const resources = {
    translation: {
        DASHBOARD: {
            LOCATION_CARD: {
                HEADER: {
                    SUBTITLE: {
                        NO_DATA: "0",
                        ALARM: "{{count}} Alarm",
                        ALARM_plural: "{{count}} Alarms",
                        ALARM_noData: "0 Alarms",
                        NORMAL: "Normal",
                    },
                    INFO: {
                        SEPARATOR: ", ",
                        DEVICE: "{{count}} Device",
                        DEVICE_plural: "{{count}} Devices",
                        SITE: "{{count}} Site",
                        SITE_plural: "{{count}} Sites",
                        DEVICE_noData: "0 Devices",
                        SITE_noData: "0 Sites",
                    },
                },
                BODY: {
                    ALARMS: "{{count}} Alarm",
                    ALARMS_plural: "{{count}} Alarms",
                    EVENTS: "{{count}} Event",
                    EVENTS_plural: "{{count}} Events",
                    ALARMS_noData: "0 Alarms",
                    EVENTS_noData: "0 Events",
                },
                FOOTER: {
                    VIEW_LOCATION: "View Location",
                },
            },
            SITE_CARD: {
                HEADER: {
                    SUBTITLE: {
                        NO_DATA: "--",
                    },
                    INFO: {
                        DEVICE: "{{count}} Device",
                        DEVICE_plural: "{{count}} Devices",
                        DEVICE_noData: "0 Devices",
                    },
                },
                BODY: {
                    ONLINE_noData: "--'",
                    ALARMS: "{{count}} Alarm",
                    ALARMS_plural: "{{count}} Alarms",
                    EVENTS: "{{count}} Event",
                    EVENTS_plural: "{{count}} Events",
                    ALARMS_noData: "0 Alarms",
                    EVENTS_noData: "0 Events",
                    OFFLINE: "Offline",
                    ONLINE: "Online",
                },
                FOOTER: {
                    VIEW_LOCATION: "View Site",
                },
            },
            TIMELINE_DETAILS: {
                ACKNOWLEDGED: "ACKNOWLEDGED",
                OPEN: "ACTIVE",
                CLOSED: "CLOSED",
                EARLIER: "Earlier",
                FUTURE: "Future",
                INACTIVE: "INACTIVE",
                LAST_WEEK: "Last Week",
                THIS_WEEK: "This Week",
                TIMELINE: "Timeline",
                TODAY: "Today",
                UNACKNOWLEDGED: "UNACKNOWLEDGED",
                YESTERDAY: "Yesterday",
            },
            ADD_BUILDING: "Add Building to ",
            AUTO_REDIRECT_BANNER: {
                ADD_LOCATION_BUTTON: "Add Location",
                DISMISS: "Dismiss",
                MESSAGE:
                    "You've been automatically redirected to {{location}} since you have no other Top-level Locations.",
            },
            USERS_ADMIN: "Admin",
            USERS_ADMIN_S: "Admins",
            ADMINS_TITLE: "Admins",
            SITE_DETAILS: {
                READING_CARDS: {
                    ALARM: "Alarm",
                    BATTERY: "Battery",
                    FULL: "Full",
                    OFFLINE: "Offline",
                    ONLINE: "Online",
                    PENDING: "Pending",
                    UNKNOWN: "Unknown",
                    VIEW_ALL: "View All",
                },
                ALL_DETAILS: "All Details",
                ALL_DEVICES: "All Devices",
                TRENDS_CARD: {
                    CHANNELS: "Channels",
                    DAY: "Day",
                    DAYS: "Days",
                    TITLE: "Trends",
                    TRENDVIEWER: "Trendviewer",
                    VIEW_ALL: "View Full Trendviewer",
                },
                DEVICES_CARD: {
                    TITLE: "Devices",
                    VIEW_ALL: "View All Devices",
                },
                TIMELINE_CARD: {
                    TITLE: "Timeline",
                    VIEW_ALL_EVENTS: "View All Events",
                },
            },
            ALL_BUILDINGS_COUNT: "All Buildings ({{count}})",
            ALL_LOCATIONS: "All Locations",
            ALL_ORGANIZATION: "All Organizations",
            ALL_DEVICES_COUNT: "All Systems ({{count}})",
            ADMINS_AND: "and",
            DASHBOARD_ASSETS_TITLE: "Assets",
            STATUS_BLOCKED: "Blocked",
            STATUS_COUNT_BLOCKED: "BLOCKED ({{count}})",
            BUILDING_CONTACT: "Building Contact",
            BUILDING_CONTACT_DETAILS_LABEL: "Building Contact Details",
            CHOOSE_LOCATION: "Choose Location",
            CONTACT_MANAGER: "Contact your account manager or ",
            ADD_ORGANIZATION: "Create Organization",
            OVERVIEW_TITLE: "Dashboard",
            DASHBOARD_TITLE: "Dashboard",
            DEVICES_TITLE: "Devices",
            EARLIER: "Earlier",
            EDIT_CONTACT_BUTTON: "Edit Contact Details",
            BUILDING_DETAIL_EMAIL: "Email",
            STATUS_EMPTY: "Empty",
            STATUS_COUNT_EMPTY: "Empty ({{count}})",
            ERROR_LOADING_CHANNELS: "Error Loading Channels",
            ERROR_LOADING_DATA: "Error Loading Data",
            ERROR_LOADING_DEVICES: "Error Loading Devices",
            ERROR_LOADING_EVENT: "Error Loading Event",
            ERROR_LOADING_EVENTS: "Error Loading Events",
            ERROR_LOADING_LOCATION: "Error Loading Location",
            ERROR_LOADING_LOCATIONS: "Error Loading Locations",
            ERROR_LOADING_ORGANIZATION: "Error Loading Organization",
            ERROR_LOADING_SITE: "Error Loading Site",
            ERROR_LOADING_SITES: "Error Loading Sites",
            ERROR_LOADING_TRENDS: "Error Loading Trends",
            EVENT_NOT_FOUND: "Event Not Found",
            STATUS_ANOMALY: "In Anomaly",
            STATUS_COUNT_ANOMALY: "In Anomaly ({{count}})",
            LAST_90_DAYS: "Last 90 Days",
            LATEST_LOGS: "Latest Logs",
            LOCATION_NOT_FOUND: "Location Not Found",
            LOCATIONS_TITLE: "Locations",
            LOCATION: "locations",
            DASHBOARD_LOGBOOK_TITLE: "Logbook",
            MAIN_CONTACT_LABEL: "Main Building Contact",
            ADMINS_MORE: "more",
            DASHBOARD_MANAGE_ORGANIZATION_TITLE: "My Organizations",
            NO_FOUND: "No {{entity}} found",
            NO_EVENTS: "No Alarms",
            NO_CHANNELS: "No Channels",
            NO_CHANNELS_ENABLED: "No Channels Enabled",
            NO_DATA: "No Data",
            NO_DATA_POINTS: "No Data for Date Range Specified",
            NO_DEVICES: "No Devices",
            NO_LOCATION_SELECTED: "No Location Selected",
            NO_LOCATIONS: "No Locations",
            NO_ORGANIZATION_SELECTED: "No Organization Selected",
            NO_SITES: "No Sites",
            NO_TRENDS: "No Trends",
            NO_USER_DATA: "No User Data",
            STATUS_COUNT_OFFLINE: "OFFLINE ({{count}})",
            ORGANIZATION_TITLE: "ORGANIZATION",
            ORGANIZATION_NOT_FOUND: "Organization Not Found",
            ORGANIZATION: {
                ORGANIZATION: "organizations",
            },
            BUILDING_DETAIL_PHONE: "Phone",
            PLATFORM_USER_DASHBOARD_WARNING:
                "Please access the web application to explore all its features",
            PROJECT: "PROJECT",
            STATUS_READY: "Ready",
            STATUS_COUNT_READY: "READY ({{count}})",
            DASHBOARD_REPORTS_TITLE: "Reports",
            SAVE_USER_DETAILS: "Save User Details",
            SECONDARY_CONTACT_LABEL: "Secondary Building Contact",
            SITE_NOT_FOUND: "Site Not Found",
            SITE: "sites",
            TIMELINE_TITLE: "Timeline",
            NEW_SITE: "to join or create new {{entity}}.",
            UNKNOWN_DEVICE_TYPE: "Unknown",
            EDIT_USER_DETAILS: "User Details",
            USERS_TITLE: "Users",
            VIEW_LOGBOOK: "View Logbook",
            USERS_VIEWER: "Viewer",
            USERS_VIEWER_S: "Viewers",
            NOT_ACCESS: "You don’t have access to any {{entity}} yet.",
            STARRED_ORGANIZATIONS: "Show Starred Organizations Only",
            ALL_CUSTOMER: "All Customers",
            SERVICE_LEVEL_AGREEMENT: "# of Service Level Agreement",
            ON_GOING_ALERTS: "On Going Alerts",
            UPCOMING_IN_DAYS: "Upcoming in 30 days",
            CUSTOMER_TITLE: "Customer",
            ADD_CUSTOMER: "Add Customer",
        },
        EVENT_DETAILS: {
            UNKNOWN: "--",
            ACKNOWLEDGE: "Acknowledge",
            ACKNOWLEDGED: "Acknowledged",
            ACKNOWLEDGE_BY: "Acknowledged by {{user}} at ",
            ACKNOWLWEGED_ERROR:
                "Acknowledgment failed to communicate to end device at {{errorDate}}. If this problem continues, please call our support team at {{phoneno}} or email ",
            DEVICE_MODEL: "Device Model",
            DEVICE_SERIAL: "Device Serial",
            ERROR_LOADING_DEVICE_DETAILS: "Error Loading Device Details",
            ERROR_LOADING_EVENT_DETAILS: "Error Loading Event Details",
            TITLE: "Event Details",
            ALARM_STATUS: "Initial Alarm Status",
            LAST_DATA_RECEIVED: "Last Alarm Update Received",
            NO_DEVICE_DETAILS: "No Device Details",
            NO_EVENT_DETAILS: "No Event Details",
            PLEASE_RETRY: "Please retry: ",
            SENDING: "Sending…",
            SET_POINT: "Setpoint (Threshold)",
            THRESHOLD: "Threshold",
            TIME_ALARM_SENT: "Time Initial Alarm Sent",
            EMPTY_VALUE: "",
        },
        DEVICE_DETAILS: {
            RADIO: 'Radio',
            RADIO_FIRMWARE_VERSION: 'Radio Firmware Version',
            EPAS_NUMBER: 'EPAS Number',
            EMPTY_VALUE: "--'",
            USERS_ADMINS: " admin",
            USERS_VIEWER: " viewer",
            FIRMWARE_AVAILABLE_GUIDE_LINK: "(Guide)",
            USERS_COUNTS: "{{adminCount}} admin, {{viewerCount}} viewer",
            FIRMWARE_AVAILABLE_GUIDE: "{{availableVersion}} Available",
            LUMINARY_ATSD: "ATSD #",
            CONNECTION_TYPE_BLE: "BLE",
            BLOCK: "Blocked",
            BUILDING: "Building",
            CONNECTION_TYPE_CELLULAR: "Cellular",
            LUMINARY_CIRCUIT: "Circuit",
            LUMINARY_CIRCUIT_HASH: "Circuit #",
            CITY: "City",
            CONNECTED: "Connected",
            CONNECTION_TYPE: "Connection Type",
            DATE_COMMISSIONED: "Date Commissioned",
            DEVICE_MODEL: "Device Model",
            DEVICE_SERIAL: "Device Serial",
            DURATION_TEST: "Duration Test ",
            DURATION_TEST_DURATION: "Duration Test Duration",
            RATED_DURATION: "Rated Duration",
            TEST_GROUP: "Test Group",
            ERROR: "Error",
            CHANNEL_DATA_ERROR: "Error Loading Channel Data",
            DEVICE_CONNECTION_ERROR: "Error Loading Connection Data",
            DEVICE_DETAILS_ERROR: "Error Loading Device Details",
            CONNECTION_TYPE_ETHERNET: "Ethernet",
            EVENT: "Event",
            FIRMWARE_VERSION: "Firmware Version",
            FUNCTIONAL_TEST: "Functional Test",
            DELAY_FUNCTIONAL_TEST: "Functional Test Delay",
            FUNCTIONAL_TEST_DURATION: "Functional Test Duration",
            GATEWAY_ADDRESS: "Gateway Address",
            GATEWAY_NAME: "Gateway Name",
            GATEWAY_COUNT: "Gateway of {{systemCount}} system",
            GATEWAY_COUNT_SYSTEMS: "Gateway of {{systemCount}} systems",
            HOSTNAME: "Host Name",
            LUMINARY_DETAIL_INFO: "Info",
            IPADDRESS: "IP Address",
            LAST_DATA: "Last Data",
            LUMINAIRE: "Luminaire",
            LUMINARY_ADDRESS: "Luminaire Address",
            NATIVE_LUMINAIRE: "Wireless Native",
            LUMINAIRES: "Luminaires",
            LUMINARIES_COUNTS: "Luminaires ",
            MAC_ADDRESS: "Mac Address",
            CONNECTION_TYPE_MODBUS: "Modbus",
            LUMINARY_MODEL: "Model",
            LUMINARY_MODEL_DESCRIPTION: "Model Description",
            LUMINARY_BATTERY: "Battery",
            CONNECTION_TYPE_MQTT: "MQTT",
            LUMINARY_NAME: "Name",
            NAME: "Name",
            NETWORK_DETAILS: "Network Details",
            LUMINARY_DISCRIPTION: "Next Duration Test Starts",
            NEXT_DURATION_TEST: "Next Duration Test Starts",
            NEXT_FUNCTIONAL_TEST: "Next Functional Test Starts",
            NO_CHANNEL_DATA: "No Channel Data",
            NO_DEVICE_CONNECTION: "No Device Connection Data",
            NO_DEVICE_DETAILS: "No Device Details Data",
            OFFLINE: "Offline",
            ONLINE: "Online",
            ORGANIZATION: "Organization",
            PART_NUMBER: "Part Number",
            PREVIOUS: "Prev",
            PREVIOUS_DURATION_TEST: "Previous Duration Test Started",
            PREVIOUS_FUNCTIONAL_TEST: "Previous Functional Test Started",
            READY: "Ready",
            CONNECTION_TYPE_RS485: "RS485",
            SERIAL_NUMBER: "Serial Number",
            GATEWAY_SHOW_ALL: "Show All",
            STATUS: "Status",
            LUMINARY_STATUS: "Status",
            SUBNET_MASK: "Subnet Mask",
            SYSTEM: "SYSTEM",
            SYSTEMS: "Systems",
            LUMINARY_DETAIL_TEST: "Tests",
            LUMINARY_TYPE: "Type",
            UPDATE_REQUIRED: "UPDATE REQUIRED",
            USERS: "Users",
            WARNING: "Warning",
            CONNECTION_TYPE_WIFI: "WiFi",
            CONNECTION_TYPE_WIREPASS: "Wirepas",
            UNASSIGNED: "Unassigned",
            GATEWAYS: "Gateways",
            CONNECTION_TYPE_NO_ACTIVE_CONNECTION: "No Active Connection",
            TYPE: "Type",
            SLA_NUMBER: "SLA Number",
            LUMINARY_SHORT_ADDRESS: "Address",
            LUMINARY_NUMBER_OF_NEIGHBOURS: "Number of Neighbors",
            RADIO_SIGNAL: "Radio Signal",
            ERROR_COUNT: "Error count",
            ERROR_DETAILS: "Error details",
            NEXT: "Next",
            UP_TO_DATE: "UP TO DATE",
            LUMINARY_STATUS_HEADER: "Luminaire Statuses",
            LUMINARY_LINE: "Line",
            LUMINARY_ZONE: "Zone",
            NEXT_SERVICE_DUE: "Next Service Due",
            TECHNICIAN: "Technician",
            ERROR_NO_SLA_FOUND: "No SLA found",
            ACTIVE: "Active",
            INPUT_ZONES: "Input Zones",
            DEVICES: "Devices",
            SYSTEM_REPORT: "System Report",
            ZONES: "Zones",
            ALL_ZONES: "All Zones",
            INACTIVE: "InActive",
            STATUS_FIRE: "In fire",
            ARCHIVE: "Archive",
            SORT_BY_OLDEST: "Sort by Oldest on top",
            SORT_BY_LATEST: "Sort by Latest on top",
            SHOW: "Show...",
            PERIODIC_SERVICE: "Periodic Service",
            REQUESTED_SERVICE: "Requested Service",
            UNASSIGNED_SERVICE: "Unassigned Service",
            CUSTOM: " Custom...",
            DURATION_RESULT: "Duration Result",
            READY_LUMINARY: "Ready Luminaires",
        },
        FORMS: {
            OPTIONAL: " (Optional)",
            BUILDING_COMPANY_ADDRESS: "Address Line 1",
            BUILDING_COMPANY_ADDRESS2: "Address Line 2(Optional)",
            BUILDING_DETAILS: "Building Details",
            CITY: "City",
            USER_ADDRESS_1: "Company Address Line 1",
            USER_ADDRESS_2: "Company Address Line 2",
            COMPANY_NAME: "Company Name",
            CONFIRM_PASSWORD: "Confirm Password",
            COUNTRY: "Country *",
            HELPING_TEXT: "Fields with an asterisk (*) are required",
            FIRST_NAME: "First Name",
            LAST_NAME: "Last Name",
            LOCAL_PRIMARY_EMAIL: "Local Primary Contact Email Address",
            LOCAL_PRIMARY_CONTACT_INFO: "Local Primary Contact Information ",
            LOCAL_SECONDARY_EMAIL: "Local Secondary Contact Email Address",
            LOCAL_SECONDARY_CONTACT_INFO: "Local Secondary Contact Information ",
            ORGANIZATION_ADDRESS_HEADER: "Organization Address",
            COMPANY_ADDRESS: "Organization Address Line 1",
            ADDRESS_LINE_2: "Organization Address Line 2",
            ORGANIZATION_DETAILS_HEADER: "Organization Details",
            PASSWORD: "Password",
            PASS_MATCH_ERROR: "Passwords do not match",
            PHONE_NUMBER: "Phone Number",
            INVALID_CUSTOMER_NUMBER: "Please provide valid customer number",
            INVALID_EMAIL_ERROR: "Please provide valid email address",
            INVALID_DETAILS: "Please provide valid input parameters",
            INVALID_PHONE_NUMBER: "Please provide valid phone number",
            INVALID_POSTAL_CODE: "Please provide valid postal code",
            INVALID_SLA_NUMBER:
                "Please provide valid SLA number of at least 8 characters",
            POSTAL_CODE: "Postal Code",
            PRIMARY_CONTACT_INFORMATION: "Primary Contact Information",
            RESET_PASSWORD: "Reset Password",
            TOGGLE_PASSWORD_VISIBILITY: "Toggle password visibility",
            VERIFICATION_CODE: "Verification Code",
            SLA_EXPIRATION_DATE_INVALID:
                "SLA expiration date cannot be in the past. Please provide a valid date.",
            BUILDING_ADDRESS: "Building Address",
            MINIMUM_3_CHAR_REQUIRED: "Minimum 3 characters required.",
        },
        DUALSMART: {
            DS_LUMINARIES_FOUND: " 74 Luminaries Found",
            DS_CIRCUIT_READY: " Circuit Ready",
            DS_COMMUNICATION_FAILURE: " Communication Failure",
            DS_DIMM_ERROR: " Dimm Error",
            DS_OVERCURRENT: " OverCurrent",
            DS_SAVE_UPDATE_BUTTON: " Save Update",
            DS_CONNECTED_POWER_INFO: "10W / 15VA",
            DS_SYSTEM_COMPONENTS_COUNT: "7 Components",
            DS_LUMINARIES_FOUND_TITLE: "Luminaires were found on this system.",
            DS_AE_ERROR: "Ae Error",
            DS_ALL_STATUSES: "All Statuses",
            DS_ALL_TESTS_PASSED: "All tests passed",
            DS_ESTIMED_GUIDELINE_ONE: "Approximately 10 year at 20 °C",
            DS_ESTIMED_GUIDELINE_THREE: "Approximately 5 year at 30 °C",
            DS_ESTIMED_GUIDELINE_TWO: "Approximately 7 year at 25 °C",
            DS_BATTERY_CHARGER: "Battery / Charger",
            DS_BATTERY_CHARGE: "Battery Charge",
            DS_BATTERY_OPERATION: "Battery Operation",
            DS_BLOCK_DEVICE: "Block Device",
            DS_BLOCK_DEVICE_INFO:
                "Block Device Blocks the emergency function and switches off the circuit",
            DS_BLOCK_SUCCESS: "Blocking was performed successfully",
            DS_BULB_ERROR_AC: "Bulb Error AC",
            DS_BULB_ERROR_DC: "Bulb Error DC",
            DS_CAPACITY: "Capacity",
            DS_CHARGER_LEVEL: "Charge Level:",
            DS_CHARGING_ERROR: "Charging Error",
            DS_FUNCTIONAL_GUIDELINE:
                "Choose a time between 20 - 800 seconds for the system to communicate when switching to battery operation for a test.",
            DS_CIRCUIT: "Circuit",
            DS_CIRCUIT_FAILURE: "Circuit Failure",
            DS_CIRCUITS_INFO_HEADER: "Circuit Information :",
            DS_CIRCUITS_NO: "Circuit No.",
            DS_CIRCUITS: "Circuits",
            DS_COMPONENTS_DETAIL: "Component Details",
            DS_CONNECTED_POWER: "Connected Power :",
            DS_CRYSTALWAY: "CrystalWay 20m",
            DS_DAYS_BETWEEN_THE_TEST: "Days between tests",
            DS_DC1: "DC1",
            DS_DC2: "DC2",
            DS_KEEP_DEEP_DISCHARGE: "Deep Discharge Protection Active",
            DS_DELAY_ON_MAINS_RETURN: "Delay on Mains Return",
            DS_ESTIMED_GUIDELINE:
                "Depending on the ambient temperature and site conditions:",
            DS_DESCRIPTION: "Description",
            DS_END_DURATION_TEST_POPUP: "Do you want to stop duration test?",
            DS_DOUBLE_ADDRESS: "Double Address",
            DS_DT_FORERUN: "DT Pre-Run",
            DS_DEVICE_COMMISSIONING: "Dual Smart Commissioning",
            DS_PASSWORD: "Dual Smart Password",
            DS_DURATION: "Duration",
            DS_DURATION_TEST: "Duration Test",
            DS_DURATION_TEST_SCHEDULE: "Duration Test Schedule",
            DS_EDIT_BATTERY_DETAILS: "Edit Battery Details",
            DS_DASH_EMPTY: "Empty",
            DS_ESTIMED_LIFESPAN: "Estimated Lifespan",
            DS_EXIT_SIGN: "Exit Sign",
            DS_FAN_OPERATING_HOURS: "Fan Operating Hours",
            DS_FOUND: "Found",
            DS_FT_FORERUN: "FT Pre-Run",
            DS_FUNCTIONAL: "Functional",
            DS_FUNCTIONAL_LEAD_AND_TIME: "Functional Lead Time",
            DS_FUNCTION_TEST: "Functional Test",
            DS_FUNCTIONAL_TEST_SCHEDULE: "Functional Test Schedule",
            DS_SYNC_DATE_AND_TIME_SUBTITLE: "G-North” Main Office",
            DS_CIRCUITS_DESCRIPTION: "Help me with the description",
            DS_SEARCH_LUM_INFO_TEXT:
                "If you only need to add luminaries Please use the Search for New Luminaries option ",
            DS_SEARCH_LUMS_POPUP_SUB_TITLE:
                "If you only need to add new luminaires, please use the Search For New Luminaires option.",
            DS_INSTALLATION_DATE: "Installation Date",
            DS_INTERVAL: "Interval",
            DS_CIRCUITS_INFO: "Key Needed. Restricted Area ! Registration required .",
            DS_LAST_DURATION_TEST_TIME: "Last Duration Test Time",
            DS_LIGHTANDBUILDING: "Light & Building 2024",
            DS_LUMINAIRE_FAILURE: "Luminaire Failure",
            DS_LUMINAIRE_NAME: "Luminaire Name",
            DS_LUMINARIES: "luminaries",
            DS_MAINS_OPERATION: "Mains Operation",
            DS_NORMAL_OPERATION: "Normal Operation",
            DS_OPERATION_FAILED: "Operation Failed",
            DS_OVERTEMPERATURE: "OverTemprature",
            DS_OVERVOLTAGE: "OverVoltage",
            DS_PREV: "Prev",
            DS_READY_ON: "Ready-on",
            DS_RELEASE_DEVICE: "Release Device",
            DS_RELEASE_DEVICE_INFO: "Release Device Switches back to operation.",
            DS_RELASE_SUCCESS: "Release was performed successfully",
            DS_SEARCH_LUM_WARNING_TEXT:
                "Retrieving data. Wait a few seconds and try to cut or copy again.",
            DS_CIRCUIT_LUMINARIES_DESC:
                "Retrieving data. Wait a few seconds and try to cut or copy again.",
            DS_SEARCH_COMPLETE: "Search Complete",
            DS_SEARCH_GUIDLINE_ONE_TEXT:
                "Search for all installed and addressed luminaries",
            DS_SEARCH_ALL_LUMINARIES: "Search For All Luminaries",
            DS_SEARCH_LUM_TEXT:
                "Search for All Luminaries will create a new configuration by doing the following:",
            DS_SEARCH_LUMS_POPUP_TITLE:
                "Starting the search will delete any activated luminaires with a defect from your configuration.",
            DS_SEARCH_GUIDLINE_TWO_TEXT:
                "Starting the search will delete any activated. defective luminaries from your configuration",
            DS_STARTS: "Starts",
            DS_SUMMARY_FT: "Summary of Function Test",
            DS_SYNC_DATE_AND_TIME: "Sync Test Schedule",
            DS_SYSTEM_COMPONENTS: "System Components",
            DS_SYNC_DATE_AND_TIME_TITLE: "Test Dates & Times",
            DS_TEST_INTERVAL: "Test Interval",
            DS_TEST_LENGTH: "Test Length",
            DS_VIEW_CIRCUITS: "View By Circuit",
            DS_W: "W:",
            DS_SEARCH_FOR_NEW_LUMINARIES: "Search For New Luminaries",
            DS_SEARCH_LUM_NEW_TEXT:
                "Search for New Luminaries to add to your lighting configuration :",
            DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT:
                "This will automatically assign addresses to new or replaced luminaries to your lighting configuration.",
            DS_SEARCH_NEW_LUM_INFO_TEXT:
                "If you only need to add luminaries Please use the Search for New Luminaries option",
            DS_NEW: "New",
            DS_MODULE_TYPE: "Module Type",
            DS_SEARCH_IO_MODULES: "Search I-Bus modules",
            DS_SEARCH_FOR_IO_MODULES: "Search for IO Modules",
            DS_SEARCH_IO_MODULES_TEXT:
                "Search for IO Modules create a new configuration by doing the following:",
            DS_SEARCH_GUIDELINE_IO_MODULES_TEXT:
                "Search for all installed modules on the bus in order to configure and program them.",
            DS_SEARCH_IO_MODULES_BTN_TEXT: "Search For IO Modules",
            DS_SEARCH_IO_MODULES_POPUP_TITLE:
                "If modules are not connected properly it will permanently alter your applied configuration.",
            DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE:
                "Please ensure all connections are correct prior to starting the search.",
            DS_PHYSICAL_MODULES: "Physical Modules",
            DS_SUBSCRIBED_MODULES: "Subscribed",
            DS_MODULES_FOUND: "Modules Found",
            DS_MODULE_NUMBER: "Module No.",
            DS_SEARCHING: "Searching...",
            DS_TIMER: "Timer",
            DS_SET_TIMER: "Set Timer",
            DS_SUBMIT_CHANGES: "Submit Changes",
            DS_TIMER_1: "Timer 1",
            DS_TIMER_2: "Timer 2",
            DS_TIME_TITLE: "Timer Title (Optional)",
            DS_DAYS: "Days of the Week & Time",
            DS_ACTIVE_DAYS: "Select days of the week you want ___ to be active.",
            DS_START_TIME: "Start Time",
            DS_END_TIME: "End Time",
            DS_SET_RELAY_BUZZER: "Set Relay Buzzer",
            DS_RESET_TO_DEFAULT_VALUES: "Reset To Default Values",
            DS_RESET_TO_DEFAULT_VALUES_INFO:
                "Select the output to assign its functions. Tap “Save” when finished.",
            DS_SEARCH_NEW_LUMINARIES_INFO:
                "Use these results to create and share a new lighting configuration by using “Export.”",
            DS_RELAY_NO: "Relay No.",
            DS_RESET_RELAY_BUZZER_POPUP_TITLE: "Please Confirm",
            DS_RESET_RELAY_ONE_TO_DEFAULT: "Reset Relay 1 to Default",
            DS_RESET_RELAY_BUZZER_TO_DEFAULT: "Reset Relays & Buzzer to Default",
            DS_UNSAVED_CHANGES_POPUP_TITLE: "There are Unsaved Changes",
            DS_UNSAVED_CHANGES_POPUP_SUB_TITLE:
                "You did not save your changes to Relay 1. Would you like to save?",
            DS_DISCARED_CHANGES: "Discard Changes",
            DS_CIRCUIT_TITLE:
                "Luminaires that are toggled on / off on this window will revert to their configured state after the system completes its next switching operation.",
            DS_EMPTY: "Empty / In failure",
            LUM_TITLE: "Tap luminaires to turn them on and off",
            ALL_OFF: "All off",
            DS_RESET_TITLE: "Reset to Default",
            DS_CONTROL_LUM: "Control Luminaires",
            DS_LUM_BUTTON: "Turn Luminaires On / Off",
            DS_APPLY: "Apply",
            DS_SET_IO_BUS_MODULES_TITLE: "Set I-Bus modules",
            DS_NEXT_MODULE: "Save and Move to Next Module",
            DS_MODULE_DETAILS: "Module Details",
            DS_MODULE_NAME: "Module Name",
            DS_LOCAL_ONLY: "Local Only",
            DS_PUBLISH: "Publish",
            DS_SUBSCRIBE: "Subscribe",
            DS_ACU_BUS_ID: "ACU Bus ID",
            DS_BUS_MODULE: "Bus Module",
            DS_INPUTS: "Inputs",
            DS_CONFIGURED_MODULE_TITLE:
                "No phase monitoring inputs are currently configured on this module.",
            DS_CONFIGURE_INPUTS: "Configure Inputs",
            DS_BLOCK: "Block",
            DS_RELEASE: "Release",
            DS_BLOCK_GUIDLINE:
                "This blocks the emergency function and switches the circuits off.",
            DS_RUN_TESTS: "Run Tests",
            DS_LUMINARIE_CONTROLS: "Luminaire Controls",
            DS_LUMINARIE_CONTROLS_GUIDELINE:
                "These functions allow you override the luminaire’s  configured programming until they are toggled off.",
            DS_ALL_LUMINARIES_ON: "All Luminaires On",
            DS_INACTIVE: "Inactive",
            DS_MAINTAINED_LUMINARIES_OFF: "Maintained Luminaires Off",
            DS_NON_MAINTAINED_LUMINARIES_OFF: "Non-Maintained Luminaires On",
            DS_RESET_SYSTEM_STATE: "Reset System State",
            DS_MANUAL_RESET: "Manual Reset",
            DS_RESET_ISO_FAILURE: "Reset ISO Failure",
            DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: "Reset Deep Discharge Protection",
            DS_SIMULATE_MAINS_FAILURE: "Simulate Mains Failure",
            DS_SEARCH_ISO_FAILURE: "Search ISO Failure",
            DS_SET_I_BUS_MODULES: "Set I-Bus modules",
            DS_COMMISSIONING: "Commissioning",
            DS_DATE_AND_TIME: "Date & Time",
            DS_RESET_SERVICE_CENTER: "Reset Service Counter",
            DS_ALERT_LEVEL: "Alert Level",
            DS_DRY_CONTACT: "Dry Contact",
            DS_BUILDING_MANAGMENT_SYSTEM: "Building Management System (BMS)",
            DS_MODBUS: "Modbus",
            MANAGE_INTERNET_CONNECTION: "Manage Internet Connection",
            INTERNET_CONNECTION: "Internet Connection",
            SYSTEM_LOCATION: "System Location",
            SUB_LOCATION: "Sub Location",
            TIME_PERIOD_NINTY_DAYS: "Every 90 Days",
            DS_SEARCH_ISO_FAILURE_TITLE: "Search for Isolation Failures ?",
            DS_SEARCH_ISO_FAILURE_BODY:
                "Please press “Search”  to determine affected circuits if you are receiving an ISO Failure message.",
            DS_SEARCH: "Search",
            DS_MAIN_FAILURE_MSG:
                "This will simulate DC operation and last for approximately 5 seconds before switching back to normal operation.",
            DS_START: "Start",
            DS_DEEP_DISCHARGE: "Deep Discharge Protection Acknowledgement",
            DS_DEEP_DISCHARGE_MSG:
                "By selecting “Acknowledge” you are verifying that you witnessed the system’s batteries go into a state of deep discharge",
            DS_ACKNOWLEDGE: "Acknowledge",
            DS_RESET_ISO: "Reset Isolation Failure?",
            DS_RESET_ISO_MSG:
                "This will reset the isolation failure message.\n\nIf the ISO error reoccurs and no cause can be identified after checking the final circuits, please contact the service department",
            DS_RESET: "Reset",
            DS_MANUAL_RESET_TITLE: "Perform Manual Reset?",
            DS_MANUAL_RESET_MSG:
                "All safety luminaires will switch back to normal operation based on their programming",
            DS_BLOCK_TITLE: "Block the system and end the duration test?",
            DS_CONFIRM_BLOCK: "Confirm & Block",
            DS_BLOCK_TEXT:
                "The battery will need at least 24 hours to recharge before performing another duration test.",
            TRIGGERS: "Triggers",
            DEFAULT_TRIGGERS: "Default Triggers",
            OPTIONAL_TRIGGERS: "Optional Triggers",
            EMPTY_TRIGGERS_LINE: "No optional triggers have been configured.",
            ADD_TRIGGER: "Add Trigger",
            SELECT_TRIGGERS: "Select Triggers",
            ASSIGN: "Assign",
            ASSIGN_TRIGGERS: "Assign Triggers",
            SELECTED: "Selected",
            INSTALLED: "Installed",
            SCENARIO: "Scenario",
            MAINTAINED_MODE: "Maintained Mode",
            NON_MAINTAINED_MODE: "Non-Maintained Mode",
            LUMINARIES_COUNT: "10 of 10 Luminaires",
            DS_INPUT_OF_PHASE_MONITOR: "Input of a Phase Monitor",
            DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE:
                "Circuit No.1 Triggers were successfully configured.",
            DS_SET_OTHER_CIRCUIT_TRIGGERS: "Set Other Circuit Triggers",
            DS_ASSIGN_TRIGGERS_GUIDELINE_TWO:
                "Please Confirm Each Trigger for Circuit 1.",
            DS_NON_MAINTAINED_LIGHT: "Non-Maintained Light",
            DS_MAINTAINED_LIGHT: "Maintained Light",
            DS_INSTALLED_LUMINARIES: "Installed Luminaires",
            DS_TIMER_SCHEDULE: "Weekday Schedule",
            DS_DEEP_DISCHARGE_TITLE: "Deep Discharge",
            DS_STIMULATE_MAIN_FAILURE: "Stimulate Main Failure",
            DS_START_FUNCTIONAL_TEST: "Start Functional Test",
            DS_SHORT_LEAD_TIME: "Use Short Lead Time",
            DS_ASSIGNED_PHASE_MONITORING_INPUT: "Assigned Phase Monitoring Inputs",
            DS_INPUT_CONFIGURATION_TITLE: "Input Configuration",
            DS_ASSIGNED_FUNCTION: "Assigned Function",
            DS_PHASE_MONITORING_INPUT: "Phase Monitoring Inputs L1/L2/L3",
            DS_RESET_OPTION: "Reset Option",
            DS_LENGTH_OF_TIME: "Length Of Time",
            DS_PHASE_MONITOR: ": Phase Monitor",
            DS_ENTRY_MESSAGE: "Please enter your credentials",
            DS_NO_OPERATION_POSSIBLE: "No Operation possible",
            DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE:
                "Tap or drag over luminaires to assign them to this trigger.",
        },
        LOGBOOK_DETAILS: {
            LABEL_EVENT_AGO: " ago",
            SITE_CONTACTS: "Site Contacts",
            PART_NUMBER: " PN: ",
            SERIAL_NUMBER: " SN: ",
            ADD_COMMENTS: "+ Add Comments...",
            REQUIRES_FIRMWARE_UPDATE: "1 REQUIRES FIRMWARE UPDATE",
            ACKNOWLEDGE: "Acknowledge",
            ACKNOWLEDGED: "Acknowledged",
            ACKNOWLEDGED_BY: "Acknowledged by",
            PREVIOUS_ACKNOWLEDGED_BY: "Acknowledged by: ",
            ACTIVE: "Active",
            ACTIVE_ACKNOWLEDGED: "Active . Acknowledged",
            AT: "at",
            LABEL_CLOSED: "closed",
            CLOSED: "Closed",
            COMMENTS: "Comments",
            DESCRIPTION: "Description",
            DEVICE: "Device",
            EDIT: "Edit",
            EVENT: "Event",
            LABEL_EVENT_BEGAN: "Event Began: ",
            LABEL_EVENT_CLOSE: "Event Closed: ",
            LOGBOOKDETAIL: "LogBookDetail",
            NO_PREVIOUS_LOG_TITLE: "No Previous Log Item on this System",
            PARTNO: "PN: ",
            PREVIOUS_LOG_ITEM: "Previous Log Item on This System",
            PREVIOUS_LOG_TITLE: "Previous Log Item on this System",
            SERIALNO: "SN: ",
            STATUS: "Status",
            SYSTEM: "System",
            TIMESTAMP: "Timestamp",
            SYSTEM_TYPE: "Type: ",
            NO_PREVIOUS_LOG: "No Previous Log",
        },
        ORGANIZATION_MANAGE: {
            SEARCH: "Search",
            BUILDING_COUNT: " Building",
            BUILDING_COUNT_S: " Buildings",
            ORGANIZATION_MANAGE: " Buildings",
            ADMIN_COUNT: " Organization Admin",
            ADMIN_COUNT_S: " Organization Admins",
            VIEWER_COUNT: " Organization Viewer",
            VIEWER_COUNT_S: " Organization Viewers",
            SYSTEM_COUNT: " System",
            SYSTEM_COUNT_S: " Systems",
            ADD_NEW_BUILDING: "+ Add New Building",
            CREATE_ORGANIZATION: "+ Create Organization",
            ERROR_ADD_NEW_SYSTEM_ACTION: "Add New Systems",
            ALL: "All",
            SORT_TYPE_NAME: "Alphabet",
            SORT_TYPE_CITY: "City",
            COMMENTS_HELPER: "Comments to help technicians arrive on site.",
            ORGANIZATION_NAME_HELPER: "Letters, numbers, underscores and dashes only",
            MARK_AS_FAV_API_FAILURE_MESSAGE: "Mark as failed",
            ERROR_NO_BUILDING_FOUND: "No building found",
            ERROR_NO_GATEWAY_FOUND: "No gateway found",
            ERROR_NO_LOGS_TITLE: "No logs during this period",
            ERROR_NO_LUMINARY_FOUND: "No Luminaries found",
            ERROR_NO_ORG_FOUND: "No organization found",
            ERROR_NO_REPORT_FOUND: "No reports found",
            ERROR_NO_SYSTEM_FOUND: "No system found",
            ERROR_NO_USER_FOUND: "No user found",
            SORT_TYPE_NUMBER_OF_SYSTEMS: "Number of Systems",
            QUIT_EDIT_USER_DETAILS: "Quit editing",
            QUIT_TITLE: "Quit editing “{{orgName}}”?",
            ERROR_READ_INSTALLATION_MANUALS_ACTION: "Read Installation Manuals",
            SEARCH_BUILDINGS_DASHBOARD: "Search buildings",
            SEARCH_SYSTEM_DASHBOARD: "Search systems",
            SORT_BY_HEADER: "SORT BY",
            STARRED_ORGANIZATIONS: "Starred Organizations",
            VIEW_ORGANIZATION: "View Organization",
            ERROR_NO_DEVICE_TITLE: "You have no assets in this organization yet.",
            ERROR_NO_DEVICE_DESCRIPTION:
                "You will see status information about your emergency lights once you start adding assets (systems) to this organization.",
            QUIT_MESSAGE: "Your unsaved changes would be lost.",
            SEARCH_BUILDINGS: "Search...",
        },
        ADD_BUILDING: {
            BLDG_ORG_CONTACT: " contacts",
            INVERTED_COMMAS_S: "s",
            BLDG_ADDITIONAL_DESC:
                "Add optional addtional comments to aid your service team",
            BLDG_ADD_DESCRIPTION: "Additional Descriptions",
            BLDG_ADDRESS: "address",
            BLDG_CREATTION: "Building Created",
            BUILD_CREATE_SUCESS: "Building created successfully",
            BLDG_HEADER: "Create a New Building for ",
            BLDG_LOCATION_MESSAGE:
                "Drag the map to place the pin near where the building is located at. This helps field engineers arrive on site quickly in the future.",
            BLDG_EDIT_BTN: "Edit Contact Details",
            BLDG_NAMELENGTH: "Ex., Main Office, Warehouse 	  	 	  	  	  	",
            BLDG_INITILIZING_NETWORK: "Initializing Network...",
            BLDG_INSIDE: "inside",
            BLDG_LOCAL_CONTACT: "Local Building Contact",
            BLDG_CONTACT_TITLE: "Local Building Contact Details",
            BLDG_LOCATE_ON_MAP: "Locate on a Map instead",
            BLDG_LOCATION: "Location",
            BLDG_ADDTIONAL_DETAILS:
                "Now let’s add some additional details to complete the setup for",
            ORG_CREATE_SUCESS: "Organization created successfully",
            BLDG_ADDITION_ERROR: "Please enter valid address.",
            BLDG_PRIMARYCONTACT: "Primary Contact",
            BLDG_PRIMARY_LOCAL_CONTACT: "Primary Local Contact",
            BLDG_SECONDARYCONTACT: "Secondary Contact (Optional)",
            BLDG_SECONDARY_LOCAL_CONTACT: "Secondary Local Contact",
            BLDG_NO_POSTAL_ADDRESS:
                "Select this option if a postal address is not available",
            BLDG_CREATED_MESSAGE: "Successfully Created",
            BLDG_ORGANIZATION_FOR: "Use organization ",
            BLDG_ADD_CONTACT: "Who shall electricians reach out about Main Office",
            SAVE_CHANGES_MSG: "Your changes have been saved",
            BLDG_ORG_CONTACTS: "Contacts",
            ADD_BUILDING_INTERNET_CONNECTION:
                "Not able add building. Please connect to internet and try again",
        },
        USER_SETTINGS: {
            AUTOMATIC_LOGOUT_SUBTITLE:
                " Disable the automatic session expiration of 15 minutes",
            ALARMS:
                "FT failed, DT failed, Disconnected, Battery failure, Lamp failure, ATSD failure",
            PHONE_NO_TEXT:
                "A mobile number is required in order to receive sms notifications",
            ACCOUNT: "Account",
            ACCOUNT_CREATED_DATE: "Account Created",
            ADDRESS: "Address",
            ALARMS_TITLE: "Critical Alarms only",
            APPLICATION_THEME_COLOR: "Application Theme Color",
            AUTOMATIC_LOGOUT: "Automatic Log Out",
            UNITS_DESCRIPTION: "British Imperial Units",
            BUILDING_NAME: "Building Name",
            TIMEZONE_DESCRIPTION: "Central European Time (GMT-1:00)",
            CHANGE_PASSWORD: "Change Password",
            COMPANY_ADDRESS: "Company Address",
            COMPANY_NAME: "Company Name",
            COMPANY_PHONE_NUMBER: "Company Phone Number",
            DATE_FORMAT: "Date Format",
            DATEFORMAT_DESCRIPTION: "DD/MM/YYYY",
            DELETE_ACCOUNT: "Delete Account",
            STATUS_UPDATES:
                "Device is in blocking mode, emergency mode, maintenance requested",
            AUTOMATIC_LOGOUT_TITLE: "Disable automatic log out",
            EMAIL: "Email Address",
            EMAIL_NOTIFICATION: "Email Notifications",
            TEXT_NOTIFICATION_TITLE: "Enable Text Notifications (SMS)",
            ENABLED: "Enabled",
            TEXT_NOTIFICATION_BODY:
                "Enabling SMS notifications may incur additional text messaging fees with your cellular service provider. These fees are not included in the Eaton Service Agreement.",
            LANGUAGE_DESCRIPTION: "English - Great Britain",
            HEALTH_REPORT_TITLE: "Health Report",
            LANGUAGE: "Language",
            HEALTH_REPORT: "Monthly reporting",
            PRODUCT_UPDATES: "New releases, firmware update available",
            NOTIFICATIONS_HEADER: "Notifications",
            APP_THEME_DESCRIPTION: "Operating System Theme",
            ORGANIZATION: "Organization",
            ORGANIZATION_NAME: "Organization Name",
            PASSWORD: "Password",
            PHONE_NUMBER: "Phone Number",
            PREFERENCES_HEADER: "Preferences",
            PRODUCT_UPDATES_TITLE: "Product Updates",
            STATUS_UPDATES_TITLE: "Status Updates",
            TEXT_NOTIFICATION: "Text Notifications (SMS)",
            AUTOMATIC_LOGOUT_BODY:
                "This will override a standard security feature included in the application to prevent access to an abandoned session. Please be aware that user will be responsible for protecting the unauthorized access to this system and should never leave this application open when unattended.",
            TIME_ZONE: "Time Zone",
            UNITS: "Units",
            ORG_ADDRESS: "Use Organization’s Address",
            ORG_CONTACT_DETAILS: "Use Organization’s Contact Details",
            EDIT_USER_DETAILS: "User Details",
            NAME: "User Name",
            USER_NAME: "User Name",
            WARNING: "WARNING",
            WARNING_TITLE: "Warnings",
            WARNING_SUBTITLE: "Firmware updates, life cycle management reminders",
        },
        EDITUSER: {
            PROMOTE_CONFIRMATION: " If this was intended, please submit your change.",
            DEMOTE_CONFIRMATION:
                "If this was intended, please make modifications below in the Role/Location section of this form.",
            DEMOTE:
                "You have changed this Org Admin's role. If you did not mean to do this - select cancel.",
            PROMOTE:
                "You have promoted this User to an Org Admin. If you did not mean to do this - select cancel.",
        },
        ADDUSER: {
            INVITEUSER: " Invite User",
            TITLE: "Add User",
            ASTERIKSINFO:
                "Fields marked with asterisk(*) are requried fields necessary to invite a user.",
            INVITESUCCESS: "Invitation Successful!",
            SELECTROLE: "Select a Role for Location(s)",
            ACCOUNTCREATED:
                "The invitation to create an account has been successfully initiated.",
            EMAILRECEIVE:
                "The user will receive an email invite to create their account in 5-10 minutes. You will not be able to see their status until they have accepted the invite.",
            ADDUSERINFORMATION: "User's Account Profile Information",
        },
        GATEWAY: {
            MANAGE_CELLULAR_CONNECTION: " Manage Cellular Connection",
            TRANSFER_SYSTEM: {
                TRANSFER_SYSTEM_SELECTION_PAGE_TITLE:
                    "{{gatewayName}} Gateway Systems ({{systemCount}})",
                TRANSFER_SYSTEM_USERCONFIRMATION_TITLE:
                    "{{gatewayName}} systems will transferred to the following users:",
                ADD_ANOTHER_USER: "Add Another user",
                ADMIN_RIGHT_REQUIRED: "Admin rights required to invite user",
                REGISTER_USER_REQUIRED:
                    "At least one registered user required for transfer",
                EMAIL_ID_DUPLICATE: "EmailId is duplicate or not valid input",
                ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER:
                    "Admin rights required to transfer user entities",
                DUPLICATE_ENTITY_ID: "EntityId is duplicate or not valid input",
                TRANSFER_SYSTEM_EXISTING_USER: "Existing Users",
                INVALID_ENTITY_TYPE:
                    "Invalid entity type. Please provide valid entity type",
                TRANSFER_SYSTEM_LOGED_IN_USER_MSG:
                    "Invalid User, Please add another user.",
                INVITE_AS_COLLEAGUE: "Invite as colleague",
                TRANSFER_SYSTEM_NEW_USER: "New Users",
                TRANSFER_SYSTEM_ADD_EXISTING_USER:
                    "Please add at least one existing user to transfer entities.",
                INVALID_EMAIL_ADDRESS: "Please provide valid email address",
                INVALID_GATEWAY_ID: "Please provide valid gateway id",
                TRANSFER_SYSTEM_INFO: "Please select an existing user or add a new one.",
                TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER:
                    "Please select the system(s) you wish to transfer.",
                NO_DATA_FOUND: "Requested data not found",
                TRANSFER_SYSTEM_SYSTEM_TRANSFER: "System Transfer",
                TRANSFER_SYSTEM_CONFIRMATION_NEW_USER:
                    "This user cannot monitor systems until they accept an invitation at the email provided.",
                TRANSFER_SYSTEM_PRIVILEGES: "Transfer System Privileges",
                TRANSFER_TO: "Transfer to",
                TRANSFER_USER_ALREADY_ADDED: "User Already added",
                TRANSFER_SYSTEM_ALREADY_ADDED_USER:
                    "User already added in the list. Please add another user.",
                TRANSFER_SYSTEM_USER_SELECTION_HEADER:
                    "Who do you want to transfer these systems to?",
                ADD_USERS: "Add Users",
            },
            ENTRY_PASSWORD_TITLE: "Accessing for",
            ADD_GATEWAYS: "Add Device",
            ADDING_GATEWAY_TITLE: "Adding {{gatewayName}} to {{orgName}}",
            CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG:
                "Gateway trying to connect to system and can take more time, review the status on System Tab",
            RESET_GATEWAY_PASSWORD_SUCCESS: "Gateway password reset successfully.",
            BLE: {
                ERROR: {
                    INVALID_IP_AADRESS: "Invalid IP address",
                    CHANGE_FAILURE_MESSAGE: "An error occured while changing parameters",
                    NOT_FETCHING_SYSTEM_DETAILS: "Not able to fetch system details",
                    BUILDING_ALREADY_EXISTS: "Building name already exists",
                    RESET_PASSWORD_FAILED:
                        "Reset password request failed. Please try again",
                    INVALID_CONNECTION_STRING: "Invalid connection string",
                    INVALID_UUID: "Invalid UUID",
                    ORGANIZATION_ALREADY_EXISTS: "Organization name already exists",
                    REQUEST_FAILED_TITLE: "Request Failed",
                    REQUEST_FAILED_GATEWAY_ADD: "Request Failed to add gateway.",
                    REQUEST_FAILED_MESSAGE:
                        "The operation could not be completed. Please wait a few minutes and try again.",
                    UNAUTHORIZED_ACCESS: "Unauthorized access Please login again",
                    INVALID_DEVICE: "Invalid Device",
                    GATEWAY_UNRECHABLE: "System Unreachable",
                    REQUEST_FAILED_WIRELESS_GATEWAY_ADD:
                        "Request Failed add wireless gateway.",
                    REQUEST_FAILED_LP_SMART_ADD: "Request Failed to add Dualsmart.",
                    DUPLICATE_SYSTEM_TITLE: "Duplicate system",
                },
                DEVICE_STATUS: {
                    ALARM: "Alarm",
                    BLOCKED: "Blocked",
                    NOT_PROVISIONED: "Not Provisioned",
                    OFFLINE: "Offline",
                    ONLINE: "Online",
                    PROVISIONED: "Provisioned",
                    READY: "Ready",
                    READY_FOR_COMMISSION: "Ready For Commissioning",
                    WARNING: "Warning",
                },
                DEVICE_TYPE: {
                    ATPLUS_CONTROLLER: "AT+ Controller",
                    COMMON_GATEWAY: "Common Gateway",
                    DGS: "DGS",
                    LPSMART: "LPSmart",
                    WIRELESS_GATEWAY: "Wireless Gateway",
                },
                SET_PASSWORD_STATUS: {
                    INVALID_LENGTH: "Invalid length",
                    INVALID_PASSWORD: "Invalid password",
                    PASSWORD_CHANGE_FAILURE: "Password change failure",
                    PASSWORD_CHANGE_SUCCESS: "Password change success",
                    PASSWORD_COMPARISON_FAIL: "Password comparison fail",
                },
                DEFAULT_LOGIN_STATUS: {
                    LOGIN_DEFAULT_SUCCESS: "Login default success",
                    LOGIN_FAILURE: "Login failure",
                    LOGIN_MAX_ATTEMPTS_EXCEEDED: "Login max attempts exceeded",
                    LOGIN_SUCCESS_ADMIN: "Login success admin",
                    LOGIN_SUCCESS_SERVICE: "Login success service",
                    LOGIN_SUCCESS_USER: "Login success user",
                    LOGOUT: "Logout",
                },
                NULL_VALUE: "No response",
                TURN_ON_BLE_MSG:
                    "Turn on Bluetooth to allow Building Safety Manager to access local systems.",
                DISCONNECT_ALERT_SUBTITILE:
                    "You are no longer connected to the {{gatewayName}} Bluetooth. Please make sure you are within range of the Bluetooth to continue.",
                SUCCESS: {
                    REQUEST_SUCCESS_GATEWAY_ADD: "Gateway added successfully",
                    REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD:
                        "Wireless Gateway added successfully",
                    REQUEST_SUCCESS_LP_SMART_ADD: "Dualsmart added successfully",
                    REQUEST_SUCCESS_BLE_DEVICE_ADD: "Device added successfully",
                },
            },
            INVALID_SYSTEM_NUMBER: "Invalid System number",
            INVALID_USER_ACCESS_SYSTEM_UNLINK:
                "Invalid user. You do not have access to unlink system.",
            GATEWAY_DISCONNECT_ALERT: "Are you sure you want disconnect?",
            DISCARD_CHANGES_ALERT: "Are you sure you want to Discard Changes?",
            UNLINKEXISTING_SYSTEM_ALERT:
                "Are you sure you want Unlink Existing System?",
            GATEWAY_UNREGISTER_ALERT: "Are you sure you want Unregister Gateway?",
            AUTOMATICALLY_CONFIG_IP: "Automatically configure IP Address",
            BACKUP_CONNECTION: "Backup Connection",
            TIMELINE_VIEW: {
                BUILDING: "Building",
                OPTINAL: "Optional",
                ORGANIZATION: "Organization",
                SELECT_BUILDING: "Please Select a Building",
                SELECT_ORGANIZATION: "Please select an organization",
                SUB_LOCATION: "Sub Location",
                SET_BACKUP_INTERNET_TITLE: "Set Backup Internet Access",
                SET_PRIMARY_INTERNET_TITLE: "Set Primary Internet Access",
                INTERNET_CONNECTION_LABLE: "Please Select…",
                SET_INTERNET_CONNECTION_MSG: "Please connect to internet first",
                SUB_LOCATION_LABLE: "Sub Location Name…",
                DESCRIPTION_LABLE: "Write notes for your team…",
            },
            BLUETOOTH_SCAN_ERROR: "Can’t find your gateway? Check  ",
            CARRIER_NAME: "Carrier Name",
            CELLULAR: "Cellular",
            CELLULAR_PROCESS_FAILED_MSG:
                "Cellular configuration process failed. Please try again.",
            CELLULAR_PROCESS_SUCCESS_MSG: "Cellular configured successfully.",
            CELLULAR_CONNECTION: "Cellular Connection",
            NO_BLUETOOTH_SUPPORT: "Bluetooth not supported on this device",
            CHANGE_CONNECTION_METHOD: "Change connection Method",
            CHECK_FOR_UPDATES: "Check for Updates",
            CONFIGURE_WI_FI_CONNECTION: "Configure Ethernet Settings",
            CONFIGURE_CELLEULAR_CONNECTION: "Configure This Cellular Connection",
            COMMISSION_NEW_GATEWAY: "Connect to an Eaton Emergency Lighting Device.",
            CONNECT_TO_ELSYSTEM_FAILED_MSG:
                "Connect to EL system process failed. Please try again.",
            CONNECTED: "CONNECTED",
            CONNECTED_TO: "connected to",
            CONNECTION_METHOD: "Connection Method",
            GATEWAY_CONNECTION_PRIORITY: "Connection Priority",
            CONNECTIONS: "Connections",
            GATEWAY_ADD_BUILDING_VALUE: "Create a new building",
            GATEWAY_ADD_ORGANIZATION_VALUE: "Create a new organization",
            SET_DATE_TIME_SUCCESS: "Date & Time are successfully set",
            DEFAULT_PASSWORD_ADMIN_CHANGED: "DEFAULT_PASSWORD_ADMIN_CHANGED",
            DEFAULT_PASSWORD_USER_CHANGED: "DEFAULT_PASSWORD_USER_CHANGED",
            DISCONNECTED:
                "Device is disconnected or unable to connect, please try again",
            DISCONNECTED_SUCCESS: "Device is disconnected successfully",
            GATEWAY_UNREGISTER_SUCCESS: "Device registration info deleted successfully",
            GATEWAY_UNREGISTER_FAILURE: "Device registration info deleted successfully",
            DGS_NOT_COMMUNICATING: "DGS not Communicating",
            DGS_UNREACHABLE: "DGS Unreachable",
            DHCP: "DHCP",
            DISABLE_WIFI_RATIO_STATUS: "Disabling wifi for Gateway",
            DNS: "DNS",
            CONNECT_TO_ELSYSTEM_SUCCESS_MSG: "EL system linked successfully.",
            ENABLE_LOCATION_FOR_MAP:
                "Enable to find Your current Location, enable it to load map view",
            ENABLE_WIFI_RATIO_STATUS: "Enabling wifi for Gateway",
            WIFI_CREDENTIALS_MESSAGE: "Enter Correct password",
            ENTER_WIFI_CREDENTIALS: "Enter Wi-Fi Credentials",
            RESET_GATEWAY_PASSWORD: "Are you sure you want to Reset Gateway Password?",
            INVALID_EPAS_SERIAL_NUMBER: "EPAS Serial Number is invalid",
            ETHERNET: "Ethernet",
            ETHERNET_CONFIGURATION: "Ethernet Configuration",
            ETHERNET_PROCESS_FAILED_MSG:
                "Ethernet configuration process failed. Please try again.",
            ETHERNET_CONNECTION: "Ethernet Connection",
            FAIL_LINK_SYSTEM: "Fail to link system from gateway",
            FAIL_UNLINK_SYSTEM: "Fail to unlink system from gateway",
            FAIL_UNREGISTER_GATEWAY: "Fail to unregister gateway",
            FINISH: "Finish",
            CHANGE_PASSWORD_INFO:
                "For security reasons, please change the default password.",
            GATEWAY_ACTIVATED: "Gateway Activated",
            GATEWAY_ADDED: "Gateway Added",
            GATEWAY_COMMISSIONING: "Gateway Commissioning",
            GATEWAY_CONNECTED: "Gateway Connected",
            GATEWAY_DETAILS: "Gateway Details",
            GATEWAY_NAME: "Gateway Name *",
            GATEWAY_PASSWORD: "Gateway Password",
            GATEWAY_PASSWORD_INCORRECT: "Gateway password incorrect",
            GATEWAY_NAME_DESCRIPTION:
                "Give this gateway a better name and description.",
            SUCCESSFULLY_ADDED: "has been successfully added.",
            INCOMPLETE_SETUP: "Incomplete Setup",
            INTERNET_SETTINGS: "Internet Settings",
            INVALID_GUID: "Invalid device id, Please enter valid GUID",
            FACTORY_RESET: "Factory Reset",
            FACTORY_RESET_SUCCESS: "Factory reset command successfully executed",
            FACTORY_RESET_FAILURE: "Factory reset command failed. Please try again",
            GATEWAY_FACTORY_RESET_ALERT:
                "Are you sure you want to execute Factory Reset for Gateway?",
            LAST_CONNECTED: "Last Connected",
            CELLULAR_CONNECTION_TYPE_LTE: "LTE",
            CELLULAR_CONNECTION_TYPE_NON_LTE: "NON-LTE",
            INVALID_LATITUDE: "Invalid latitude. Please provide valid latitude",
            INVALID_LONGITUDE: "Invalid longitude. Please provide valid longitude",
            INVALID_USER: "Invalid user",
            SUBLOCATION_NAME_LENGTH: "Letters, dashes, numbers only",
            LINK_NEW_DEVICE: "Link a New Device",
            LINK_NEW_SYSTEM: "Link A New System",
            LINK_SYSTEM: "LINK A SYSTEM",
            LINK_ANOTHER_SYSTEM: "Link Another System",
            LINK_MORE_SYSTEM: "Link More Systems",
            LINK_SYSTEM_MSG: "Link System to '{{gatewayName}}' In progress",
            LINK_SYSTEMS: "Link Systems",
            LOCATION: "Location",
            DENIED_LOCATION_PERMISSION:
                "Location permission denied, Enable it to get bluetooth scan for nearby device",
            DENIED_LOCATION_PERMISSION_FOR_MAP:
                "Location permission denied, enable it to load map view",
            CONNECTION_TYPE_VALUE: "LTE/WCDMA/GSM",
            MANAGE_ETHERNET_CONNECTION: "Manage Ethernet Connection",
            MANAGE_WIFI_CONNECTION: "Manage Wifi connection",
            MANUALLY_CONFIG_IP: "Manually Enter IP Address",
            SET_NAME_DESCRIPTION_SUCCESS: "Name & Description successfully set",
            NO_DEVICE_FOUND: "No Devices Found",
            UNLINK_SYSTEM_ERROR: "No Gateway to unregister",
            NO_GATEWAY_NAME_FOUND: "No Name Found",
            NO_SYSTEM_YET: "No Systems Yet",
            WIFI_NETWORK_NOT_AVAILABLE: "No wifi network available",
            DHCP_OFF: "Off",
            DHCP_ON: "On",
            NO_SYSTEM_YET_DESCRIPTION:
                "Once you link your systems to this gateway, you will see a list of system here. Reword me.",
            ONLINE_TEXT: "online.",
            ORGANIZATION_TREE: "Organization Tree",
            OTHER_NETWORK: "Other Network..",
            BLUETOOTH_INSTRUCTIONS: "our instructions ",
            CHOOSE_GATEWAY_CONNECTION_METHOD:
                "Please choose your Gateway connection method",
            CONFIRM_SELECTION: "Please Confirm Selection",
            ENTER_ADMIN_CHANGE_PASSWORD: "Please enter admin changed password",
            ENTRY_GATEWAY_CHANGED_PASSORD:
                "Please enter the gateway changed password for",
            ENTRY_GATEWAY_DEFAULT_PASSORD:
                "Please enter the gateway default password for",
            ENTRY_PASSWORD: "Please enter the gateway password for",
            PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT:
                "Please enter the new password again to reconnect to the gateway.",
            MOVE_CAMERA_OVER_QR_CODE: "Please move your camera\n over QR Code",
            INVALID_BUILDING_ID: "Please provide valid building id",
            INVALID_DEVICE_ID: "Please provide valid device id",
            INVALID_DEVICE_NAME: "Please provide valid device name",
            INVALID_DEVICE_STATUS: "Please provide valid device status",
            INVALID_DEVICE_TYPE: "Please provide valid device type",
            INVALID_PROJECT_ID: "Please provide valid project id",
            INVALID_SYSTEM_ID: "Please provide valid system id",
            PLEASE_WAIT: "Please wait",
            PRIMARY_CONNECTION: "Primary Connection",
            GATEWAY_PRIORITY: "Priority",
            PROXY: "Proxy (optional)",
            PULL_REFRESH_TEXT: "Pull down to refresh",
            QUATERNARY_CONNECTION: "Quaternary Connection",
            REMOVE_CONNECTION: "Remove Connection",
            REMOVE_PRIMARY_CONNECTION: "Remove Primary Connection",
            REQUIRE_GATEWAY_CONNECTED_TO_INTERNET:
                "Requires gateway connected to the internet",
            SAVE_WI_FI_CREDENTIALS: "Save Wi-Fi credentials for additional devices",
            SCAN_QR_CODE: "Scan QR code",
            QR_CODE_SCAN: "Scan QR Code",
            SCANNING_FOR_NEAR_BY_BLE: "Scanning for Nearby Ble Devices..",
            SCANNING_FOR_NEAR_BY_WIFI: "Scanning for Nearby WIFI..",
            SEARCH_VIA_BLUETOOTH: "Search via Bluetooth",
            SEARCHING_FOR_NEARBY_WIFI: "Searching for Nearby Wi-Fi...",
            SEARCH_VIA_BLUETOOTH_EllIPSE: "Searching via Bluetooth...",
            SECONDARY_CONNECTION: "Secondary Connection",
            SELECT_PRIMARY_CONNECTION: "Select a Primary Connection Method",
            SERIAL_NUMBER_NULL_OR_EMPTY: "Serial Number cannot be null or empty",
            SET_DATE_TIME_CONFIG: "Set Date & Time Incorrect config",
            SET_DATE_TIME_FAILURE: "Set Date & Time is config failure",
            SET_NAME_DESCRIPTION_INCORRECT_CONFIG:
                "Set Name & Description Incorrect config",
            SET_NAME_DESCRIPTION_FAILURE: "Set Name & Description is config failure",
            SET_EL_SYSTEM_PORT: "Set the EL System Port",
            SET_GATEWAY_PORT: "Set the Gateway Port",
            STATIC: "Static",
            STATUS: "Status",
            STEP_THREE_OF_THREE: "Step 3 of 3",
            SYNC_DATE_TIME: "Sync Date And Time",
            SYSTEM_UNLINK_SUCCESS: "System unlink successfully",
            SYSTEM_UNLINKED: "System Unlinked",
            SYSTEMS: "Systems",
            UNLINK_SYSTEM_SUCCESS: "Systems unregistered successfully.",
            TERTIARY_CONNECTION: "Tertiary Connection",
            GATEWAY_NOT_EXISTS: "The gateway does not exist",
            ADDING_GATEWAY_SUBTITITLE: "This process may take up to 2 minutes.",
            UNLINK_ANOTHER_SYSTEM: "Unlink Another System",
            UNLINK_EXISTING_SYSTEM: "Unlink Existing System",
            UNLINK_EXIST_SYSTEM: "Unregister Gateway",
            USE_WI_FI_PASSWORD: "Use Wi-Fi Password",
            USE_WPA2_KEY: "Use WPA2 Key",
            SCANNING_FAILED_TRY_AGAIN: "Verifying device...",
            CARRIER_NAME_VALUE: "Vodafone NL 3G",
            WI_FI: "Wi-Fi",
            WIFI_PROCESS_FAILED_MSG:
                "Wifi configuration process failed. Please try again.",
            GATEWAY_WIFI_CONFIG: "Wifi Configurations",
            WI_FI_NETWORK: "Wi-Fi Network",
            WI_FI_NETWORK_NAME: "Wi-Fi Network Name",
            WI_FI_PASSWORD: "Wi-Fi Password",
            GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG:
                "You can skip any of these steps, but they will need to be completed later to finish setup.",
            GATEWAY_OF: "Gateway Of",
            LOCATION_PERMISSION_TITLE: "Location Permission",
            LOCATION_REQUIRED_MESSAGE: "This app needs access to your location",
            PERMISSION_DENIED_TITLE: "Permission Denied",
            PERMISSION_DENIED_MULTIPLE_MSG:
                "You have denied the location permission multiple times. The app may not function correctly without it.",
            UNREGISTER_GATEWAY: "Unregister Gateway",
            CHOOSE_CONNECTION_TYPE:
                "What kind of connection type will you use for \n the DGS system?",
            REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG:
                "Cannot add more systems. Limit reached for maximum systems supported on Gateway",
            DUALSMART_NAME: "Dualsmart Name *",
            WIRELESS_GATEWAY_NAME: "Wireless Gateway Name *",
            DUPLICATE_SYSTEM_ERROR_MSG:
                "System with this IP address is already linked to Gateway.",
            DIRECT_CONNECT_OPTION_SELECT_MSG:
                "Ensure IP Address of the System is set to IP Address and DHCP is disabled",
            SEARCH_ALL_LUMINARIES: "Search All Luminaires",
        },
        ERROR_MESSAGES: {
            GENERIC_ERROR_CONTACT_DETAILS: " or call at ",
            GENERIC_ERROR:
                "An unspecified error has occurred. If this issue persists, please contact Eaton Support at  ",
            9003: "Requested operation cannot be performed, please contact your administrator",
            2002: "User Registration link is Expired or Already Redeemed.",
            2018: "We are unable to complete your registration. Your Organization has exceeded the number of allocated Users for your subscription. If your Organization requires additional Users, please contact CST Support via email at ",
            9044: "User password is not valid or length should be between 8 and 16 characters",
        },
        FORGOT_PASSWORD: {
            INSTRUCTIONS:
                "Please enter the account email associated with the account. <br/><br/>" +
                "If this email has an account with Safety Management Software, you will receive a response within <3>one business day</3>.<br/><br/>" +
                "For urgent account issues, please call ",
            ERROR: "Could not reset your password at this time.",
            RESET_CODE_ERROR: "There was an error with your reset code. ",
            EATON_EMAIL_ALERT:
                "BSMS password is same as JOE password. If you want to change your password, please change using Account Preferences on your Eaton Asset.",
        },
        ACCOUNT_SETTING: {
            UPDATES_AVAILABLE: " UPDATES AVAILABLE",
            ACCOUNT_CREATED: "Account Created",
            ACCOUNT_PREFERENCES: "Account Preferences",
            ADDRESS_LINE2: "Address Line 2 (Optional)",
            ALARAM: "Alarms",
            ALL_BUILDINGS: "All Buildings",
            ALL_SYSTEM_FIRMWARE: "All System Firmware",
            ALL_SYSTEMS: "All Systems",
            APPLICATION_THEME_COLOR: "Application Theme Color",
            AUTOMATIC_LOG_OUT: "Automatic Log out",
            AUTOMATIC_UPDATES: "Automatic Updates",
            AUTOMATIC_UPDATES_INFO:
                "Automatically download the latest version of firmware to your device.",
            CHANGE_PASSWORD: "Change Password",
            STORAGE_FIRMWAREFILE_INFO:
                "Choose how to store firmware files to your device",
            CITY: "City",
            COMPANY_ADDRESS: "Company Address",
            COMP_ADDRESS: "Company Address*",
            COMPANY_DETAILS: "Company Details",
            COMPANY_NAME: "Company Name",
            COMP_NAME: "Company Name",
            COMPANY_PHONE_NUMBER: "Company Phone Number",
            CODE: "Country Code",
            DATE_FORMAT: "Date Format",
            DELETE_ACCOUNT: "Delete Account",
            DELETE_CUSTOMER: "Delete Customer",
            DEVICE_BLOCKING:
                "Device is in blocking mode, emergency mode, maintenance requested",
            EDIT_CUSTOMER_INFO: "Edit Customer Info",
            EMAIL: "Email",
            EMAIL_ADDRESS: "Email Address",
            REQUIRED_FIELD: "Fields with an asterisk(*) are required to continue.",
            FIRMWARE_FILE: "Firmware Files",
            FIRMWARE_UPDATES: "Firmware Updates",
            FIRST_NAME: "First Name",
            FT_DT_FAIL:
                "FT failed, DT failed, Disconnnected, battery failure, Lampfailure, ATSD failure",
            HEALTH_REPORT: "Health Report",
            LANGUAGE: "Language",
            LAST_NAME: "Last Name",
            MONTHLY_REPORTING: "Monthly Reporting",
            NEW_RELEASE_FIRMWARE_UPDATE: "New releases, firmware update available",
            NOTIFICATIONS: "Notifications",
            ORGAN_UPDATED_SUCCESSFULLY: "Organization updated successfully",
            PASSWORD: "Password",
            PERSONAL_DETAILS: "Personal Details",
            PHONE_NUMBER: "Phone Number",
            POSTAL_CODE: "Postal Code",
            PREFERENCES: "Preferences",
            PRIMARY_CONTACT: "Primary Contact",
            PRIMARY_CONTACT_EMAIL_ADDRESS: "Primary Contact Email Address",
            PRIMARY_CONTACT_PHONE_NUMBER: "Primary Contact Phone Number",
            PRIMARY_EMAIL_ADDRESS: "Primary Email Address",
            PRIMARY_PHONE_NUMBER: "Primary Phone Number",
            PRODUCT_UPDATE: "Product Updates",
            SAVE_CHANGES: "Save Changes",
            SECONDARY_CONTACT: "Secondary Contact",
            SECONDARY_CONTACT_EMAIL_ADDRESS: "Secondary Contact Email Address",
            SECONDARY_CONTACT_PHONE_NUMBER: "Secondary Contact Phone Number",
            SECONDARY_EMAIL_ADDRESS: "Secondary Email Address",
            SECONDARY_PHONE_NUMBER: "Secondary Phone Number",
            SLA_DETAILS: "SLA Details",
            STATUS_UPDATE: "Status Updates",
            STORAGE: "Storage",
            TIME_ZONE: "Time zone",
            UNITS: "Units",
            USER_NAME: "User Name",
            USER_UPDATED_SUCCESSFULLY: "User updated successfully",
            VERSION: "Version",
            EST: "EST",
        },
        CHANGE_PASSWORD: {
            EMAIL_CONFIRM_MESSAGE: " We have sent a confirmation email to {{email}}",
            PROBLEM_OCCURRED: "A problem occurred:",
            PASSWORD: "Change Password",
            OLD_PASSWORD: "Old Password",
            PASSWORD_CHANGED: "Password Changed",
            PASSWORD_INFO:
                "Password must be at least 8 characters long, contain at least one uppercase character, one lowercase character, one number, and one special character.",
            ERROR_MESSAGR:
                "Your information did not match our records. Please re- enter your information to try again.",
            SUCCESS_MESSAGE:
                "Your password was successfully updated! To ensure your account's security, you will need to log in to the application with your updated credentials.",
        },
        SYSTEM_DETAIL: {
            GUIDE: "(Guide)",
            USERS_DATA: "5 admins, 1 viewer",
            ACTIVATE_CONNECTIONS: "Activate connections in the cloud",
            ADD_ANOTHER_CELLULAR: "Add Backup Cellular connection",
            ADD_SLA: "Add SLA",
            SYSTEM_DETAILS_TITLE: "System Details",
            ALL_CONTACTS: "All Contacts",
            ALL_PEOPLE_IN_THIS_BUILDING: "All People in this building",
            ALL_SYSTEMS_IN_THIS_BUILDING: "All Systems in this Building",
            BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: "Both ports cannot be on same subnet",
            BUILDING: "Building",
            BUILDING_INFO: "Building Info",
            BUILDING_TYPE: "Building Type",
            BUYER: "Buyer",
            CONNECTION_TYPE: "Connection Type",
            CONTACT_PERSON_Onsite: "Contact Person Onsite",
            CONTACT_TYPE: "Contact Type",
            CUSTOMER_DETAILS: "Customer Details",
            CUSTOMER_INFO: "Customer Info",
            CUSTOMER_NUMBER: "Customer Number",
            DATE_COMMISSIONED: "Date Commissioned",
            DISABLE: "Disable",
            DURATION_TEST: "Duration Test",
            DURATION_TEST_FAILED: "Duration Test Failed",
            DURATION_TEST_PASSED: "Duration Test Passed",
            ENABLED: "Enabled",
            ENTER_VALID_GATEWAY_ADDRESS: "Enter a valid Gateway Address",
            ENTER_VALID_IP_ADDRESS: "Enter a valid IP Address",
            ENTER_VALID_SUBNET_MASK: "Enter a valid Subnet Mask",
            ETHERNET_PORT_ONE: "Ethernet Port A",
            ETHERNET_PORT_TWO: "Ethernet Port B",
            EXPIRY_DATE: "Expiry Date",
            FIRMWARE_VERSION: "Firmware Version",
            FOR_BUILDINGS: "For Buildings",
            FOR_SYSTEMS: "For Systems",
            FUNCTIONAL_TEST: "Functional Test",
            FUNCTIONAL_TEST_FAILED: "Functional Test Failed",
            FUNCTIONAL_TEST_PASSED: "Functional Test Passed",
            GATEWAY: "Gateway",
            GATEWAY_ADDRESS: "Gateway Address",
            GATEWAY_ADDRESS_REQUIRED: "Gateway Address*",
            GATEWAY_NAME: "Gateway Name",
            SYSTEM_UNLINKED_GATEWAY: "has been unlinked from ",
            SYSTEM_LINKED_GATEWAY: "has been linked to ",
            HOST_NAME: "Host Name",
            INTIALIZE_CONNECTION: "Initialize connection",
            INTIALIZE_NETWORK: "Initializing Network...",
            IP_ADDRESS: "IP Address",
            IP_ADDRESS_REQUIRED: "IP Address*",
            IP_GATEWAY_NOT_IN_SAME_SUBNET: "Ip and gateway not in same subnet mask",
            ETHERNET_CONNECTED: "is now  connected to the internet",
            SYSTEM_LINKING_TITLE: "Is this the system you are linking?",
            SYSTEM_UNLINKING_TITLE: "Is this the system you are unlinking?",
            SYSTEM_LINK_TITLE: "Link a System to ",
            LUMINAIRES: "Luminaires",
            LUMINARIES_LIST: "Luminaires List",
            MAC_ADDRESS: "Mac Address",
            MAIN_CONTACT: "Main Contact",
            NETWORK_INFORMATION: "Network Information",
            NO_SYSTEM_FOUND: "No System Available",
            OFFICE: "Office",
            ORGANIZATION: "Organization",
            OTHER_STEPS: "Other steps, if necessary",
            OTHER_SYSTEMS: "Other Systems",
            PART_NUMBER: "Part Number",
            SETPORT_SYSTEM_DETAILS_DESCRIPTION:
                "Please complete the Ethernet configuration details.",
            SYSTEM_DETAILS_DESCRIPTION:
                "Please find these details on the HMI screen of your system cabinet.",
            PORT_NUMBER: "Port Number",
            PREV: "Prev",
            PROJECT_LEAD: "Project Lead",
            REGISTER_ACTIVATE_GATEWAY: "Register and activate the gateway",
            SERIALNO_VALUE: "S3ri4l-Num63r",
            SERIAL_NUMBER: "Serial Number",
            SETPORT_SYSTEM_LINK_TITLE: "Set the Port to Link a System to ",
            SLA_NUMBER_TITLE: "SLA#",
            SLAVE_NUMBER: "Slave Number",
            SUBNET_MASK: "Subnet Mask",
            SUBNET_MASK_REQUIRED: "Subnet Mask",
            SYN_DATE_TIME: "Synchronize date and time",
            SYSTEM: "System",
            SYSTEM_NAME: "System Name",
            SYSTEM_TYPE: "System Type",
            TECHNICAL_PERSON: "Technical Person",
            STATUS_DESCRIPTION:
                "This is a long description. It might describe the device location and who to talk to.",
            TOTAL_SLA: "Total SLA",
            TRANSFER_ORGANIZATION:
                "Transfer this organization and its assets \n to another user (optional)",
            SYSTEM_UNLINK_TITLE: "Unlink System From",
            UPDATE_REQUIRED: "update required",
            UPLOAD_DETAILS: "Upload details via bluetooth",
            FIRMWARE_VERSION_VALUE: "v12.34-56",
            VERSION_AVAILABLE: "v123.457 Available",
            VIEW_ALL: "View All",
            VIEW_ALL_LUMINARIES: "View All Luminaires",
            PARTNO_VALUE: "xx xx xx xx",
            ETHERNET_SUBTITLE:
                "You may now access your gateway through the web. Reword me.",
        },
        USER_INVITATION_MANAGEMENT: {
            YOU: "(You)",
            INVITATION_MESSAGE_UPDATE_COUNT:
                "{{updatedInvitationCount}} invitations were {{inviteStatus}} successfully, {{rejectedInvitationCount}} invitations were not {{inviteStatus}}.",
            SUCCESS_COUNT:
                "{{updatedInvitationCount}} invitations were {{inviteStatus}} successfully.",
            INVITE_ACCEPT: "Accept",
            INVITE_ACCEPT_INVITATION: "Accept invitation",
            INVITE_ACCEPTED: "accepted",
            INVITE_ACCEPTED_BUTTON: "Accepted",
            INVITE_ACCEPT_INVITATION_DESCRIPTION_1:
                "Accepting this invite will add the following item to your profile:",
            ADMIN_APPROVE: "Approve Request",
            COMPANY: "Company",
            DECLINE_INVITATION: "Decline Invitation",
            TABLE_HEADER_DENIED_TITLE: "Declined by Me ({{count}})",
            INVITE_DENIED: "denied",
            INVITE_DENY: "Deny",
            ADMIN_DECLINE_INVITATION: "Deny Request",
            TABLE_HEADER_EXPIRED_AT: "Expiration",
            TABLE_HEADER_EXPIRED_TITLE: "Expired Invitations ({{count}})",
            INVITE_HISTORY: "Invitation History",
            INVITATION_SUCCESS_MESSAGE: "Invitation successfully {{inviteStatus}}.",
            JOIN: "Join",
            JOINALL: "Join All",
            TABLE_HEADER_NAME: "Name",
            INVITE_PENDING: "Pending",
            INVITE_REQUEST_ACCESS_DESCRIPTION_2:
                "Please request access from the admin to add this item to your profile",
            TABLE_HEADER_INVITE_DATE: "Received",
            REMOVE_USER: "Remove User",
            INVITE_REQUEST: "Request",
            INVITE_REQUEST_ACCESS: "Request Access",
            REQUESTEDBY: "Requested by",
            INSTRUCTIONS:
                "Select to either add items to your profile or to decline the invitation to add it to your profile.",
            ADMIN_INSTRUCTIONS:
                "Select to either approve or deny their request for access:",
            SENTBY: "Sent by",
            TABLE_HEADER_INVITE_BY: "Sent By",
            TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND:
                "There are no accepted invitations at this time.",
            TABLE_HEADER_DENIED_NO_DATA_FOUND:
                "There are no denied invitations at this time.",
            TABLE_HEADER_EXPIRED_NO_DATA_FOUND:
                "There are no expired invitations at this time.",
            INVITATION_TEXT: "They will need an invitation to rejoin.",
            INVITE_REQUEST_ACCESS_DESCRIPTION_1:
                "This invitation has expired and can no longer be added to your profile.",
            TABLE_HEADER_TOTAL_COUNT: "Total Accepted Invitations ({{count}})",
            TABLE_HEADER_TOTAL_ACCEPTED_COUNT: "Total Accepted Invitations ({{count}})",
            SUCCESS_MESSAGE: "User invitation success {{count}}",
            ERROR_MESSAGE: "User request to update invitation failed",
            VIEW_ALL_ACCESS_RIGHTS: "View All Access Rights",
            TITLE: "Welcome, {{username}}",
            SUBTITLE: "You have been invited to the following projects:",
            ADMIN_SUBTITLE: "You have requests to access expired invitations:",
            LEAVE_ORGANIZATION: "Leave Organization",
            REMOVE_SERVICE_USER_TITLE: "Remove {{userName}} from {{companyName}} ?",
            ARCHIVE_USER_DIALOG: "Are you sure you want to archive {{userName}} user?",
            ARCHIVE_USER_TITLE: "Archive User",
            ARCHIVE_USER_SUCCESS: "User archived successfully",
            ARCHIVE_USER_ERROR_9260: "User is Already archived",
            RESTORE_USER_DIALOG: "Are you sure you want to restore {{userName}} user?",
            RESTORE_USER_TITLE: "Restore User",
            RESTORE_USER_SUCCESS: "User restored successfully",
            RESTORE_USER_ERROR_9261: "Already user is restored from archive",
        },
        INACTIVITY: {
            LOGOUT: ", you will be logged out.",
            INACTIVE_LOGOUT: "Logged out due to inactivity",
            TITLE: "Session Timeout",
            WARNING:
                "We haven't seen any activity for 15 minutes, unless you take action you will be logged out in  ",
        },
        ATPLUS: {
            ATPLUS_FAILURE_COUNT: "{{count}} Failure",
            ATPLUS_DATETIME_TWENTYFOUR_HOUR: "24-Hour Time",
            ATPLUS_TWO_MINUTE_AGO: "2mn ago",
            ATPLUS_ACTIVATION: "Activation",
            ADMIN: "Admin",
            ADMINVIEWER: "Admin & Viewer",
            ATPLUS_ADMIN_ACCESS: "Admin Access",
            ATPLUS_ALERT_LEVEL: "Alert Level",
            ATPLUS_ALERTSETTING_HEADER: "Alert Level Settings",
            ATPLUS_SEARCHLUMINAIRE_WARNING:
                "All luminaires will be assigned a new address and create a new configuration. ",
            ATPLUS_LOGIN_FAILURE: "An error occurred while changing parameters",
            ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: "Automatic Date & Time",
            ATPLUS_AUTOMATIC_RESET: "Automatic Rest Mode",
            ATPLUS_AUTOMATIC_REST_MODE_MSG:
                "Automatic Rest Mode will send the luminaires into rest if the local main is switched off.",
            ATPLUS_BATTERYFAILURE: "Battery Fail",
            ATPLUS_CHANGE_ADMIN_PASSWORD: "Change Admin Password",
            ATPLUS_CHANGE_PASSWORD_FAILURE: "Change password failure",
            ATPLUS_CHANGE_PASSWORD_SUCCESS: "Change password Success",
            ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: "Change Service Partner Password",
            ATPLUS_CHANGE_PASSWORD: "Change System Password",
            SYSTEMPASSWORD: "Change System Passwords",
            ATPLUS_CHANGE_VIEWER_PASSWORD: "Change Viewer Password",
            ATPLUS_SYNC_TEST_SCHEDULE_INFO:
                "Click, “Sync Test Schedule” to set the Functional Tests to exactly 7 days from now and Duration tests 10 weeks from now.",
            ATPLUS_INFO_TAG_CLOSED: "CLOSED",
            ATPLUS_COMISSIONING: "Comissioning",
            ATPLUS_COMMANDS: "Commands",
            ATPLUS_COMMSFAILURE: "Comms Fail",
            ATPLUS_CONFIGRATION_CREATED: "Configuration Created",
            ATPLUS_CONFIGRATION_DETAIL: "Configuration Details",
            ATPLUS_CONFIGRATION_NAME: "Configuration Name",
            ATPLUS_CREATE_CONFIGRATION: "Create Configuration",
            ATPLUS_DATETIME_CURRENT_TIME: "Current Date & Time",
            ATPLUS_DEVICE_DATETIME_CURRENT_TIME: "Current Mobile Device Date & Time",
            ATPLUS_CURRENT_TEST_SCHEDULE: "Current Test Schedule",
            ATPLUS_REFRESH_LUMINAIRES:
                "Currently retrieving the most recent status for all luminaires in the {{atplus}} building.",
            ATPLUS_DATETIME: "Date & Time",
            ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: "Default Settings",
            ATPLUS_DETAILS: "Details",
            ATPLUS_DRY_CONTACT: "Dry Contact",
            ATPLUS_DRYCONTACT_INPUT: "Dry Contact Input",
            ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: "Dry Contact Input Activated",
            ATPLUS_DRYCONTACT_OUTPUT: "Dry Contact Output",
            ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: "Dry Contact Output Activated",
            ATPLUS_DRYCONTACT_HEADER: "Dry Contact Settings",
            ATPLUS_DRYCONTACT_STATUS: "Dry Contact Status",
            ATPLUS_DURATION_TEST_TITLE: "Duration \n Test",
            ATPLUS_DTSUCCESS: "Duration Test Complete",
            ATPLUS_DTFAILEDTITLE: "Duration Test Failed",
            ATPLUS_DTINPROGRESS: "Duration Test In Progress...",
            SERVICE: "Eaton Service",
            ATPLUS_ELSYSTEM_SYSTEM_TIME: "EL System Local Time",
            ATPLUS_EMC_HEADER: "EMC Test",
            ATPLUS_EMERGENCY: "Emergency",
            ATPLUS_FW_UPDATE_EROOR: "Error in upgrading firmware please try it again",
            ATPLUS_EXPORT_CONFIG: "Export Configuration",
            ATPLUS_FAILED_LUMINAIRE: "Failed Luminaires",
            ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: "Failure Threshold Exceeded",
            ATPLUS_FAILURETYPE: "Failure Types",
            ATPLUS_FIRMWARE_FILE_FOR: "Firmware file for version",
            ATPLUS_FIRMWARE_UPDATE: "Firmware Update",
            ATPLUS_FW_UPDATE_COMPLETE: "Firmware Update Complete",
            ATPLUS_FW_UPDATE_INPROGRESS: "Firmware Update in Progress",
            ATPLUS_FUNCTIONAL_TEST_TITLE: "Functional \n Test",
            ATPLUS_FTSUCCESS: "Functional Test Complete",
            ATPLUS_FTINPROGRESS: "Functional Test In Progress...",
            CHANGEPASSWORDFOR: "I need to change the Password for",
            ATPLUS_IMPORT_CONFIG: "Import Configuration",
            ATPLUS_INEMERGENCYMODE: "In Emergency Mode",
            ATPLUS_INFAILURE: "In Failure",
            ATPLUS_INRESTMODE: "In Rest Mode",
            ATPLUS_INTESTMODE: "In Test Mode",
            ATPLUS_REFRESH_INCOMPLETE: "Incomplete Data",
            ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: "Incorrect Current password",
            ATPLUS_DRYCONTACT_STATUS_INPUT: "Input",
            GWCDATPLUSHEADER: "Is this the EL Device you are commissioning?",
            ATPLUS_LAMPFAILURE: "Lamp Fail",
            ATPLUS_CONFIGRATION_FILE_TITLE_INFO:
                "Letters, numbers, underscores & dashes only",
            ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: "Local Main Failure",
            ATPLUS_LOAST_CONNECTION: "Lost Connection - Please Try Again",
            ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: "Luminaire Alerts",
            ATPLUS_DTFAILEDDESCRIPTION: "Luminaire Failure",
            ATPLUS_LUMINAIRE: "Luminaires",
            ATPLUS_FOUNDLUMINAIRE: "Luminaires Found...",
            ATPLUS_FOUNDWERELUMINAIRE: "Luminaires were found.",
            ATPLUS_MAIN_OFFICE: "Main Office",
            ATPLUS_DRYCONTACT_SUBHEADER: "Main Office",
            ATPLUS_MANAGE_CONFIG: "Manage Configurations",
            ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED:
                "Maximum number of attempts has been reached",
            ATPLUS_MINIMIZE: "Minimize",
            ATPLUS_MULTIPLE_FAILURES: "Multiple Failures",
            ATPLUS_FOUNDNEWLUMINAIRE: "new Luminaires were found.",
            ATPLUS_NEW_TEST_SCHEDULE: "New Test Schedule",
            ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: "New York",
            ATPLUS_NEXT_SCHEDULES_DTTEST: "Next Scheduled Duration Test",
            ATPLUS_NEXT_SCHEDULES_FTTEST: "Next Scheduled Functional Test",
            ATPLUS_NO_FW_FILES: "No Firmware file present for version",
            ATPLUS_NO_LUMINAIRES_INSTALLED: "No Luminaires Installed",
            ATPLUS_NO_LUMINAIRES_YET: "No Luminaires Yet",
            ATPLUS_DRYCONTACT_RADIO_CLOSED: "Normally Closed",
            ATPLUS_DRYCONTACT_RADIO_OPEN: "Normally Open",
            ATPLUS_NEWLUMINAIRES_HEADLINE:
                "Only search for newly-added or replaced luminaires in the “Main Office” to automatically assign addresses to them.",
            ATPLUS_OPENSNACK: "Open",
            ATPLUS_OPERATIONS: "Operations",
            ATPLUS_ALERTSETTING_OTHER_ALERTS: "Other Alerts",
            ATPLUS_DRYCONTACT_STATUS_OUTPUT: "Outputs",
            ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: "Output Default Settings",
            ATPLUS_ALERTSETTING_CHOOSE_NUMBER: "Please choose between 1- 10 luminaires",
            ATPLUS_ADDITIONALPASSWORDINSTRUCTION:
                "Please create new passwords for users with Service, Admin, and Viewer level access to this telecommand.",
            ATPLUS_DONT_MOVE: "Please Don’t Move Away",
            ATPLUS_DOWNLOAD_FW_FILES: "Please download file again and try...",
            ATPLUS_BLE_DISCONNECT_SUBTITILE:
                "Please ensure you are within range of the Bluetooth and try again.",
            ATPLUS_RELOGINPASSWORDINSTRUCTION:
                "Please enter the new password again to reconnect to the",
            ATPLUS_RELOGIN_MESSAGE:
                "Please enter the new password again to reconnect to the.",
            ATPLUS_ENTRY_MESSAGE:
                "Please enter your credentials to chang the following passwords.",
            ATPLUS_EXPORT_CONFIGRATION_INFO:
                "Please name the file to save and export your most recently created configuration.",
            ATPLUS_STAY_WHERE: "Please Stay Where You Are",
            ATPLUS_ALERTSETTING_NOTIFY:
                "Please use the following settings to customize your alert preferences.",
            ATPLUS_REFRESH_COMPLETE: "Refresh Complete",
            ATPLUS_REFRESHLUMINAIRE_TEST: "Refresh Luminaires",
            ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: "Refresh Luminaires",
            ATPLUS_REFRESH_LUMINAIRES_PROGRESS: "Refresh Luminaires in Progress...",
            ATPLUS_USE_RELIGHT:
                "Relight is only available for luminaires currently in Rest mode.",
            ATPLUS_DRYCONTACT_INPUT_RELIGHT: "Relight JOUR",
            ATPLUS_RELIGHT_SUCCESS: "Relight Mode has been activated successfully.",
            ATPLUS_RESTMODE: "Rest",
            ATPLUS_REST_SUCCESS: "Rest Mode has been activated successfully.",
            ATPLUS_DURATION_TEST: "Run Duration Test",
            ATPLUS_FUNCTIONAL_TEST: "Run Functional Test",
            ATPLUS_SEARCH_ALL_LUMINAIRES: "Search For All Luminaires",
            ATPLUS_SEARCH_NEWLUMINAIRES: "Search For New Luminaires",
            ATPLUS_SEARCHNEW_LUMINAIRE: "Search New Luminaires",
            ATPLUS_SERVICE_ACCESS: "Service Access",
            ATPLUS_SERVICEPARTNERPASSWORD: "Service Partner",
            ATPLUS_CHANGEPASSWORD_INSTRUCTION: "Set a password for users with",
            ATPLUS_ADDITIONALPASSWORD: "Set Additional Passwords",
            ATPLUS_DATE_TIME: "Set Date & Time",
            ATPLUS_DATETIME_HEADER: "Set Date & Time",
            ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO:
                "Set the number of failing luminaires a system must reach for an alert to be activated.",
            ATPLUS_SHOW_CONNECTED_LUMINAIRE: "Show Connected Luminaires",
            ATPLUS_SHOW_REGISTERED_LUMINAIRE: "Show Registered Luminaires",
            SIGN_IN: "Sign in",
            SIGN_IN_AS: "Sign in as...",
            ATPLUS_RELIGHT: "Start Relight Mode",
            ATPLUS_REST: "Start Rest Mode",
            ATPLUS_STARTSEARCH: "Start Search",
            ATPLUS_START_TEST: "Start Test",
            ATPLUS_VISIBILITY_TEST: "Start Visibility Plus",
            ATPLUS_DRYCONTACT_INPUT_VISIBILITY: "Start Visibility+",
            ATPLUS_STARTDT: "Starting Duration Test...",
            ATPLUS_STARTFT: "Starting Functional Test...",
            ATPLUS_STARTDTSNACK: "Stop Test",
            ATPLUS_EMC: "Switch to EMC Test",
            ATPLUS_SYNCH_TEST: "Sync Test Schedule",
            ATPLUS_SYNC_TEST_SCHEDULE: "Sync Test Schedule",
            ATPLUS_SYNC_TEST_SCHEDULED_INFO:
                "Synchronize the test schedule for the Functional & Duration test for all of the luminaires in the building",
            TELECOMMANDPASSWORD: "Telecommand Password",
            ATPLUS_TEST: "Test",
            ATPLUS_SYNC_TEST_TIME: "Test Time:",
            ATPLUS_DRYCONTACT_INPUT_READONLY:
                "The Dry Contact Input is read-only, but can be configured manually on the dip switch.",
            ATPLUS_DRYCONTACT_STATUS_READONLY:
                "The status is read-only, but can be configured manually on the dip switch.",
            ATPLUS_LUMINAIRE_INSTALL:
                "This action will blink all of the luminaires in an installation.",
            ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO:
                "This action will blink any luminaire that is properly wired and connected to the controller.",
            ATPLUS_SEARCHLUMINAIRE_HEADLINE:
                "This action will create a new configuration using all connected luminaires.",
            ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO:
                "This action will only blink luminaires that are included in your lighting configuration.",
            ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO:
                "This action will sync the next Functional Test to exactly 1 week and Duration Tests at 10 weeks.",
            ATPLUS_AUTOMATIC_REST_MODE_INFO:
                "This information is read only, but can be configured manually on the dip switch.",
            ATPLUS_LOAST_CONNECTION_INFO:
                "This mobile device must remain in Bluetooth range and connected to the AT+ System during the Functional Test.",
            ATPLUS_DEVICE_RANGE:
                "This mobile device must remain within the Bluetooth range of the G-North TLAT+ for this operation. \n This process can take several minutes.",
            ATPLUS_TOMANYLUMINAIREHEADER:
                "This system can only support up to 64 luminaires. Only the first 64 devices detected will be part of your configuration. Please use the “Search Registered Luminaires” function in the Commissioning  Window to find the luminaires not included in your configuration.",
            ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION:
                "This will replace your current luminaire configuration",
            ATPLUS_TIMEREMAINS: "Time Estimate,",
            ATPLUS_TIMEREMAINING: "Time Remaining, ",
            ATPLUS_DATETIME_TIMEZONE: "Time Zone",
            ATPLUS_TIMEZONE_HEADER: "Time Zone",
            TLU_ATPLUS_PASSWORD_INCORRECT: "TLU AT+ password incorrect",
            ATPLUS_TOMANYLUMINAIRE: "Too Many Luminaires Were Found",
            ATPLUS_FIRMWARE_UPDATING: "Updating Firmware...",
            ATPLUS_USE_REST:
                "Use  Rest for luminaires no longer connected to the main power. ",
            ATPLUS_FINISHSEARCH:
                "Use these results to create and share a new configuration by using “Export.”",
            ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT:
                "Use your mobile device’s date, time, and time zone to automatically sync with the TLAT+ System. Turn off this function to manually set the date, time, and time zone.",
            ATPLUS_VIEWLOGBOOK: "View Logbook",
            VIEWER: "Viewer",
            ATPLUS_VIEWER_ACCESS: "Viewer Access",
            ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: "You can try to sign in to this",
            ATPLUS_DT_DIALOG:
                "You may lose data if you move too far away from the AT+ System during the Duration Test.Estimated time remaining, 01:00:00",
            ATPLUS_FT_DIALOG:
                "You may lose data if you move too far away from the AT+ System during the Functional Test.Estimated time remaining, 00:02:00",
            ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION:
                "You will need to use the “Search All Luminaires” function and activate your TLAT+ to see your luminaires here.",
            ATPLUS_CONFIGRATION_CREATED_MESSAGE:
                "Your Configuration has been Created Successfully.",
            ATPLUS_RELOGIN_SUCCESS_MESSAGE: "Your new passwords were saved.",
            ATPLUS_DEVICE_UNREGISTERED: "This Device is Unregistered",
            ATPLUS_DEVICE_NEEDCOMMISSIONIG:
                "This Device is Unregistered from Cloud and need to be re-commissioned",
            ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: "Invalid Configuration Name",
            SAVE_TO_CLOUD: "Save to Cloud",
            EXPORT: "Export",
            ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: "Setting the Device Name",
            TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION:
                "Loading the Luminaire Configuration...",
            ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION:
                "Setting the Dry Contact Configuration",
            ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: "Quit and Lose Progress?",
            TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE:
                "Exiting this screen will cancel the import process and you will have to start the process again.",
            ATPLUS_START_VISIBILITY_PLUS: "Start Visibility Plus",
            ATPLUS_VISIBILITY_PLUS: "Visibility Plus",
            ATPLUS_VISIBILITY_PLUS_FAILED: "Visibility Plus Failed",
            DRY_CONTACT_SETTINGS_DESCRIPTION:
                "Information is only configurable on the telecommand or via the mobile application.",
            ATPLUS_SEARCHALL_LUMINAIRE: "Search All Luminaires",
        },
        USERLIST: {
            DELETECONFIRMATION:
                "{{email}} Account and all its data will be permanently removed. Deleting this account will not affect the Organization, Devices, or any related historical data.",
            ACCOUNT_DELETE: "Account Deleted",
            ALL_LOCATION: "All Locations",
            DELETEACCOUNT: "Delete this Account?",
            COL_EMAIL: "Email",
            COL_LOCATION: "Location",
            COL_ROLE: "Role",
            COL_STATUS: "Status",
            DELETE_SUCCESS:
                "The User Account for {{email}} has been successfully deleted.",
            COL_USERNAME: "User Name",
        },
        REPORTS: {
            ISSUES: "{{issueCount}} issues",
            MONTHLY_REPORT: "Monthly Report",
            NO_ISSUES: "No issues during this period",
            REPORT_DOWNLOAD_FAILED: "Report file download failed",
            REPORT_DOWNLOAD_SUCCESSFULLY: "Report file downloaded successfully",
        },
        INSTALLATION_MANUAL: {
            DOWNLOAD_SUCCESSFULLY: "Download Complete",
            DOWNLOAD_FAILED: "Download Failure. Please try again",
        },
        MAP: {
            MAP_COORDINATES: "{{latitude}} N, {{longitude}} E",
            MAP_COORDINATES_LABEL: "Coordinates",
            MAP_ADDRESS_DISPLAY: "Display address on map",
            MAP_DRAG_MARKER: "Drag on the map to place the pin",
            MAP_ENABLE_ON_COUNTRY: "Select country to enable map",
            WARNING: "WARNING",
            BLOCKED: "BLOCKED",
            ERROR: "ERROR",
            OFFLINE: "OFFLINE",
            READY: "READY",
            SYSTEM: "System",
            SYSTEMS: "Systems",
            LOCATE_ON_MAP: "Locate on map",
            TOGGLE_MAP_LAYER: "Toggle map layer",
            TOGGLE_FULLSCREEN: "Toggle fullscreen",
            ZOOM_OUT: "Zoom out",
            ZOOM_IN: "Zoom in",
        },
        MAINTENANCE_DETAILS: {
            ADD_DOC: "+  Add Document",
            ADD_NOTES: "+  Add Notes",
            ADD_DOCUMENT_BUTTON: "+ Add Document or Photo",
            NEW_MAINTENANCE: "+ New Maintenance",
            CREATE_MAINTAINENCE_BUTTON: "Assign and Notify",
            TECHNICIAN_INPUT_LABEL: "Assigned To",
            STATUS_COMPLETED: "Completed",
            CUSTOMER_CONTACT: "Customer Contacts",
            DATE_CREATED: "Date Created",
            DELETE_REQ: "Delete Request",
            COMMENTS_LABEL: "Description (Optional)",
            DOCUMENTATION: "Documentation",
            STATUS_DUE: "Due",
            EMERGENCY: "Emergency",
            STATUS_EXPIRED: "Expired",
            HIGH: "High",
            IN_DUE: "IN {{differenceInDays}} DAYS",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE:
                "Invalid file type. Only PDF, JPEG, and PNG are allowed.",
            SUPPORT_TYPE_INPUT_LABEL: "Issue Type",
            LIFECYCLE_MAINTAINANCE: "Life Cycle Maintenance",
            LIFECYCLE_MAINTENANCE: "LifeCycle Maintenance",
            LOCATION: "Location(s)",
            LOW: "Low",
            MAINTENANCE_HISTORY: "Maintenance History",
            MAINTENANCE_REQUEST: "Maintenance Request",
            MEDIUM: "Medium",
            NO_CUSTOMER_LINKED: "No Customer Linked",
            NO_DOC_ADDED: "No Documentation Added",
            NO_MAINTENACE_FOUND: "No maintenance found",
            NO_NOTES_ADDED: "No Notes Added",
            NOTES: "Notes",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE:
                "One or more files exceed the 2MB size limit.",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_EXCEEDS_FILE_SIZE:
                "The total size of selected files exceeds the 2MB limit.",
            PAST_DUE: "Past Due",
            PRIORITY: "Priority",
            STATUS_REJECTED: "Rejected",
            REOPEN_SERVICE_TICKET: "Reopen Service Ticket",
            REQUEST_PRIORITY_INPUT_LABEL: "Request Priority",
            REQ_MAINTENANCE: "Requested Maintenance",
            REQUESTED_MAINTAINANCE: "Requested Maintenance",
            SEARCH: "Search by ticket number",
            SERVICE_DATE: "Service Date",
            SERVICE_TICKET_NO: "Service Ticket Number",
            SERVICE_TYPE: "Service Type",
            SUPPORT_TECHNICIAN: "Support Technician",
            SYS_FAILURE: "System Failure",
            SYSTEM_FAILURE: "System Failure",
            TICKET_CLOSED: "Ticket Closed",
            TICKET_NO: "Ticket Number",
            STATUS: "Ticket Status:All",
            TODAY: "TODAY",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES:
                "You can only select up to 3 files.",
            EDIT_SERVICE_TICKET: "Edit Service Ticket",
            MAINTENANCE_OPERATIONS: "Maintenance Operations",
            SCHEDULED_MAINTENANCE: "Scheduled Maintenance",
            RECENT_MAINTENANCE: "Recent Maintenance",
            CLOSE_SERVICE_TICKET: "Close Service Ticket",
            CLOSE_TICKET: "Close Ticket",
            DESCRIBE_ACTION: "Describe actions taken to resolve the issue",
            TICKET_RESOLUTION: "Ticket Resolution",
            CLOSED_BY: "Closed by",
            SCHEDULED: "Scheduled",
            STATUS_SCHEDULED: "Scheduled",
            SCH_SERVICE_DATE: "Scheduled Service Date",
            TIME_RANGE_All: "Time Range: All",
            MAINTENANCE_TYPE_ALL: "Maintenance Type:All",
            ORGANIZATION_ALL: "Organization: All",
            CUSTOMER_All: "Customer:All",
            TICKET_NUMBER_ALL: "Ticket Number:All",
            SLA_ALL: "SLA:All",
            TECHNICIAN_ALL: "Technician:All",
            COMPLETED_7_DAYS: "Completed in the Last 7 Days",
            COMPLETED_30_DAYS: "Completed in the Last 30 Days",
            TECHNICAN: "Technican:",
            TICKET_NO_: "Ticket No.",
            NO_RECORD_FOUND: "No Record found",
            ADD_NOTES_TITLE: "Add Notes",
            NOTE_HELPER_TEXT: "Notes cannot be added to closed tickets",
            NOTE_255_CHAR: "Note cannot exceed 255 characters",
            NOTE_SPECIAL_CHAR: "Note cannot contain special characters",
            NOTES_PLACEHOLDER: "Enter Notes",
            SEARCH_BY_ASSET: "Search By Asset",
            SEARCH_BY_SLA: "Search By SLA",
            CREATE_MAINTENANCE_DIALOG_HEADER: "Who is this maintenance for?",
        },
        ASSETS_DETAILS: {
            ZONES_CONFIGURATION_UNSAVED_CHANGES: "You have unsaved changes on this page.",
            ADD_BUILDINGS: "+ Add Building",
            ADD_SYSTEMS: "+ Add System",
            NEW_MAINTAINENCE: "+ New Maintenance",
            BUILDINGS: "Buildings",
            CUSTOMER_MAINTAINENCE_HEADER: "Customer Details",
            CUSTOMER_INFO_HEADER: "Customer Info",
            DOWNLOAD_AS: "Download As…",
            FIRMWARE: "Firmware",
            GATEWAYS: "Gateways",
            LINK_TO_CUSTOMER_BUTTON: "Link to Customer",
            MAIN_CONTACT: "Main Contact",
            RIGHT_MAINTAINENCE_HEADER: "Maintenance Details",
            MOST_RECENT_STATUS: "Most recent status",
            NOTIFY_USERS_MAINTAINENCE_HEADER: "Notify Users:",
            SUBHEADER_TEXT_MAINTAINENCE:
                "Please review information, assign a technician, and include any helpful details for fixing the issue.",
            PREVIOUS_SYSTEM_STATUS: "Previous System Status",
            CREATE_MAINTAINENCE_HEADER: "Schedule a New Maintainance Operation",
            ADD_BUILDING_ASSET: "Select a organization to create a building",
            SELECT_ORGANIZATION_LABEL: "Select organization",
            SHOW_FAVORITE_BUILDINGS: "Show Starred Buildings Only",
            SHOW_FAVORITE_GATEWAYS: "Show Starred Gateways Only",
            SHOW_FAVORITE_SYSTEMS: "Show Starred Systems Only",
            SLA_SUBTITLE: "SLA#",
            LEFT_MAINTAINENCE_HEADER: "System Details",
            SYSTEM_NAME_TYPE_SUBTITLE: "System Name & Type",
            SYSTEMS: "Systems",
            HELPER_TEXT_MAINTAINENCE:
                "This request will alert {{customerName}} Primary & Secondary contacts. It will include relevant location, device, alarm, and event information by default.",
            NO_CUSTOMER_TEXT: "This system has not been linked to a customer",
            SLA: "SLA's",
            ADD_SLAS: "Add SLA",
            MAINTENANCE_TICKETS: "Maintenance Tickets",
            SCHEDULE_MAINTENANCE: "Schedule Maintenance",
            SHOW_FAVORITE_SLAS: "Show Starred SLAs Only",
            LINK_CUSTOMER_DIALOG_SEARCH: "Search Customer by Name",
            LINK_TO_CUSTOMER_DIALOG_HEADER: "Whose system is this?",
            LINK_TO_CUSTOMER_DIALOG_SECOND_HEADER:
                "What are the SLA details for this system?",
            BUILDING_INFO_HEADER: "Building Info",
            BUILDING_ADDRESS: "Address",
            BUILDING_OFFICE: "Office",
            BUILDING_OTHER_SYSTEMS: "Other systems",
            ALL_SYSTEMS_IN_BUILDING: "All Systems in this Building",
            ALL_CONTACTS_IN_BUILDING: "All People in this Building",
            DOWNLOAD_TOOLTIP: "Please select building or system",
            ADD_SLA: "+ New SLA",
            CREATE_NEW_CUSTOMER_BUTTON: "+ Create New Customer",
            TOTAL_SLA: "Total SLA",
            FOR_SYSTEM: "For Systems",
            FOR_BUILDING: "For Buildings",
            FIRE_PANELS: "Fire Panels",
            NO_FIRE_PANELS_FOUND: "No Fire Panels Found",
            SYSTEM_SLA_NO: 'System SLA Number',
            VIEW_ALL_SYSTEMS: 'View all Systems in this building',
            SLA_EXPIRATION: 'SLA Expiration',
            LUMINNAIRE_MONITORING: 'Luminaire Monitoring',
            ZONE_CONFIG_DESC: 'Give names and descriptions to zones to make it easier to identify them in your installation. (optional)',
            ZONE_NAME: 'Zone Name',
            PLACEHOLDER_TEXT: 'Please Enter',
            MANAGE_SYSTEM_SETUP: 'Manage System Setup',
            CONFIG_LUMNS_DECS: 'You can paste data from Excel to this table directly.',
            EPAS: 'EPAS',
            PRODUCT_FAMILY: 'Product Family',
            CATEGORY: 'Category',
            RATED_DURATION: 'Rated Duration',
            OPTIONAL_DESCRIPTION: 'Optional Description',
            SET_INPUT_DESCRIPTION: 'Configure and name Inputs. (optional)',
            SET_OUTPUT_DESCRIPTION: 'Configure and name Outputs. (optional)',
            SET_INPUT_NAME: 'Input Name',
            RELAY_NAME: 'Relay Name',
            BLOCK_THE_SYSTEM: 'Block the system',
            OPTIONAL_INPUTS: 'Optional Inputs',
            COMMUNICATION_METHOD: 'Communication Method',
            CONFIGURE_INPUT_FUNCTION: 'Configure Input Functions',
            CONFIGURE_RELAY_FUNCTION: 'Configure Relay Functions',
            RELAY: 'Relay 1',
            OPTIONAL_OUTPUTS: 'Optional Outputs',
            TEST_SCHEDULES: 'Test Schedules',
            SET_IP_OP: 'Set Input/Output',
            GROUP_TAB: 'Group',
            RESET_LUMN_GROUPS: 'Reset Luminaire Groups',
            TEST_GROUP_DESC: 'Use the “Test Group” column to reassign luminaires or the checkbox to reassign more than one luminaire at a time.',
            TEST_GROUP_INFO: 'Assign 25% of all luminaires to each test group randomly and evenly across all zones.',
            REASSIGN_TEST_GROUPS: 'Reassign Test Groups and Erase Previous Groupings?',
            REASSIGN_TEST_GROUPS_CONFIRM: 'All previous test group configuration will be erased.',
            ALL_GROUPS: 'All Groups',
            LUMINAIRES_ASSIGNED: 'Luminaires assigned to current groups',
            LUMINAIRES_ASSIGNED_OTHER: 'Luminaires assigned to other groups',
            TRANSFER_LUMINAIRES: 'Transfer Luminaires from',
            TEST_GROUP_INLINE_ERROR_MESSAGE: 'Test group is required',
            ZONE_INLINE_ERROR_MESSAGE: 'Zone is required',
            LUMINARY_NAME_INLINE_ERROR_MESSAGE: 'Luminaire name is required',
            LUMINARY_PRODUCT_INFORMATION: 'Product Information',
        },

        COMMON: {
            SYNC_NOW_TIME: "=--min ago",
            REQUIRES_FIRMWARE_UPDATE: "1 requires firmware update",
            NOTIFICATION_REPORT_MESSAGE_BODY:
                "A new monthly report for: \n {{bodytext}} is available to view",
            ACCESS: "Access",
            ACTIVE: "Active",
            ALERT: "Alert!",
            DOWNLOAD_PERMISSION: "Allow the permissions to save file to your device",
            GO_BACK: "GO BACk",
            NOTIFICATION_EVENT_OCCURED:
                "An {{logType}} has occurred with the following system",
            ASSETS: "Assets",
            BACK: "Back",
            BLOCKED: "BLOCKED",
            CANCEL: "Cancel",
            CANNOT_REFRESH_TOKEN: "Cannot refresh token",
            CLOSE: "Close",
            SET_ETHERNET: "Configure Port Settings",
            CONFIRM: "Confirm",
            CONNECT: "Connect",
            CONNECTION: "Connection",
            CSV: "CSV",
            DASHBOARD: "Dashboard",
            DISCARD: "Discard",
            DISCARD_UNSAVED_CHANGE: "Discard unsaved changes?",
            DONE: "Done",
            DOWNLOAD: "Download",
            DOWNLOAD_FAILED: "Download Failed, please try again",
            COMPANY: "Eaton",
            EDIT: "Edit",
            APP_NAME: "Building Safety Manager",
            EMPTY: "EMPTY",
            INTERVAL_SEVENDAYS: "Every 7 Days",
            INTERVAL_90DAYS: "Every 90 Days",
            EXCEL: "Excel File",
            EXIT: "Exit",
            EXTEND: "Extend",
            DOWNLOAD_SUCCESS: "File downloaded successfully.",
            ANOMALY: "IN ANOMALY",
            INACTIVE: "Inactive",
            INCOMPLETE: "Incomplete",
            INFO: "Info",
            INTERVAL: "Interval",
            KEEP_EDITING: "Keep Editing",
            LAST_RETRIEVED: "Last retrieved:",
            LINK: "Link",
            LOCATE: "Locate",
            LOGBOOK: "Logbook",
            LOGGED_IN_SUCCESSFULLY: "Logged In successfully",
            NOTIFICATION_NEW_REPORT_AVAILABLE: "New Report Available",
            NEWUSER: "New User",
            NODATA: "No Data",
            OFF: "off",
            OFFLINE: "Offline",
            OK: "Ok",
            ON: "on",
            PASSWORD: "Password",
            PDF: "PDF",
            SELECT_PREFERRED_LANGUAGE: "Please Select Your Preferred Language",
            POWERED_BY_BRIGHTLAYER: "Powered by Brightlayer",
            READY: "READY",
            RECOONECTTOGATWAY: "Reconnect To Gateway",
            REFRESH: "Refresh",
            REMOVE: "Remove",
            RETURNTODASHBOARD: "Return To Dashboard",
            NAVIGATION_HEADER: "Safety Management System",
            SAVE: "Save",
            REFRESH_TOKEN_ERROR: "Security token must not be null or empty",
            SESSION_ALERT_TITLE: "Session Timeout",
            SET: "Set",
            SETTINGS: "Settings",
            VIEW_ALL_SYSTEM: "Show All",
            SKIP: "Skip",
            STOP: "Stop",
            PERMISSION_ERROR: "Storage Permission Not Granted",
            SYNC: "Sync",
            SYNCH_OFFLINE_DATABASE: "Sync Offline Database",
            SYSTEM: "System",
            SESSION_ALERT_SUBTITLE:
                "This window has been inactive for 15 minutes.If no action is taken in {{extendTime}}, you will be logged out.",
            TIME: "Time",
            TRYAGAIN: "Try Again",
            DOWNLOAD_FAIL: "Unable to download,try again.",
            UNAUTHORIZED_ACCESS: "Unauthorized access",
            UNLINK: "Unlink",
            USERS: "Users",
            VIEW: "View",
            YES: "Yes",
            EMPTY_SYSTEM_TITLE: "You have no assets in this organization yet.",
            EMPTY_SYSTEM_SUBTITLE:
                "You will see status information about your emergency lights once you start adding assets (systems) to this organization.",
            ERROR_OCCURED: "Error ocurred in",
            OOPS: "Oops!'",
            THERE_IS_ERROR: "There's an error",
            NEW_VERSION_AVAILABLE: "New version of app avaialble in",
            UNDER_MAINTENANCE: "The app is currently under maintenance.",
            UNDER_MAINTENANCE_TITLE: "App Under Maintenance",
            UPDATE_AVAILABLE_TITLE: "Update available",
            UPDATE_REQUIRED_TITLE: "Update required",
            UPDATE_NOW: "Update now",
            ASK_ME_LATER: "Ask Me Later",
            OKTA_LOGOUT_ALERT: "Are you sure you want logout from okta?",
            OKTA_LOGIN_BUTTON: "Sign In with Okta",
            CANNOT_PROCCED_LOGIN: "You are an unauthorized user. Please signUp.",
            UNAUTHORIZED_ACCESS_OKTA: "Authorization Error",
            SCAN: "Scan",
            NO: "No",
            ACKNOWLEDGE: "Acknowledge",
            S: "s",
            HOURS: "hours",
            MINUTES: "minutes",
            SECONDS: "seconds",
            AGO: "ago",
            EVERY: "every",
            DAYS: "days",
        },
        PASSWORD_REQUIREMENTS: {
            LENGTH: "8-16 Characters",
            LOWER: "One lowercase letter",
            NUMBERS: "One number",
            SPECIAL: "One special character",
            UPPER: "One uppercase letter",
        },
        AUTH_TRANSLATION: {
            FORGOT_PASSWORD: {
                LINK_SENT_ALT:
                    "A link to reset your password has been sent to <1>{{email}}</1>.",
                LINK_SENT:
                    "A link to reset your password has been sent to <b>{{email}}</b>.",
                ERROR: "Could not reset your password at this time.",
                INSTRUCTIONS_ALT:
                    "Please enter the account email associated with the account.<br/><br/>" +
                    "If this email has an account with Safety Management Software, you will receive a response within <1>one business day</1>.<br/><br/>" +
                    "For urgent account issues, please call <4>{{phone}}</4>.",
                INSTRUCTIONS:
                    "Please enter the account email associated with the account.\n\n" +
                    "If this email has an account with Safety Management Software, you will receive a response within one business day.\n\n" +
                    "For urgent account issues, please call \n {{phone}}.",
                RESET_CODE_ERROR: "There was an error with your reset code. ",
            },
            MESSAGES: {
                USER_PHONE_NUMBER_INVALID: "A phone number is invalid",
                CONGRATS: "Congratulations!",
                CONTACT: "Contact an Eaton Support Representative",
                EMAIL_SENT: "Email Sent",
                ERROR: "Error!",
                FAILURE: "Failure",
                INVALID_VERIFICATION_CODE:
                    "Verification code is not valid or length should be less than 6 characters",
                LOADING: "Loading...",
                GENERIC_ERROR_MESSAGE:
                    "Please contact your administrator if the requested operation cannot be completed.",
                EMAIL_ENTRY_ERROR: "Please enter a valid email",
                USER_EMAIL_INVALID: "Please provide a valid email address.",
                REQUEST_ERROR: "Sorry, there was a problem sending your request.",
                SUCCESS: "Success",
                WELCOME: "Welcome",
                LOGIN_MESSAGE: "You are 'logged' in",
            },
            CHANGE_PASSWORD: {
                PROBLEM_OCCURRED: "A problem occurred:",
                CANCEL: "Cancel",
                PASSWORD: "Change Password",
                CONFIRM_NEW_PASSWORD: "Confirm New Password",
                OLD_PASSWORD: "Old Password",
                PASSWORD_CHANGED: "Password Changed",
                PASSWORD_INFO:
                    "Password must be at least 8 characters long, contain at least one uppercase character,one lowercase character, one number and one special character.",
                UPDATE: "Update",
                EMAIL_CONFIRM_MESSAGE:
                    "We have sent a confirmation email to <b>{{email}}</b>",
                ERROR_MESSAGE:
                    "Your information did not match our records. Please re- enter your information to try again.",
                SUCCESS_MESSAGE:
                    "Your password was successfully updated! To ensure your account's security, you will need to log in to the application with your updated credentials.",
            },
            SELF_REGISTRATION: {
                VERIFY_EMAIL: {
                    MESSAGE:
                        "A verification code has been sent to the email address you provided. Click the link or enter the code below to continue. This code is valid for 30 minutes.",
                    VERIFICATION_CODE_PROMPT: "Didn't receive a code?",
                    RESEND: "Resend Verification Email",
                    VERIFICATION: "Verification Code",
                },
                ALREADY_REGISTERED_USER: "Already registered user",
                INSTRUCTIONS:
                    "ToregisterforanEatonaccount,entertherequiredinformationbelow.Youwillneedtoverifyyouremailaddresstocontinue.",
            },
            REGISTRATION: {
                STEPS: {
                    COMPLETE: "Account Created!",
                    ACCOUNT_DETAILS: "Account Details",
                    COMPANY_ADDRESS: "Company Address",
                    COMPANY_DETAILS: "Company Details",
                    CREATE_ACCOUNT: "Create an Account",
                    PASSWORD: "Create Password",
                    LICENSE: "License Agreement",
                    VERIFY_EMAIL: "Verify Email",
                },
                INSTRUCTIONS: {
                    ACCOUNT_DETAILS:
                        "Enter your details below to complete account creation.",
                    COMPANY_DETAILS:
                        "This helps Eaton provide the service support for your emergency light solution. If you are initiating a project for your client, please put in the information for your own company, not your client’s.",
                    COMPANY_ADDRESS:
                        "This helps Eaton provide the service support for your emergency light solution. If you are initiating a project for your client, please put in the information for your own company, not your client’s.",
                },
                EULA: {
                    AGREE_TERMS: "I have read and agree to the Terms & Conditions",
                    LOADING: "Loading End User License Agreement...",
                    LANGUAGE: "Please Select Your Preferred Language",
                    LANGUAGE_SUCCESS: "Language Updated Successfully",
                    ENGLISH: "English",
                    DEUTSCH: "Deutsch",
                    FRENCH: "Français",
                    POLISH: "Polish",
                    CZECH: "Czech",
                    NORWEGIAN: "Norwegian",
                    SPANISH: "Spanish",
                    DUTCH: "Dutch",
                },
                UNKNOWN_EMAIL: "Unknown Email",
                UNKNOWN_ORGANIZATION: "-",
                FAILURE_MESSAGE:
                    "We were unable to complete your registration. Press continue below to finish.",
                SUCCESS_MESSAGE_ALT:
                    "Your account has been successfully created with the email <1>{{email}}</1>.Your account has already been added to the < 3 > {{ organization }} </3> organization.Press continue below to finish.",
                SUCCESS_MESSAGE:
                    "Your account has been successfully {{state}} with the email {{email}}.\n\nYou have been added to {{organization}} .',",
                SUCCESS_EXISTING:
                    "Your account has been successfully created. Please log in with your Eaton account email and password.",
                SUCCESS_SYNCED_MESSAGE:
                    "Your EL Digital account has successfully synced with the Bright Layer Cloud information associated with the email <b>{{email}}</b>.",
                SUCCESS_FINISH: "Please click Finish to login and access your account.",
                SUCCESS_DASHBOARD:
                    "Please click Go To My Dashboard to continue your account.",
            },
            ACTIONS: {
                BACK: "Back",
                CANCEL: "Cancel",
                CHANGE_LANGUAGE: "Change Language here!",
                CLICK_BUTTON: "Click the button",
                UPDATE_REDUX: "Click the button to update the redux store value!",
                CONTINUE: "Continue",
                DONE: "Done",
                FINISH: "Finish",
                GO_HOME: "Go to Home",
                GO_DASHBOARD: "Go To My Dashboard",
                GO_TEST: "Go to Test Page",
                LOG_IN: "Log In",
                LOG_OUT: "Log Out",
                NEXT: "Next",
                OKAY: "Okay",
                REMEMBER: "Remember me",
                RESEND: "Resend",
                SEND_AGAIN: "Send Again",
                SEND_EMAIL: "Send Email",
                CREATE_ACCOUNT: "Sign Up",
                UPDATE: "Update",
                LINK_SYSTEM: "Link System",
                OR: "OR",
            },
            FORMS: {
                COMPANY_NAME: "Company Name",
                CONFIRM_PASSWORD: "Confirm Password",
                COUNTRY: "Country",
                CURRENT_PASSWORD_ERROR: "Current Password do not match",
                FIRST_NAME: "First Name",
                RESET_PASSWORD: "Forgot Password",
                LAST_NAME: "Last Name",
                ORGANAIZATION_ADRESS: "Organization Address Line 1*",
                PASSWORD: "Password",
                PASS_MATCH_ERROR: "Passwords do not match",
                PHONE_NUMBER: "Phone Number",
                TOGGLE_PASSWORD_VISIBILITY: "Toggle password visibility",
            },
            LABELS: {
                CURRENT_PASSWORD: "Current Password",
                EMAIL: "Email Address",
                FORGOT_PASSWORD: "Forgot your password ?",
                NEED_ACCOUNT: "Need an account?",
                NEW_PASSWORD: "New Password",
                OPTIONAL: "Optional",
                PASSWORD: "Password",
                USERNAME: "Username",
            },
            LOGIN: {
                INCORRECT_CREDENTIALS: "Incorrect Email or Password",
                GENERIC_ERROR: "Your request could not be processed at this time.",
                INVALID_CREDENTIALS:
                    "Your username/password combination is not recognized.",
            },
            GATEWAY_COMMISSION_STEP: {
                STEP_NUMBER: "Step {{stepNo}} of 4",
            },
        },
        REGISTRATION: {
            STEPS_MESSAGE: {
                CREATE_ACCOUNT_VERIFY_EMAIL:
                    "A verification code has been sent to the email address you provided. Click the link or enter the code below to continue. This code is valid for 30 minutes.",
                CREATE_ACCOUNT_USER_DETAILS:
                    "Enter your details below to complete account creation.",
                CREATE_ACCOUNT_COMPANY_DETAILS:
                    "This helps Eaton provide the service support for your emergency light solution. If you are initiating a project for your client, please put in the information for your own company, not your client’s.",
                CREATE_ACCOUNT_ENTER_EMAIL:
                    "To register for an account for Safety Management System, enter the required information below. You will need to verify your email address to continue.",
            },
            STEPS: {
                COMPLETE_OTHER_ADOPTER: "Account Confirmed!",
                COMPLETE: "Account Created!",
                ACCOUNT_DETAILS: "Account Details",
                COMPANY_ADDRESS: "Company Address",
                COMPANY_DETAILS: "Company Details",
                CREATE_ACCOUNT: "Create an Account",
                PASSWORD: "Create Password",
                FORGOT_PASSWORD: "Forgot Password",
                LICENSE: "License Agreement",
                VERIFY_EMAIL: "Verify Email",
            },
            STEPS_ERROR_MESSAGE: {
                USER_ALREADY_EXIST_MESSAGE: "Already registered user",
                USER_INVALID_ENTRY: "Input parameters cannot be null or empty.",
                GENERIC_ERROR_MESSAGE:
                    "Please contact your administrator if the requested operation cannot be completed.",
                USER_EMAIL_INVALID: "Please provide a valid email address.",
                VERIFICATION_CODE_EXPIRED_MESSAGE:
                    "The code has expired. Please click the button below to request for another verification email.",
                USER_PHONE_NUMBER_INVALID: "A phone number is invalid",
            },
            EULA: {
                AGREE_TERMS: "I have read and agree to the Terms & Conditions",
                LOADING: "Loading End User License Agreement...",
                LANGUAGE: "Please Select Your Preferred Language",
                LANGUAGE_SUCCESS: "Language Updated Successfully",
                ENGLISH: "English",
                DEUTSCH: "Deutsch",
                FRENCH: "Français",
                POLISH: "Polish",
                CZECH: "Czech",
                NORWEGIAN: "Norwegian",
                SPANISH: "Spanish",
                DUTCH: "Dutch",
            },
            FAILURE_MESSAGE:
                "We were unable to complete your registration. Press continue below to continue to Eaton ELDigital suite",
            SUCCESS_MESSAGE:
                "Your account has been successfully created with the email {{email}}.",
            SUCCESS_MESSAGE_OTHER_ADOPTER:
                "Your EL Digital account has successfully synced with the Bright Layer Cloud information associated with the email <2>{{email}}</2>.",
        },
        VERIFY_EMAIL: {
            EMAIL_INFO:
                "A verification code has been sent to the email address you provided. Click the link or enter the code below to continue. This code is valid for 30 minutes.",
        },
        USER_INVITATION_REGISTRATION: {
            ACCEPT: "Accept",
            DENY: "Deny",
            INSTRUCTIONS:
                "If this email has an account with Eaton, you will receive a response within <3>one business day</3>.<br/><br/>For urgent account issues, please call ",
            TITLE: "Safety Management System - User Invitation",
            INVITATION_VALIDATION_ERROR:
                "There was an error with your invitation code. ",
        },
        DASHBORAD: {
            ACCEPT_BUTTON: "Accept Invitation",
            ACCEPT_HEADER: "Accept Invitation?",
            ACCEPTED_INVITATION: "Accepted Invitations",
            ACCEPT_TITLE:
                "Accepting the invite will add the following item to your profile:",
            ADD_NEW_ORGANIZATION: "Add a New Organization...",
            ADD_ANOTHER_ORGANIZATION: "Add Another Organization",
            ALL_BUILDINGS: "All Buildings",
            ALL_CITIES: "All Cities",
            ALL_COMPANIES: "All Companies",
            ALL_COUNTRIES: "All Countries",
            ALL_CUSTOMER_ID: "All Customer ID",
            ALL_GATEWAYS: "All Gateways",
            ALL_STATUSES: "All Status",
            ALL_STATUS: "All Statuses",
            ALL_TYPES: "All Types",
            BLOCKED: "Blocked",
            BUILD_DETAILS: "Building Details",
            BUILDINGS: "Buildings",
            CUSTOMERS: "Customers",
            DECLINE: "Decline",
            DECLINED_INVITATION: "Declined Invitations",
            DISPLAY_ADDRESS_ON_MAP: "Display address on map",
            MAP_DRAG_TITLE: "Drag on the map to place the pin",
            REQUEST_ACCESS_SENT: "Email request access invite sent to user",
            ERROR: "Error",
            EVENT: "Event",
            EXPIRED_INVITATION: "Expired Invitations",
            EXPORT_REPORT: "Export Report",
            GATEWAY: "Gateways",
            IN_ANOMALY: "In Anomaly ",
            INFORMATION: "Information",
            INVITATION_HISTORY: "Invitation History",
            ISSUES: "issues",
            JOIN: "Join",
            LIST_VIEW: "List View",
            MAP_VIEW: "Map View",
            MONTHLY_REPORT: "Monthly Report",
            NO_ISSUES_DURING_THIS_PERIOD: "No issues during this period",
            ORG_DETAILS: "Organization Details",
            PENDING_INVITATION: "Pending Invitations",
            CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE:
                "Please choose the report you would like to save or share.",
            PLEASE_MAKE_A_SELECTIONS: "Please Make A Selection",
            REQUEST_SUBTITLE:
                "Please request access from the person who sent the invite to add this item to your profile.",
            INVITATION_BODY:
                "Please select items to add to your profile or to decline an invitation.",
            READY: "Ready",
            NO_CONTENT: "Replace this page with your own content",
            REPORTS: "Reports",
            REQUEST_BUTTON: "Request Access",
            REQUEST_HEADER: "Request Access?",
            CHECK_INVITATIONS: "Scanning for invitations... ",
            SELECT_ALL: "Select All",
            SELECTIONS_CONFIRMED: "Selections Confirmed",
            SERVICE_MANAGERS: "Service Managers",
            SYSTEMS: "Systems",
            TECHNICIANS: "Technicians",
            EMPTY_ACCEPTED_INVITATION: "There are no accepted invitations at this time",
            EMPTY_DECLINED_INVITATION: "There are no denied invitations at this time",
            EMPTY_EXPIRED_INVITATION: "There are no expired invitations at this time",
            EMPTY_REQUESTED_INVITATION:
                "There are no requested invitations at this time",
            REQUEST_TITLE:
                "This invitation has expired and can no longer be added to your profile.",
            TOTAL_ACCEPTED_INVITATIONS: "Total Accepted Invitations",
            TOTAL_LUMINAIRES: "Total Luminaires",
            TOTAL_SYSTEMS: "Total Systems",
            UPDATING_PROFILE: "Updating Your Profile...",
            VIEW_ALL: "View All",
            VIEW_ALL_ACCESS_RIGHTS: "View All Access Right",
            VIEW_ALL_BUIDINGS: "View All Buildings",
            VIEW_ALL_SYSTEM: "View All Systems",
            WARNING: "Warning",
            INVITATION_SUB_HEADING: "You have been invited to the following projects:",
            REPORTS_BUILDINGS: "Buildings",
            REPORTS_SYSTEMS: "Systems",
        },
        TRANSFER_BUILDINGS: {
            PASSWORD: "Account Password",
            ERRORMESSAGE: "Login limits exceeded. please try again after sometime",
            HEADER:
                "Permanently transfer all {{buildingCount}} buildings, including all the X gateways and {{systemCount}} systems under it, to another organization. You must be organization admins on both organization to perform the action.",
            ACTION: "Please type your account password to confirm the action.",
            TRANSFER_TO: "Transfer To…",
        },
        DRAWER: {
            ACCOUNTPREFERENCES: "Account Preferences",
            RIGHTS_RESERVED: "All Rights Reserved",
            ASSETS: "Assets",
            COPYRIGHT: "Copyright © Eaton",
            DASHBOARD: "Dashboard",
            OVERVIEW: "Dashboard",
            DEVICES: "Devices",
            HELP: "Help",
            HELPANDFEEDBACK: "Help and Feedback",
            LEGAL: "Legal",
            LOCATIONS: "Locations",
            LOGBOOK: "Logbook",
            MAINTENANCE: "Maintenance",
            MANAGELOCATION: "Manage Locations and Sites",
            MANAGEUSER: "Manage Users",
            ORGSETTINGS: "My Organizations",
            MYPROFILE: "My Profile",
            REPORTS: "Reports",
            ELDIGITAL: "Safety Management System",
            SELECT_ACCOUNT: "Select Account",
            SETTINGS: "Settings",
            TIMELINE: "Timeline",
            USERS: "Users",
        },
        SETTINGS: {
            TITLE: "Account Preferences",
            SUBTITLE: "Admin Level - Users",
        },
        USER_MENU: {
            ACCOUNT_SETTING: "Account Settings",
            CONTACT_US: "Contact Us",
            LOG_OUT: "Log Out",
        },
        USER_DETAIL: {
            ACTIVE: "ACTIVE",
            COMPANY_ADRESS: "Company Address",
            COMPANY_DETAIL: "Company Details",
            COMPANY_NAME: "Company Name",
            COMPANY_PHONE_NUMBER: "Company Phone Number",
            EMAIL_ID: "Email Address",
            INACTIVE: "INACTIVE",
            PERSONAL_ADRESS: "job titile",
            LEAVE_ORGANISATION: "Leave Organization",
            JOB_TITLE: "Personal Address",
            PERSONAL_PHONE_NUMBER: "Personal Phone Number",
            PHONE_NUMBER: "Phone Number",
            REMOVE_USER: "Remove User",
            USER_NAME: "User Name",
        },
        FILTER: {
            ACTIVE_LOGS_ONLY: "Active Logs Only",
            ALL: "All",
            ALL_LOG_TYPES: "All Log Types",
            CUSTOM: "Custom...",
            PAST_TWELVE_MONTHS: "Past 12 months",
            PAST_SIX_MONTHS: "Past 6 months",
            SINCE_THE_BEGINNING_OF_YEAR: "Since Beginning of {{currentyear}}",
        },
        LOGBOOK: {
            LOGBOOK_ACTIVELOG: "Active Logs Only",
            LOGBOOK_ALL: "All",
            LOGBOOK_ALLLOG: "All Log Types",
            CUSTOM_LOGBOOK_RANGE: "Custom Logbook Range",
            CUSTOM: "Custom...",
            END_DATE: "End Date",
            LOGBOOK_GROUPBY: "Group By :",
            PAST_TWELVE_MONTHS: "Past 12 months",
            PAST_SIX_MONTHS: "Past 6 months",
            FILTER_DOWNLOAD_TEXT: "Please apply a filter to download the logbook.",
            LOGBOOK_SHOW: "Show :",
            SINCE_THE_BEGINNING_OF_YEAR: "Since Beginning of {{currentyear}}",
            START_DATE: "Start Date",
            LOGBOOK_TIME_RANGE: "Time Range :",
        },
        BUILDING_DETAILS: {
            ADD_BUILDING: "Add Building to",
            ALL_SYSTEMS: "All Systems",
            VIEW_ALL_GATEWAYS: "View All Gateways",
        },
        ADD_ORGANIZATION: {
            ORG_ADD_DESCRIPTION:
                "Add optional additional comments to aid your service team.",
            ADDITIONAL_DESC: "Additional Description",
            ORG_ADD_BLDG_BELONGS: "belongs.",
            CREATE_ORGANIZATION_TITLE: "Create Organization",
            ORG_SUBTITLE:
                "Creating an organization allows you to group buildings and coordinate the supervision of EL Systems.",
            DETAILS_FOR: "Details for",
            ORG_FOR: "for",
            INVALID_CHARACTER: "Invalid character",
            ORG_NAMELENGTH: "Letters, numbers, underscores & dashes only 	  	 ",
            ORG_ADD_BLDG: "Now let’s add the building where the ",
            ORGANIZATION_CREATED: "Organization Created",
            VALID_EMAIL_ERROR: "Please enter a valid email",
            ORG_PRIMARYCONTACT: "Primary Contact",
            ORG_PROVIDED_DETAILS: "Provide details in case xxx is necessary.",
            ORG_SECONDARYCONTACT: "Secondary Contact (Optional)",
            ORG_SKIPBUTTON: "Skip For Now",
            ORG_SKIPMESSAGE:
                "Skip to fill in contact details individually for each building.",
            ORG_SUCCESS: "Successfully created organization",
            ALPHABET_INPUT: "Takes Alphabet as Input",
            ALPHANUMERIC_INPUT: "Takes Alphanumeric as Input",
            ALPHANUMERIC_DASH_UNDERSCORE_INPUT:
                "Takes Alphanumeric, dash, underscore as Input",
            ORG_HELPTEXT:
                "This helps electricians from Eaton and others outside your company to quickly arrive on site.",
            ORGANIZATION_DETAILS: "Who shall electricians reach out about",
        },
        MANAGE_USERS: {
            ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: "Add them to organizations:",
            INVITE_USER_ORGANIZATION_LABEL: "Add to organization... *",
            USER_ROLE_ADMIN: "Admin",
            ADVANCED_INVITE_ADMIN: "Admin: ",
            ADVANCED_INVITE: "Advanced Invite",
            INVITE_USER_ADVANCE: "Advanced...",
            INVITE_USER_AS: "As",
            ADVANCED_INVITE_USER_SELECTION: "Choose a new or existing user:",
            INVITE_USER_EMAIL_NAME: "Email *",
            INVITE_USER_EMAIL: "Email *",
            INVITE_USER_EMAIL_USER_NAME: "Email or user name *",
            INVITE_USER_SUBTITLE: "Grant access to new or existing users",
            ADVANCED_INVITE_SUBTITLE:
                "Grant access to specific organizations, buildings, and systems.",
            ADVANCED_INVITE_ADMIN_DESCRIPTION:
                "grant full access to everything within the assigned level.",
            ADVANCED_INVITE_LIMITED_DESCRIPTION:
                "grant minimum viewing privileges so that a user only sees basic information for what is critical to their role. This is useful when someone only needs to monitor one system within a building.",
            ADVANCED_INVITE_VIEWER_DESCRIPTION:
                "grant viewing privileges to everything within an assigned level.",
            INVITATION_FAIL_HEADER: "Invitation Expired",
            INVITE_USER_AS_COLLEAGUE: "Invite as colleague",
            INVITE_USER: "Invite User",
            INVITE_SUCCESS_MESSAGE_SINGLE: "Invited {{email}} to {{organization}}.",
            INVITE_SUCCESS_MESSAGE_MULTIPLE:
                "Invited {{email}} to {{organizationCount}} organizations.",
            USER_ROLE_LIMITED: "Limited",
            ADVANCED_INVITE_LIMITED: "Limited: ",
            MY_DETAILS_HEADER: "My Details",
            OTHER_USER_LIST_HEADER: "Other Users ",
            ADVANCED_INVITE_PLEASE_ASSIGN_ROLES:
                "Please assign roles for {{email}} access to organizations, buildings and systems.",
            REMOVE_USER: "Remove {{name}} from {{title}} ?",
            INVITATION_REQUEST_ACTION: "Request Another Invitation",
            INVITE_USER_ORGANIZATION_SELECT_ALL: "Select All",
            INVITE_USER_SEND_INVITE: "Send Invite",
            INVITATION_FAIL_BODY:
                "This email invitation link has expired. Please contact your system admin to get another email invitation.",
            USERS_IN_HEADER: "Users in ",
            USER_ROLE_VIEWER: "Viewer",
            ADVANCED_INVITE_VIEWER: "Viewer: ",
            NOT_APPLICABLE: "NA",
            NOT_APPLICABLE_SLASH: "N/A",
            INVITE_USER_DO_NOT_ASSIGN: "Do not assign at this time",
        },
        ORGANIZATION_DETAILS: {
            ADDRESS: "Address",
            BUILDING_DETAILS: "Building Details",
            DELETE_FOREVER: "Delete Forever",
            EDIT_BUILDING: "Edit Building",
            EDIT_ORGANIZATION: "Edit Organization",
            EMAIL_ADDRESS: "Email Address",
            MERGE_ASSETS: "Merge Assets To Another Building",
            ORGANIZATION: "Organization",
            ORGANIZATION_DETAILS: "Organization Details",
            PHONE_NUMBER: "Phone Number",
            PRIMARY_CONTACT: "Primary Contact",
            PRIMARY_CONTACT_EMAIL_ADDRESS: "Primary Contact Email Address",
            PRIMARY_CONTACT_PHONE_NUMBER: "Primary Contact Phone Number",
            SECONDARY_CONTACT: "Secondary Contact",
            SECONDARY_CONTACT_EMAIL_ADDRESS: "Secondary Contact Email Address",
            SECONDARY_CONTACT_PHONE_NUMBER: "Secondary Contact Phone Number",
            TRANSFER_BUILDINGS: "Transfer Buildings to Another Organization",
            USERS: "Users",
        },
        COMMON_INPUT: {
            COMMON_ADDRESS: "Address",
            COMMON_ADDRESSLINE2: "Address Line 2 (Optional)",
            COMMON_BUILDINGNAME: "Building Name",
            COMMON_CITY: "City",
            COMMON_COUNTRY: "Country",
            COMMON_OPTIONALDESC: "Description (Optional)",
            COMMON_EMAIL_ADDRESS: "Email Address",
            COMMON_NAME: "Organization Name",
            COMMON_PHONENUMBER: "Phone Number",
            VALID_ADDRESS: "Please enter a valid address",
            VALID_PHONE_ERROR: "Please enter a valid phone number",
            VALID_POSTAL_CODE: "Please enter a valid postal code",
            VALID_FIRSTNAME_ERROR: "Please enter valid first name",
            VALID_LASTNAME_ERROR: "Please enter valid last name",
            VALID_VERIFICATION_CODE: "Please enter valid verification code",
            COMMON_POSTALCODE: "Postal Code",
            VALID_CITY_ERROR: "Please enter valid city",
            VALID_COMPANY_ERROR: "Please enter valid company",
        },
        TOAST_MSG: {
            CREATE_CUSTOMER_ERROR_CODE_9069:
                "Address  is not valid or length should be less than or equal to 250 characters",
            CREATE_CUSTOMER_ERROR_CODE_9070:
                "Address2 is not valid or length should be less than or equal to 250 characters",
            INVITE_TECHNICIAN_ERROR_CODE_9130: "Admin rights required to invite user",
            INVITE_USER_ERROR_CODE_9130: "Admin rights required to invite user.",
            TOAST_ERROR_MERGE_ASSET_9213: "Admin Rights required to merge assets",
            TOAST_SUCCESS_BUILDING_CREATE: "Building created successfully",
            BUILDING_LIST_API_FAILURE: "Building listing failed",
            BUILDING_TRANSFER_FAILURE: "Building transfer encountered an error",
            BUILDING_TRANSFER_SUCCESS: "Building transfer successfully",
            TOAST_SUCCESS_BUILDING_UPDATE: "Building updated successfully",
            INVITE_USER_ERROR_CODE_9143: "Cannot degrade the user role.",
            CREATE_CUSTOMER_ERROR_CODE_9072:
                "City is not valid or length should  be less than or equal to 50 characters",
            CREATE_CUSTOMER_ERROR_CODE_9164:
                "Company comment is not valid or length should be less than or equal to 255 characters.",
            CREATE_CUSTOMER_ERROR_CODE_9040: "Company country code is not valid",
            CREATE_CUSTOMER_ERROR_CODE_9170: "Company name already available.",
            CREATE_CUSTOMER_ERROR_CODE_9023:
                "Company phone number is not valid or length shoud be between 8 and 10",
            CREATE_CUSTOMER_ERROR_CODE_9073:
                "Country code is not valid or length should  be less than or equal to 4 characters",
            CREATE_CUSTOMER_ERROR_CODE_9068:
                "Country is not valid or length should be less than or equal to 50 characters",
            CREATE_MAINTAINANCE_API_FAILURE: "Create Maintainance api failed",
            TOAST_SUCCESS_CUSTOMER_CREATED: "Customer created successfully",
            CUSTOMER_DETAIL_SUCCESS: "Customer detail retrieved successfully",
            TOAST_ERROR_GET_CUSTOMER_INFO: "Customer details retrieval unsuccessful",
            CREATE_CUSTOMER_ERROR_CODE_9225: "Customer Number already available.",
            CREATE_CUSTOMER_ERROR_CODE_9172:
                "Customer Number is not valid or length should be between 8 and 16 characters.",
            CREATE_MAINTAINANCE_ERROR_CODE_9078:
                "Description is not valid or length should be less than or equal to 255 characters",
            DEVICE_LIST_API_FAILURE: "Device listing failed",
            ACKNOWLEDGE_LOG_SUCCESS: "Device log details acknowledged successfully",
            CREATE_CUSTOMER_ERROR_CODE_9043:
                "Email is not valid or length should  be less than or equal to 75 characters",
            INVITE_TECHNICIAN_ERROR_CODE_9043:
                "Email is not valid or length should be less than or equal to 75 characters",
            INVITE_USER_ERROR_CODE_9043:
                "Email is not valid or length should be less than or equal to 75 characters",
            INVITE_TECHNICIAN_ERROR_CODE_9136:
                "Entity or role type is not valid input or mismatch in entity type and role type",
            INVITE_USER_ERROR_CODE_9136:
                "Entity or role type is not valid input or mismatch in entity type and role type.",
            INVITE_TECHNICIAN_ERROR_CODE_9127:
                "EntityId is duplicate or not valid input",
            INVITE_USER_ERROR_CODE_9127: "EntityId is duplicate or not valid input",
            TOAST_ERROR_BUILDING_UPDATE: "Failed to execute building update ",
            CREATE_MAINTAINANCE_ERROR_CODE_9219:
                "File name is not valid or length should be less than or equal to 50 characters",
            TOAST_ERROR_GET_PASS_DETAILS: "Get PAAS details api failed",
            REMOVE_ACCESS_ERROR_CODE_3057:
                "Invalid entity Id. Please provide valid entity Id",
            REMOVE_ACCESS_ERROR_CODE_3059:
                "Invalid entity type. Please provide valid entity type",
            TOAST_ERROR_LINK_CUSTOMER_9203: "Invalid SLA TYPE Enum.",
            REMOVE_ACCESS_ERROR_CODE_2007: "Invalid user id, please provide valid GUID",
            INVITE_TECHNICIAN_ERROR_CODE_9159:
                "Invite and invited by user should not be same",
            INVITE_USER_ERROR_CODE_9159:
                "Invite and invited by user should not be same",
            UPDATE_LOG_COMMENTS_SUCCESS: "Log comments updated successfully",
            ACKNOWLEDGE_LOG_API_FAILURE: "Logs acknowledgment unsuccessful",
            CREATE_MAINTAINANCE_SUCCESS: "Maintenance activity created successfully",
            TOAST_ERROR_MERGE_ASSET_9214: "No assets to merge",
            CREATE_MAINTAINANCE_ERROR_CODE_9221:
                "Number of document should be less than or equal to 3",
            TOAST_SUCCESS_ORG_CREATE: "Organization created successfully",
            TOAST_ERROR_ORG_UPDATE: "Organization failed",
            TOAST_SUCCESS_ORG_UPDATE: "Organization updated successfully",
            CREATE_CUSTOMER_ERROR_CODE_9074:
                "Phone number is invalid or length should be between 8 and 10.",
            TOAST_ERROR_MESSAGE:
                "Please fill all the details properly before submission",
            CREATE_MAINTAINANCE_ERROR_CODE_9220:
                "Please provide valid assignedTo technician user id",
            TOAST_ERROR_MERGE_ASSET_9048: "Please provide valid building id.",
            CREATE_CUSTOMER_ERROR_CODE_9167: "Please provide valid contact type.",
            CREATE_MAINTAINANCE_ERROR_CODE_9185: "Please provide valid customer id",
            TOAST_ERROR_MERGE_ASSET_9210:
                "Please provide valid destination building id.",
            CREATE_MAINTAINANCE_ERROR_CODE_9217: "Please provide valid link",
            CREATE_CUSTOMER_ERROR_CODE_9163:
                "Please provide valid name or length should be less than or equal to 24 characters",
            CREATE_MAINTAINANCE_ERROR_CODE_9215: "Please provide valid request type",
            CREATE_MAINTAINANCE_ERROR_CODE_9228: "Please provide valid service date",
            CREATE_MAINTAINANCE_ERROR_CODE_9216: "Please provide valid service type",
            CREATE_MAINTAINANCE_ERROR_CODE_9050: "Please provide valid system Id",
            CREATE_CUSTOMER_ERROR_CODE_9071:
                "Postal code is not valid or length should be between 4 and 10 characters",
            CREATE_CUSTOMER_ERROR_CODE_9165:
                "Primary contact comment is not valid or length should be less than or equal to 255 characters.",
            CREATE_CUSTOMER_ERROR_CODE_9175:
                "Primary countrycode2 is not valid or length should be less than or equal to 4 characters",
            CREATE_CUSTOMER_ERROR_CODE_9150:
                "Primary first name is not valid or length should be between 1 and 50 characters",
            CREATE_CUSTOMER_ERROR_CODE_9151:
                "Primary last name is not valid or length should be between 1 and 50 characters",
            CREATE_CUSTOMER_ERROR_CODE_9173:
                "Primary phone2 is invalid or length should be between 8 and 10.",
            REMOVE_ACCESS_SUCCESS: "Remove user completed successfully",
            TOAST_ERROR_MERGE_ASSET_9004: "Requested data not found",
            CREATE_CUSTOMER_ERROR_CODE_9166:
                "Secondary contact comment is not valid or length should be less than or equal to 255 characters.",
            CREATE_CUSTOMER_ERROR_CODE_9076:
                "Secondary country code is not valid or length should  be less than or equal to 4 characters",
            CREATE_CUSTOMER_ERROR_CODE_9176:
                "Secondary countrycode2 is not valid or length should be less than or equal to 4 characters",
            CREATE_CUSTOMER_ERROR_CODE_9077:
                "Secondary email is not valid or length should  be less than or equal to 75 characters",
            CREATE_CUSTOMER_ERROR_CODE_9152:
                "Secondary first name is not valid or length should be between 1 and 50 characters",
            CREATE_CUSTOMER_ERROR_CODE_9153:
                "Secondary last name is not valid or length should be between 1 and 50 characters",
            CREATE_CUSTOMER_ERROR_CODE_9147:
                "Secondary phone number is invalid or length should be between 8 and 10.",
            CREATE_CUSTOMER_ERROR_CODE_9174:
                "Secondary phone2 number is invalid or length should be between 8 and 10.",
            CREATE_MAINTAINANCE_ERROR_CODE_9009:
                "Security token must not be null or empty",
            CREATE_MAINTAINANCE_ERROR_CODE_9222:
                "Service Manager rights required to create maintenance activity",
            CREATE_MAINTAINANCE_ERROR_CODE_9162:
                "SLA Number is not valid or length should be between 6 and 12 characters",
            INVITE_TECHNICIAN_ERROR_CODE_9158:
                "Some entities have limited role from invitedby roles",
            INVITE_USER_ERROR_CODE_9158:
                "Some entities have limited role from invitedby roles.",
            INVITE_TECHNICIAN_ERROR_CODE_9160:
                "Some entities have limited role in invite request",
            INVITE_USER_ERROR_CODE_9160:
                "Some entities have limited role in invite request.",
            TOAST_ERROR_MERGE_ASSET_9211:
                "Source and Destination building Ids are same",
            TOAST_ERROR_MERGE_ASSET_9212:
                "Source building and Destination building are not under same Organization",
            TOAST_ERROR_LINK_CUSTOMER_9204: "System already linked to valid SLA",
            INVITE_USER_ERROR_CODE_9223:
                "The current user can only send invite to Normal user.",
            INVITE_USER_ERROR_CODE_9224:
                "The current user cannot send invite to Service manager and PAAS Maanger.",
            CREATE_MAINTAINANCE_ERROR_CODE_9218:
                "The document is greater than 2MB or duplicate or invalid Base64 encoded PDF, JPEG, or PNG",
            REMOVE_ACCESS_ERROR_CODE_9001: "Unauthorized access",
            CREATE_CUSTOMER_ERROR_CODE_9001: "Unauthorized access",
            CREATE_MAINTAINANCE_ERROR_CODE_9001: "Unauthorized access",
            CREATE_CUSTOMER_ERROR_CODE_9000: "Unauthorized feature access",
            UPDATE_LOG_COMMENTS_API_FAILURE: "Update log comments failed",
            REMOVE_ACCESS_ERROR_CODE_3060: "User cannot remove self access",
            REMOVE_ACCESS_ERROR_CODE_2023: "Please check the user access at higher level",
            TOAST_ERROR_UPDATE_USER_DETAILS: "User detail update unsuccessful",
            INVITE_USER_ERROR_CODE_9142: "User has been invited for the same role.",
            INVITE_TECHNICIAN_SUCCESS: "User Invite Send successfully",
            TOAST_ERROR_MERGE_ASSET_9044:
                "User password is not valid or length should be between 8 and 16 characters",
            INVITE_TECHNICIAN_ERROR_CODE_9190: "User role type is not valid input",
            INVITE_USER_ERROR_CODE_9190: "User role type is not valid input.",
            TOAST_SUCCESS_UPDATE_USER_DETAILS: "User updated successfully",
            UPDATE_MAINTAINANCE_SUCCESS: "Maintenance activity updated successfully",
            UPDATE_MAINTAINANCE_ERROR_CODE_9001: "Unauthorized access",
            UPDATE_MAINTAINANCE_ERROR_CODE_9009:
                "Security token must not be null or empty",
            UPDATE_MAINTAINANCE_ERROR_CODE_9078:
                "Description is not valid or length should be less than or equal to 255 characters.",
            UPDATE_MAINTAINANCE_ERROR_CODE_9222:
                "Service Manager or Technician rights are required to perform this operation",
            UPDATE_MAINTAINANCE_ERROR_CODE_9227: "Please provide valid maintenance id",
            UPDATE_MAINTAINANCE_ERROR_CODE_9245:
                "Maintenance activity already has the same current ticket status as requested for update",
            UPDATE_MAINTAINANCE_ERROR_CODE_9246:
                "Maintenance activity reopen limit reached",
            UPDATE_MAINTAINANCE_API_FAILURE: "Update Maintainance api failed",
            TICKET_CLOSED_SUCCESS: "Service ticket closed successfully",
            MARK_AS_FAV_API_SUCCESS: "Added to favorite successfully",
            MARK_AS_FAV_API_FAILED: "Mark as fav API failed",
            REMOVE_MARK_AS_FAV_API_SUCCESS: "Removed from favorite successfully",
            REMOVE_MARK_AS_FAV_API_FAILED: "Remove mark as fav API failed",
            TOAST_SUCCESS_LINK_CUSTOMER_DIALOG:
                "Customer information linked to system successfully",
            INVITE_TECHNICIAN_ERROR_CODE_9233: "Invite user is already technician.",
            INVITE_TECHNICIAN_ERROR_CODE_9224:
                "The current cannot send invite to Service manager and PAAS Maanger.",
            INVITE_TECHNICIAN_ERROR_CODE_9223:
                "The current user can only send invite to Normal user.",
            INVITE_TECHNICIAN_ERROR_CODE_9234:
                "Invite user is already mapped to another platform.",
            INVITE_TECHNICIAN_ERROR_CODE_9142: "Invite request failed.",
            REMOVE_TECHNICIAN_SUCCESS: "Technician removed successfully",
            REMOVE_SERVICE_USER_ERROR_CODE_2007:
                "Invalid user id, please provide valid GUID",
            REMOVE_SERVICE_USER_ERROR_CODE_9131: "UserType is not valid input.",
            REMOVE_SERVICE_USER_ERROR_CODE_9001: "Unauthorized access",
            REMOVE_SERVICE_USER_ERROR_CODE_3060: "User cannot remove self access",
            REMOVE_SERVICE_USER_ERROR_CODE_9238:
                "Cannot delete, as the deleting user is the last user with this role under platform",
            REMOVE_SERVICE_USER_ERROR_CODE_9235: "User type is mismatch with user.",
            REMOVE_SERVICE_USER_ERROR_CODE_9239:
                "Cannot delete the main service manager",
            REMOVE_SERVICE_USER_ERROR_CODE_9236:
                "Cannot delete the user as only the current user have admin access for some entities",
            REMOVE_SERVICE_USER_ERROR_CODE_9237:
                "Cannot delete, as the current and deleting user are not in same platform",
            REMOVE_SERVICE_MANAGER_SUCCESS: "Service Manager removed successfully",
            TOAST_ERROR_LINK_CUSTOMER_ERROR_INVALID_SLA:
                "SLA Number is not valid or length should be between 6 and 12 characters",
            TOAST_ERROR_LINK_CUSTOMER_ERROR_INVALID_EXPIRY_DATE:
                "Expiry date is not in valid format or should be greater than current date",
            TOAST_ERROR_LINK_CUSTOMER_ERROR_INVAILD_TOKEN: "Unauthorized access",
            TOAST_ERROR_LINK_CUSTOMER_SYSTEM_DETAIL_NOT_AVAILABLE:
                "System details not found",
            TOAST_ERROR_LINK_CUSTOMER_INVALID_SYSTEM_ID:
                "Please provide valid system Id",
            TOAST_ERROR_LINK_CUSTOMER_INVALID_CUSTOMER_NUMBER:
                "Customer Number is not valid or length should be between 8 and 16 characters",
            TOAST_ERROR_LINK_CUSTOMER_CUSTOMER_DETAIL_NOT_AVAILABLE:
                "Customer details not found",
            TOAST_ERROR_LINK_CUSTOMER_SLA_ALREADY_AVAILABLE:
                "SLA Number already available",
            TOAST_SUCCESS_UPDATE_CUSTOMER_DETAILS: "Customer updated successfully",
            TOAST_ERROR_UPDATE_CUSTOMER_DETAILS: "Update customer detail api failed",
            TOAST_ERROR_UPDATE_PAAS_DETAILS: "Create PAAS api failed",
            TOAST_BUILDING_NAME_ALREADY_EXISTS: "Building name already exists",
            TOAST_MSG_ERROR_CODE_9122:
                "Please provide valid name or length should be less than or equal to 32 characters",
            TOAST_MSG_ERROR_CODE_9069:
                "Address  is not valid or length should be less than or equal to 250 characters",
            TOAST_MSG_ERROR_CODE_9070:
                "Address 2 is not valid or length should be less than or equal to 250 characters",
            TOAST_MSG_ERROR_CODE_9071:
                "Postal Code is not valid or length should be between 4 and 10 characters",
            TOAST_MSG_ERROR_CODE_9072:
                "City is not valid or length should  be less than or equal to 50 characters",
            TOAST_MSG_ERROR_CODE_9043:
                "Email is not valid or length should  be less than or equal to 75 characters",
            TOAST_MSG_ERROR_CODE_9073:
                "Country Code is not valid or length should  be less than or equal to 4 characters",
            TOAST_MSG_ERROR_CODE_9074:
                "Phone number is not valid or length should be between 8 and 10 characters",
            TOAST_MSG_ERROR_CODE_9079:
                "Contact is not valid or length should  be less than or equal to 75 characters",
            TOAST_MSG_ERROR_CODE_9149:
                "Secondary Contact is not valid or length should  be less than or equal to 75 characters",
            TOAST_MSG_ERROR_CODE_9077:
                "Secondary Email is not valid or length should  be less than or equal to 75 characters",
            TOAST_MSG_ERROR_CODE_9075:
                "Secondary Phone number is not valid or length should be between 8 and 10 characters",
            TOAST_MSG_ERROR_CODE_9076:
                "Secondary Country Code is not valid or length should  be less than or equal to 4 characters",
            TOAST_MSG_ERROR_CODE_9078:
                "Description is not valid or length should  be less than or equal to 500 characters",
            TOAST_MSG_ERROR_CODE_9086:
                "Please provide address, postalcode and city Or latitude and longitude coordinates",
            TOAST_MSG_ERROR_CODE_9082: "Please provide valid latitude coordinate",
            TOAST_MSG_ERROR_CODE_9083: "Please provide valid longitude coordinate",
            TOAST_MSG_ERROR_CODE_9068:
                "Country is not valid or length should be less than or equal to 50 characters.",
            TOAST_MSG_ERROR_CODE_9150:
                "Primary first name is not valid or length should be between 1 and 50 characters",
            TOAST_MSG_ERROR_CODE_9151:
                "Primary last name is not valid or length should be between 1 and 50 characters",
            TOAST_MSG_ERROR_CODE_9152:
                "Secondary first name is not valid or length should be between 1 and 50 characters",
            TOAST_MSG_ERROR_CODE_9153:
                "Secondary last name is not valid or length should be between 1 and 50 characters",
            TOAST_MSG_ERROR_CODE_9121:
                "Please provide valid name or length should be less than or equal to 24 characters",
            TOAST_MSG_ERROR_CODE_9100: "Organization name already exists",
            TOAST_MSG_ERROR_CODE_9146:
                "Phone number is invalid or length should be between 8 and 10",
            TOAST_MSG_ERROR_CODE_ORG_9071:
                "Postal Code is not valid or length should be between 4 and 10 characters",
            TOAST_MSG_ERROR_CODE_ORG_9075:
                "Secondary Phone number is not valid or length should be between 1 and 10 characters",
            TOAST_MSG_ERROR_CODE_ORG_9078:
                "Description is not valid or length should  be less than or equal to 255 characters",
            TOAST_MSG_ERROR_CODE_ORG_9147:
                "Secondary phone number is invalid or length should be between 8 and 10",
            ADD_NOTES_ERROR_CODE_9001: "Unauthorized access",
            ADD_NOTES_ERROR_CODE_9009: "Security token must not be null or empty",
            ADD_NOTES_ERROR_CODE_9227: "Please provide valid maintenance id.",
            ADD_NOTES_API_FAILURE: "Add notes api failed",
            NOTE_ADD_SUCCESS: "Note added successfully",
            TOAST_ERROR_GET_SERVICE_PARTNER_INFO: "Get service partner info detail api failed",
            TOAST_ERROR_LUMNS_FAILS: 'Luminary list loading failed',
            TOAST_ERROR_WHITELIST_FAILS: 'Whitelist detail loading failed',
            TOAST_ERROR_DEVICE_WHITELIST_ZONE_FAILS: 'Device whitelist zone loading failed',
            TOAST_ERROR_SAVE_ZONES_FAILS: 'Failed to save zones',

            MANAGE_WHITELIST_ZONE_ERROR_CODE_9280: "Invalid whitelist name. Please provide valid whitelist name",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9001: "Unauthorized access",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9009: "Security token must not be null or empty",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9047: "Please provide valid project id",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9048: "Please provide valid building id.",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9050: "Please provide valid system Id",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9273: "Invalid whitelist id. Please provide valid whitelist id",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9276: "Invalid zone description. Please provide valid zone description",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9274: "Invalid zone id. Please provide valid zone id",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9275: "Invalid zone name. Please provide valid zone name",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9263: "Please provide valid zone",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9279: "Whitelist already exists and no changes from existing data",
            MANAGE_WHITELIST_ZONE_ERROR_CODE_9278: "Zone data already exist for system. Please provide new values to update",
            ZONE_DESCRIPTION_REQUIRED: "Zone description is required",
            ZONE_NAME_REQUIRED: "Please add zone name to save this zone",
            SET_CONFIG_LUM_ERROR_CODE_8200: "Whitelist Id is invalid",
            SET_CONFIG_LUM_ERROR_CODE_9001: "Unauthorized access",
            SET_CONFIG_LUM_ERROR_CODE_9274: "Invalid zone id. Please provide valid zone id",
            SET_CONFIG_LUM_ERROR_CODE_9281: "Invalid test group id. Please provide valid test group id",
            SET_CONFIG_LUM_ERROR_CODE_9008: "Input parameters cannot be null or empty",
            SET_CONFIG_LUM_ERROR_CODE_9292: "Invalid Luminary Name. Please provide valid luminary Name",
            TOAST_ERROR_SAVE_CONFIG_LUMS_FAILS: 'Failed to save luminary configuration',
            SET_IO_CONFIG_ERROR_CODE_9001: "Unauthorized access",
            SET_IO_CONFIG_ERROR_CODE_9274: "Invalid zone id. Please provide valid zone id",
            TOAST_ERROR_SAVE_IO_CONFIG_FAILS: 'Failed to save IO configuration',

        },
        MY_ORGANIZATION_DETAILS: {
            ADDRESS_Line1: "Address Line 1",
            ADMINS: "Admins",
            DELETE_FOREVER: "Delete Forever",
            DESCRIPTION: "Description(Optional)",
            EDIT_BUILDING: "Edit Building",
            EDIT_ORGANIZATION: "Edit Organization",
            NAME_DESCRIPTION: "Name & Description",
            SAVE_ORGANIZATION: "Save Organization",
            TRANSFER_BULDING_ANOTHER_ORGANIZATION:
                "Transfer Buildings to another Organization",
            VIEWER: "Viewers",
        },
        INVITE_USER: {
            ADMIN: "Admin",
            ADVANCE_INVITATION: "Advanced invitation",
            ADVANCE_INVITE: "Advanced...",
            ADVANCE_INVITE_CLOSE:
                "Are you sure you want to exit from Advanced invitation?",
            AS_ADMIN: "As Admin",
            AS_VIEWER: "As Viewer",
            BUILDING_ACCESS: "Building Access",
            ENTER_USER_EMAIL: "Email or User Name",
            GRANT_ACCESS_HEADER: "Grant access to new or existing users.",
            ADVANCE_DES_CONTENT:
                "Grant access to users for specific access to organizations, buildings, and systems.",
            GRANT_ADMIN_ACCESS:
                "Grant full access to everything within the assigned level.",
            GRANT_VIEW_ACCESS:
                "Grant viewing privileges to everything within an assigned level.",
            SEND_INVITE_FAILURE: "Invitation sending failed",
            SEND_INVITE_SUCCESS: "Invitation sent successfully",
            INVITATION_ACCEPTED: "Invitation successfully accepted.",
            INVITATION_DENIED: "Invitation successfully denied.",
            INVITE_AND_ASSIGN: "Invite and Assign",
            INVITE_AS_COLLEGUE: "Invite as colleague",
            INVITE_USER: "Invite User",
            LIMITED: "Limited",
            GRANT_LIMITED_ACCESS:
                "Minimum privileges, this is useful for a user who only needs to monitor one system within a building.",
            NOBUILDING_AVAILABLE: "No Buildings Available",
            NOSYSTEMS_AVAILABLE: "No Systems Available",
            ORGANIZATION_ACCESS: "Organization Access",
            SELECT_ORGANIZATION: "Please select an Organization",
            PRIVILEGES: "Privileges",
            RECEIVED: "Received",
            SEND_INVITE: "Send Invite",
            SENT_BY: "Sent by",
            SYSTEM_ACCESS: "System Access",
            VIEWER: "Viewer",
            ERROR_MESSAGE: "Your request has been failed",
        },
        DISCLAMIER: {
            OVERVIEW: "Alarm Count represents all active alarms",
            TIMELINE: "Alarms displayed represent all alarms during the past 90 days",
        },
        LUMINARY_DETAILS: {
            ALL_ATSD: "All ATSD",
            ALL_CIRCUIT: "All Circuit",
            ALL_STATUSES: "All statuses",
            ATSD: "ATSD #",
            CIRCUIT: "Circuit",
            LUMINAIRE_ADDRESS: "Luminaire Address",
            LUMINAIRE_DESCRIPTION: "Description",
            LUMINAIRE_NAME: "Name",
            MODEL: "Model",
            TYPE: "Type",
            CG_LINE_PLUS_ID: "CG Line+ ID",
            MODEL_NAME: 'Model Name',

            CGLINE_VERSION_CORTEX: 'Version Cortex',
            CGLINE_VERSION_XMEGA: 'Version xMega',
            CGLINE_VERSION_BOOTLOADER: 'Version Bootloader',
            CGLINE_VERSION_SDCARD: 'Version SDCard',
        },
        SEARCH: {
            ALL_BUILDINGS: "All Buildings",
            ALL_GATEWAYS: "All Gateways",
            ALL_ORGANIZATIONS: "All Organizations",
            ALL_STATUSES: "All Statuses",
            ALL_SYSTEMS: "All Systems",
            ALL_TYPES: "All Types",
            ALL_CUSTOMER: "All Customers",
            ALL_SLA: "All SLAs",
            ALL_CITY: "All Cities",
            ALL_ZIPCODE: "All Zip Codes",
            ALL_SERVICE_TYPES: "All Service Types",
            ALL_COMPANY: "All Companies",
            ALL_COUNTRY: "All Countries",
            ALL_PLATFORMS: "All Platforms",
            ALL_PANELS: "All Panels",
            ALL_INPUT_ZONES: "All Input Zones",
            ALL_MODULES: "All Modules",
        },
        NAVIGATION_DRAWER: {
            ALL_RIGHTS_RESERVED: "All Rights Reserved",
            CHANGE_PASSWORD: "Change Password",
            COPYRIGHT: "Copyright",
            HELP_AND_FEEDBACK: "Help and Feedback",
            LEGAL: "Legal",
            LOGOUT: "Logout",
            PROJECT_SETTINGS: "My Organizations",
            REPORTS: "Reports",
            USERS: "Users",
        },
        CUSTOMER_DETAILS: {
            ALL_USERS: "All Users",
            DELETE_SLA: "Are you sure do you want to delete SLA",
            BACK_UP_PHONE: "Backup Phone",
            BUYER_HEADER: "Buyer",
            BUYER: "Buyer",
            CONTACT_TYPE: "Contact Type",
            CONTACT_PERSON_ON_SITE: "ContactPersonOnsite",
            CUSTOMER_HEADER_SUBTITLE: "Customer",
            CUSTOMER_ID: "Customer ID",
            CUSTOMER_NAME: "Customer Name",
            CUSTOMER_DETAILS_HEADER: "Customer Name & Address",
            CUSTOMER_NAME_LABEL: "Customer name or number",
            CUSTOMER_NUMBER: "Customer Number",
            DELETE_CUSTOMER: "Delete Customer",
            LUMINARY_INFO: "Does this contract include luminaire monitoring?",
            EDIT_CUSTOMER_INFO: "Edit Customer Info",
            CREATE_CUSTOMER_HEADER: "Edit Customer Info",
            EDIT_PLATFORM_INFO: "Edit Platform Info",
            EDIT_SLA_DETAILS: "Edit SLA Details",
            EXPIRES: "Expires",
            IMAGES: "Images",
            INCLUDE_LUM_MONITORING: "Include luminaire monitoring",
            SLA_DETAILS_TEXT: "Luminaire monitoring included",
            CALENDAR_HELPER_TEXT: "mm/dd/yyyy",
            MOBILE_NUMBER: "Mobile Number",
            LUMINARY_MONITORING_NO: "No",
            NO_CUSTOMER_FOUND: "No Customer Found",
            NO_SERVICE_MANAGER_FOUND: "No Service Manager Found",
            NO_TECHNICIAN_FOUND: "No Technician Found",
            CUSTOMER_NUMBER_HELPER_TEXT: "Alphabets and numbers Only",
            SLA_NUMBER_HELPER_TEXT: "Alphabets and numbers Only",
            OFFICE_NUMBER: "Office Number",
            IMAGE_REQUIREMENTS: "PNG, JPG (100x100px), 2 MB Max.",
            PHONE_NUMBERS_HEADER: "Primary & Backup Phone Numbers",
            PRIMARY_CONTACT_INFO: "Primary Contact Info",
            PROJECT_LEAD: "ProjectLead",
            REMOVE_IMAGE: "Remove Image",
            SECONDARY_CONTACT_INFO: "Secondary Contact Info",
            FILE_RESOLUTION_ERROR:
                "Selected file does not match our desired resolution",
            FILE_SIZE_ERROR: "Selected file size exceeds maximum allowed file size",
            SERVICE_MANAGER: "Service Manager",
            SLA_CUSTOMER_NUMBER: "SLA Customer Number",
            SLA_DETAILS_HEADER: "SLA Details",
            SLA_EXPIRATION_DATE: "SLA Expiration Date",
            TECH_LEAD_HEADER: "Technical Lead",
            TECHNICAL_PERSON: "TechnicalPerson",
            UPLOAD_AVATAR_LOGO: "Upload Avatar Logo",
            LUMINARY_MONITORING_YES: "Yes",
            SLA_NUMBER: "SLA Number",
            CREATE_CUSTOMER: "Create Customer",
            SLA_MANAGEMENT_HEADER: "SLA Management",
        },
        USER_MANAGEMENT: {
            ALL_USERS: "All Users",
            INVITE_USER: "Invite User",
            YOUR_DETAILS: "Your Details",
        },
        USERDETAILS: {
            DELETE_USER_SUBHEADER: "All your user data will be permanently lost.",
            RESET_PASSWORD_ERROR: "Could not reset your password at this time.",
            DELETE_USER_BUTTON_TEXT: "Delete Account Forever",
            DELETE_USER_FAILURE_MSG: "Failed to delete, Please try after some time",
            DELETE_USER_POP_UP_HEADER: "Permanently delete account “{{email}}”?",
            RESET_PASSWORD_SUCCESS: "Reset password email sent successfully.",
            EDIT_SUCCESS: "User updated successfully",
            DELETE_USER_SUCCESS_MSG: "Your account has been successfully deleted",
        },
        ATPLUS_LOGBOOK_EVENTNAME: {
            MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: "Allowed Login Attempts Exceeded",
            BATTERY_CHARGE_FAILURE: "Battery Charge Failure Detected",
            BATTERY_DURATION_FAILURE: "Battery Duration Failure Detected",
            TLAT_PLUS_BATTERY_FAILURE: "Battery Failure",
            TLAT_PLUS_BATTERY_LOW: "Battery Low",
            COMMUNICATION_FAILURE: "Communication Failure Detected",
            DRY_CONTACT_INPUT: "Dry Contact Input Activated",
            DRY_CONTACT_OUTPUT: "Dry Contact Output Activated",
            MANUAL_DURATION_TEST: "Duration Test Started",
            MANUAL_DURATION_TEST_CANCELED: "Duration Test Stopped",
            FACTORY_RESET: "Factory Reset",
            FAILURE_THRESHOLD_EXCEEDED: "Failure Threshold Exceeded",
            FIRMWARE_UPDATE_FAILURE: "Firmware Update Failed",
            FIRMWARE_UPDATE_SUCCESS: "Firmware Update Successful",
            MANUAL_FUNCTION_TEST: "Function Test Started",
            MODBUS_COMMUNICATION_FAILURE: "Gateway Communication Failure",
            UART_COMMUNICATION_FAILURE: "Internal Failure",
            LAMP_FAILURE: "Lamp Failure Detected",
            LOCAL_MAIN_FAILURE: "Local Mains Failure",
            PASSWORD_CHANGE: "Password Change",
            PASSWORD_RESET: "Password Reset",
            MANUAL_RELIGHT_COMMAND: "Relight Activated",
            MANUAL_REST_COMMAND: "Rest Activated",
            SEARCH_NEW_LAMP_COMPLETED: "Search new lamp completed",
            SEARCH_ALL_LAMP_COMPLETED: "Search all lamp completed",
            MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: "Synchronize test times",
            ACTIVATION: "System Activation Completed",
            SYSTEM_POWER_DOWN: "System Power Down",
            SYSTEM_POWER_UP: "System Power On",
            DATALINE_FAILURE: "TLAT+ Communication Line Failure",
            MANUAL_START_VISIBILITY_PLUS: "Visibility + Started",
            MANUAL_STOP_VISIBILITY_PLUS: "Visibility + Stopped",
        },
        MY_ORGANIZATION: {
            ALPHABET: "Alphabet",
            CITY: "City",
            NUMBER_SYSTEM: "Number of Systems",
        },
        FIRMWARE_UPDATE: {
            FIRMWARE_UPDATE_ALERT_TITILE: "Are you sure you want Exit?",
            CURRENT_VERSION: "Current Version",
            FIRMWARE_ALREADY_UPDATED: "Firmware Already updated",
            FIRMWARE_UPDATE_FAILED_TITLE: "Firmware Update Failed",
            FIRMWARE_PROGRESS_MSG: "Firmware Update in Progress...",
            FIRMWARE_UPDATE_ALERT_SUB_TITILE:
                "Firmware Update is still in progress. Do you want to go to Dashboard?",
            FIRMWARE_UPDATE_FAILED:
                "Firmware Update process has been failed. Please try again.",
            FIRMWARE_VERSION_UPDATED:
                "firmware upgrade has been successfully completed",
            FIRMWARE_ALREADY_UPDATED_TEXT:
                "Firmware version is already updated to latest version",
            FIRMWARE_NOT_AVAILABLE:
                "Firmware version not fetched properly. Please logout from the mobile app and login to try again.",
            LATEST_VERSION: "Latest Version",
            LOST_BLUETOOTH_CONNECTION: "Lost Bluetooth Connection",
            ENTRY_PASSWORD: "Please enter the system password for",
            RELEASED_ON: "Released on",
            SELECT_FIRMWARE_VERSION: "Select a firmware version",
            SELECT_A_VERSION: "Select a Version",
            UPDATE_TO_LATEST: "Update To Latest",
            UPLOAD_FILE: "Upload File",
            FIRMWARE_UPDATE_TITILE:
                "We recommend that you update the firmware to the latest version.",
            FIRMWARE_UPDATEPOPUP_MSG: "You are no longer connected to the",
        },
        ASSETS: {
            ASSETS_DETAILS: "Assets Details",
        },
        SYSTEM_TYPE: {
            ATPLUS: "AT+",
            CGLINE: "CGLine+",
            DGS: "DG-S",
            LPSMART: "LPSmart",
            LPSTAR: "LPStar",
            WIRELESS: "Wireless",
            ZBS: "ZBS",
        },
        DEVICE_TYPE_VALUE: {
            AT: "AT+",
            ATS: "AT-S+",
            CGLINE: "CGLINE",
            DGS: "DG-S",
            LPSMART: "LP-SMART",
            LPSTAR: "LP-STAR",
            WIRELESS: "WIRELESS",
            ZBS: "ZB-S",
        },
        CONTROLLER_TYPE_VALUE: {
            AT: "AT+",
            CGLINE_PLUS: "CGLINE+",
            DGS: "DG-S",
            LP_SMART: "LP-SMART",
            LP_STAR: "LP-STAR",
            WIRELESS: "WIRELESS",
            ZBS: "ZBS",
        },
        ACTIONS: {
            BACK: "Back",
            CANCEL: "Cancel",
            CHANGE_LANGUAGE: "Change Language here!",
            CLICK_BUTTON: "Click the button",
            UPDATE_REDUX: "Click the button to update the redux store value!",
            CONFIRM: "Confirm",
            CONTINUE: "Continue",
            DELETE: "Delete",
            RESEND_VERIFICATION_EMAIL_LABEL: "Didn’t receive email?",
            DISABLE: "Disable",
            DONE: "Done",
            DOWNLOAD_DATA: "Download Data",
            EDIT: "Edit",
            ENABLE: "Enable",
            EXTEND: "Extend",
            FINISH: "Finish",
            GO_HOME: "Go to Home",
            GO_TO_DASHBOARD: "Go To My Dashboard",
            GO_TEST: "Go to Test Page",
            LOG_IN: "Log In",
            LOG_OUT: "Log Out",
            NEXT: "Next",
            OKAY: "Ok",
            QUIT: "Quit",
            REMEMBER: "Remember Me",
            RETRY: "Retry",
            SAVE: "Save",
            SAVE_ADD_ANOTHER: "Save and add another",
            SEND: "Send",
            RESEND: "Send Again",
            RESEND_VERIFICATION_EMAIL: "Send Again",
            SUBMIT: "Submit",
            SUBMITCHANGES: "Submit Changes",
            TRANSFER: "Transfer",
            UPDATE: "Update",
            LINK_SYSTEM: "Link System",
            OR: "OR",
        },
        NETWORK: {
            BAD_REQUEST_MESSAGE: "Bad Request",
            INTERNAL_SERVER_ERROR_MESSAGE: "Internal Server Error",
            NO_DATA_FOUND: "No data found",
            REQUEST_NOT_FOUND_MESSAGE: "Not Found",
            ERROR_INTERNET_CONNECTION:
                "Seems you are out of internet connectivity and try again.",
            SERVICE_UNAVAILABLE: "Service Unavailable",
            ERROR_NO_RESPONSE: "Something went wrong",
            ERROR_MESSAGE_SENDING_REQUEST:
                "Sorry, there was a problem sending your request.",
            ERROR_INVALID_REQUEST: "Sorry, your request is invalid.",
            NETWORK_ALERT_SUBTITILE:
                "The Dashboard is unavailable because you are no longer connected to the internet",
            ERROR_NOT_FOUND: "The resource is not found.",
            ERROR_ALERT_TITLTE: "Unable to connect Dashboard",
            UNAUTHORISED_REQUEST_MESSAGE:
                "Unauthorised - Authorisation has been denied for this request",
            ERROR_RESTRICTED_USER_ACCESS:
                "User does not have the access to the resource.",
        },
        CONNECTION_TYPE_VALUE: {
            BLE: "BLE",
            BLUETOOTH: "bluetooth",
            CELLULAR: "Cellular",
            ETHERNET: "Ethernet",
            MODBUS: "Modbus",
            MQTT: "MQTT",
            RS485: "RS485",
            WIFI: "Wifi",
            WIREPAS: "Wirepas",
        },
        STATUS: {
            STATUS_BLOCK: "Blocked",
            BLOCKED: "Blocked",
            STATUS_EMPTY: "Empty",
            STATUS_ERROR: "Error",
            ERROR: "Error",
            EVENT: "Event",
            DT: "In DT",
            STATUS_DT: "In Test",
            INTEST: "In Test",
            STATUS_OFFLINE: "Offline",
            STATUS_READY: "Ready",
            READY: "Ready",
            TOTAL_LUMINAIRES: "Total Luminaires",
            TOTAL_SYSTEM: "Total Systems",
            STATUS_WARNING: "Warning",
            WARNING: "Warning",
            STATUS_FAILURE: "In Failure",
            EMERGENCY: "Emergency",
            FAILURE: "Failure",
        },
        UNSUPPORTED_BROWSER: {
            NOT_SUPPORTED: "Browser not supported",
            INCOMPATIBLE_BROWSER:
                "This web application is incompatible with your current browser.",
            RECOMMENDED_BROWSER:
                "We recommended upgarding to the latest version of Microsoft Edge, Safari, Firefox, or Chrome to use this tool.",
        },
        ENTITY_TYPE: {
            BUILDING: "Building",
            DEVICE: "Device",
            DEVICE_TYPE: "Device Type",
            GATEWAY: "Gateway",
            LUMINARY: "Luminary",
            MASTER_ROLE: "Master Role",
            ORGANIZATION: "Organization",
            ORGANIZATION_STATISTIC_DETAIL: "Organization Statistical Detail",
            PLATFORM: "Platform",
            SYSTEM: "System",
            USER: "User",
        },
        LOGSOURSE_DEVICE_TYPE: {
            BUILDING: "Building",
            DEVICE: "Device",
            DEVICETYPE: "DeviceType",
            GATEWAY: "Gateway",
            LUMINARY: "Luminary",
            MASTERROLE: "MasterRole",
            ORGANIZATION: "Organization",
            ORGANIZATIONSTATISTICALDETAIL: "OrganizationStatisticalDetail",
            SYSTEM: "System",
            USER: "User",
        },
        TECHNICIAN_DETAILS: {
            BUILD_ADMIN: "Building Admin",
            BUILD_VIEWER: "Building Viewer",
            CUST_VIEWER: "Customer Viewer",
            INDIVIDUAL_DETAILS: "Individual Details",
            LIMT_ACCESS: "Limited Access",
            ORG_ADMIN: "Organization Admin",
            ORG_VIEWER: "Organization Viewer",
            PASS_SERVICE_MANAGER: "Pass Service Manager",
            PROJ_OWNER: "Project Owner",
            SERVICE_MANAGER: "Service Manager",
            SYSTM_ADMIN: "System Admin",
            SYSTM_VIEWER: "System Viewer",
            TECHNICIAN: "Technician",
            USER_DETAILS: "User Details",
            COMPANY_DETAILS: "Company Details",
            COMPANY: "Company",
        },
        TRANSFER_BUILDING_TO_ORGANIZATION: {
            TRANSFER_SUCCESS: "Building transferred successfully to other organization",
            CONFIRM_PASSWORD: "Confirm Password",
            INSTRUCTIONS:
                "Permanently transfer all {{buildingCount}} buildings including all the {{systemCount}} gateways and {{gatewayCount}} systems.",
            ORG_SELECT: "Please select valid organization",
            INSTRUCTION_TWO:
                "Please type your Organization Admin account password to confirm the action",
            TRANSFER: "Transfer",
            HEADER_TITLE:
                "Transfer Building to Another Organization \n \n Organization",
            DROPDOWN_LABEL: "Transfer To...",
        },
        CHANGE_PASSWORD_SCREEN: {
            CHANGE_PASSWORD: "Change Password",
            CONFIRM_PASSWORD: "Confirm Password",
            NEW_PASSWORD: "New Password",
        },
        MESSAGES: {
            CONGRATS: "Congratulations!",
            CONTACT: "Contact an Eaton Support Representative",
            EMAIL_SENT: "Email Sent",
            ERROR: "Error!",
            FAILURE: "Failure",
            LOADING: "Loading...",
            EMAIL_ENTRY_ERROR: "Please enter a valid email",
            SUCCESS: "Success",
            WELCOME: "Welcome!",
            LOGIN_MESSAGE: "You are 'logged' in",
        },
        LANDING_SCREEN: {
            CONNECT_NOW: "Connect Now",
            CONNECT_TO_SYSTEM: "Connect To Systems",
            CONTINUE_TO_DASHBOARD: "Continue to Dashboard",
            DASHBOARD_UNAVAILABLE: "Dashboard Unavailable",
            NO_INTERNET_CONNECTION: "No Internet Connection",
            VIEW_DASHBOARD: "View Dashboard",
            IN_PROGRESS: "Work in Progress...",
        },
        USERS: {
            CREATE_NEW_CUSTOMER: "Create New Customer",
            EDIT_PLATFORM_HEADER: "Edit Platform",
            EDIT_PLATFORM_SUCCESS_200: "Platform Updated Successfully",
            LOADER_HELPER_TEXT: "Please wait",
            LOCATION: "Location",
            SLA_MANDATORY_HEADER: "SLA",
            ADD_USER: "+ Add User",
            COUNTRY: "Country",
            MANAGE_PLATFORM_ERROR_CODE_3047:
                "Main Service Manager is not registered on BSMS. Not able to create platform",
            ADD_TECHNICIAN_TITLE: "Add A Technician",
            STEP1: "Step 1",
            STEP1_TEXT:
                "Choose or add a user and assign them to specific organizations",
            STEP2: "Step 2",
            ERROR_NO_TECHNICIAN_FOUND: "No technician found",
            PAAS: "PAAS",
            SERVICE_PARTNERS: "Service Partners",
            ADD_SERVICE_MANAGER_SUCCESS_200: "Service Manager added successfully",
            ERROR_NO_SERVICE_MANAGER_FOUND: "No service manager found",
            ERROR_NO_SERVICE_PARTNER_FOUND: "No service partner found",
            ADD_SERVICE_MANAGER_ERROR_CODE_9043:
                "Email is not valid or length should be less than or equal to 75 characters",
            ADD_SERVICE_MANAGER_ERROR_CODE_3051:
                "The user with the specified email address is not registered in the system",
            ADD_SERVICE_MANAGER_ERROR_CODE_3050: "Please provide valid platform id",
            ADD_SERVICE_MANAGER_ERROR_CODE_9000: "Unauthorized feature access",
            ADD_SERVICE_MANAGER_ERROR_CODE_3052:
                "The user with the specified email address is already registered in the system",
            ADD_PAAS_MANAGER_ERROR_CODE_9162:
                "SLA Number is not valid or length should be between 6 and 12 characters.",
            ADD_PAAS_MANAGER_ERROR_CODE_9169:
                "Expiry date is not in valid format or should be greater than current date.",
            ADD_PAAS_MANAGER_ERROR_CODE_9163:
                "Please provide valid name or length should be less than or equal to 24 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9068:
                "Country is not valid or length should be less than or equal to 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9069:
                "Address is not valid or length should be less than or equal to 250 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9070:
                "Address2 is not valid or length should be less than or equal to 250 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9071:
                "Postal code is not valid or length should be between 4 and 10 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9072:
                "City is not valid or length should  be less than or equal to 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9164:
                "Company comment is not valid or length should be less than or equal to 255 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9043:
                "Email is not valid or length should  be less than or equal to 75 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9073:
                "Country code is not valid or length should  be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9074:
                "Phone number is not valid or length should be between 8 and 10 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9167: "Please provide valid contact type.",
            ADD_PAAS_MANAGER_ERROR_CODE_9077:
                "Secondary email is not valid or length should  be less than or equal to 75 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9147:
                "Secondary phone number is invalid or length should be between 8 and 10.",
            ADD_PAAS_MANAGER_ERROR_CODE_9076:
                "Secondary country code is not valid or length should  be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9001: "Unauthorized access",
            ADD_PAAS_MANAGER_ERROR_CODE_9170: "Company name already available.",
            ADD_PAAS_MANAGER_ERROR_CODE_9171: "SLA Number already available.",
            ADD_PAAS_MANAGER_ERROR_CODE_9150:
                "Primary first name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9151:
                "Primary last name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9152:
                "Secondary first name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9153:
                "Secondary last name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9165:
                "Primary contact comment is not valid or length should be less than or equal to 255 characters.",
            ADD_PAAS_MANAGER_ERROR_CODE_9166:
                "Secondary contact comment is not valid or length should be less than or equal to 255 characters.",
            ADD_PAAS_MANAGER_ERROR_CODE_9004: "System details not found.",
            ADD_PAAS_MANAGER_ERROR_CODE_9050: "Please provide valid system Id.",
            ADD_PAAS_MANAGER_ERROR_CODE_9172:
                "Customer Number is not valid or length should be between 8 and 16 characters.",
            ADD_PAAS_MANAGER_ERROR_CODE_9173:
                "Primary phone2 is invalid or length should be between 8 and 10.",
            ADD_PAAS_MANAGER_ERROR_CODE_9174:
                "Secondary phone2 number is invalid or length should be between 8 and 10.",
            ADD_PAAS_MANAGER_ERROR_CODE_9175:
                "Primary countrycode2 is not valid or length should be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9176:
                "Secondary countrycode2 is not valid or length should be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9040: "Company country code is not valid",
            ADD_PAAS_MANAGER_ERROR_CODE_9023:
                "Company phone number is not valid or length shoud be between 8 and 10",
            ADD_PAAS_MANAGER_ERROR_CODE_9193:
                "Service manager email is not valid or length should be less than or equal to 75 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9194:
                "Service manager first name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9195:
                "Service manager last name is not valid or length should be between 1 and 50 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9196:
                "Service Manger primary countrycode is not valid or length should be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9197:
                "Service manager primary phone number is not valid or length shoud be between 8 and 10",
            ADD_PAAS_MANAGER_ERROR_CODE_9198:
                "Service Manager secondary country code is not valid or length should be less than or equal to 4 characters",
            ADD_PAAS_MANAGER_ERROR_CODE_9199:
                "Service manager secondary phone number is not valid or length shoud be between 8 and 10",
            ADD_PAAS_MANAGER_ERROR_CODE_9201:
                "Service Manger comment is not valid or length should be less than or equal to 255 characters.",
            ADD_PAAS_MANAGER_ERROR_CODE_9000: "Unauthorized feature access",
            MANAGE_PLATFORM_LIST_FAILED: "Failed to load platform list",
            ADD_SERVICE_MANAGER_DIALOG_HEADER: "Add A Service Manager",
            ADD_SLA: "+ Add SLA",
            ADD_CUSTOMER: "+ Add Customer",
            ADD_PLATFORM: "+ Add Platform",
            ADD_PLATFORM_DIALOG_HEADER: "Add A Platform",
            SHOW_FAVORITE_CUSTOMERS: "Show Starred Customers Only",
            SHOW_FAVORITE_TECHNICIANS: "Show Starred Technicians Only",
            SHOW_FAVORITE_SERVICE_MANAGERS: "Show Starred Service Managers Only",
            SHOW_FAVORITE_SERVICE_PARTNER: "Show Starred Service Partners Only",
            SHOW_FAVORITE_PLATFORMS: "Show Starred Platforms Only",
            ERROR_NO_PLATFORM_FOUND: "No platform found",
            ERROR_NO_CUSTOMER_FOUND: "No customer found",
            ADD_TO_PLATFORM_LABEL: "Add to Platform... *",
            LATFORM_NAME_HEADER: "Platform Name",
            PLATFORM_HELPER_TEXT: "Ex., French CSU Team",
            SERVICE_PARTNER_HEADER: "Service Partner",
            CUSTOMER_NAME_SUBHEADER: "What is the name of this service partner?",
            SERVICE_MANAGER_LABEL: "Service Manager",
            REGION_SELECT_HEADER_SERVICE_MANAGER:
                "Which PAAS will this person be assigned to?",
            PLATFORM_NAME_SUBHEADER:
                "What is the name for the region/area for this platform?",
            COUNTRY_SUBHEADER: "What is the country for this platform?",
            MAIN_SERVICE_MANAGER_HEADER: "Main Service Manager",
            MAIN_SERVICE_MANAGER_SUBHEADER:
                "Who is overseeing the customers & technicians in this platform?",
            SERVICE_MANAGER_DIALOG_HEADER:
                " Choose or add a user and assign them to a region and organizations.",
            PLATFORM_NAME_HEADER: "Platform Name",
            SERVICE_PARTNER_LABEL: "Service Partner Name ",
            SLA_OPTIONAL_HEADER: "SLA (Optional)",
            INTERNAL_EATON_SERVICE_TEAM_CHECKBOX_TEXT:
                "This is an internal Eaton service team",
            DEFINE_ACCESS_LEVEL: "Define access levels for",
            DEFINE_ACCESS_LEVEL_NEXT: "organizations, buildings and systems.",
            ADD_TO_PAAS: "Add to PAAS... *",
            CUSTOMER_NAME_HEADER: "Customer Name",
            MANAGE_PLATFORM_ERROR_CODE_3048:
                "Please provide valid name or length should be less than or equal to 32 characters",
            MANAGE_PLATFORM_ERROR_CODE_3049: "Platform name already exists",
            MANAGE_PLATFORM_ERROR_CODE_3045:
                "Platform country name is not valid or length should be less than or equal to 50 characters",
            MANAGE_PLATFORM_ERROR_CODE_3046: "Please provide valid customer id",
            MANAGE_PLATFORM_ERROR_CODE_900: "Unauthorized feature access",
            MANAGE_PLATFORM_ERROR_CODE_3061: "Service Manager is already mapped to another platform",
            MANAGE_PLATFORM_SUCCESS_200: "Platform Created Successfully",
            SECONDARY_CONTACT_INFO_OPTIONAL: "Secondary Contact Info (Optional)",
            MANAGE_PLATFORM_ERROR_CODE_9241: "Given User is already a Service User",
            MANAGE_PLATFORM_ERROR_CODE_9159: "Invite and invited by user should not be same.",
        },
        LABELS: {
            CSV: "CSV",
            EMAIL: "Email Address",
            EXCEL: "Excel File",
            FORGOT_PASSWORD: "Forgot your password?",
            GROUP_BY: "Group by:",
            ITEMS_PER_PAGE: "Items per page",
            LOGGING_IN: "Logging in",
            NEED_ACCOUNT: "Need an account?",
            NEW_PASSWORD: "New Password",
            PASSWORD: "Password",
            PDF: "PDF",
            SHOW: "Show:",
            SIGN_UP: "Sign Up",
            TIME_RANGE: "Time Range:",
            TO_BE_IMPLEMENTED: "To be implemented",
            VIEW_ALL_EVENTS: "View All {{count}} Events",
            VIEW_BUILDING_DETAILS: "View Building Details",
            SIGN_IN_WITH_OKTA: "Sign In With Okta",
            SIGN_IN: "Sign In",
            FILTER_BY: "Filter By",
            VIEW_DETAILS: "View Details",
            REQUESTED: "Requested",
            SCHEDULED: "Scheduled",
            CUSTOM_LOGBOOK_RANGE: "Custom Logbook Range",
            START_DATE: "Start Date",
            END_DATE: "End Date",
        },
        TIMELINE_EXPORT: {
            DOWNLOAD_TITLE: "Download Timeline Data",
            DOWNLOAD_SUBTITLE_SITE:
                "Select date range of alarm history you would like to export.",
            DOWNLOAD_SUBTITLE_TIMELINE:
                "Select the location and date range of alarm history you would like to export.",
        },
        AUTO_LOGOUT_ENABLED: {
            AUTO_LOGOUT_ENABLED: "Enabled(Recommended)",
        },
        LEAGAL: {
            END_USER_AGREEMENT: "End User Agreement",
            LICENCE_AGREEMENT: "End User Licence Agreement",
            LEAGAL: "Legal",
            MANUALS: "MANUALS",
            OPEN_SOURCE: "Open Source Licenses",
            INSTRUCTION_EATON_BSMS_GATEWAY:
                "Operating Instructions for Eaton BSMS Gateway",
            QUICK_START_GUIDE: "Quick Start Guide",
            REMOTE_MONITORING_GUIDE: "Remote Monitoring Guide",
            TERMS_CONDITIONS: "Terms and Conditions",
        },
        LEGAL: {
            EULA: "End User License Agreement",
            OPENSOURCELICENSES: "Open Source Licenses",
            TERMSANDCONDITIONS: "Terms and Conditions",
            REACT_NATIVE: "React Native",
            EULA_WIRELESS: "EULA - Eaton Wireless Controller",
            EULA_AT_PLUS_CONTROLLER: "EULA - Eaton AT+ Controller",
            OSS: "Open source licensing - Eaton Wireless Controller",
            OPEN_SOURCE_BSM: "Open source licensing - Building Safety Manager",
            OPEN_SOURCE_BSM_CLOUD: "Open source licensing - Building Safety Manager (Cloud)",
        },
        EVENT_TIMELINE: {
            ERROR_LOADING_MORE_EVENTS: "Error Loading More Events",
            LOAD_MORE_EVENTS: "Load {{count}} More Events",
        },
        ATPLUS_EXPORT_CONFIGRATION_FAIL: "Export Configuration process failed",
        ASSETS_SCREEN: {
            FAVORITE_LIMIT_REACHED: "Favorite limit reached",
            NOBUILDINGFOUND: "No Buildings Found",
            NOGATEWAYFOUND: "No Gateways Found",
            NOORGANIZATIONFOUND: "No Organization Found",
            NOREPORTFOUND: "No Reports Found",
            NOSYSTEMS: "No Systems Found",
            OTHERS: "OTHERS",
            SHOW_ONLY_STARRED_BUILDING: "Show Starred Buildings Only",
            STARRED: "STARRED",
            MARK_AS_FAV_API_SUCCESS: "Added to favorite successfully",
            REMOVE_MARK_AS_FAV_API_SUCCESS: "Removed from favorite successfully",
            MARK_AS_FAV_API_FAILURE_MESSAGE:
                "Please remove some of your existing favorites before adding new ones as maximum limit is 10",
            SHOW_ONLY_STARRED_SYSTEM: "Show Starred Systems Only",
            SHOW_ONLY_STARRED_GATEWAY: "Show Starred Gateways Only",
            SHOW_ONLY_STARRED_CUSTOMER: "Show Starred Customer Only",
            SHOW_ONLY_STARRED_SLA: "Show Starred SLA Only",
        },
        ADDLOCATION: {
            ASTERIKSINFO:
                "Fields marked with an asterisk(*) are required fields {{entity}}.",
            ADDLOCATIONINFORMATION: "Location Profile Information",
        },
        ATPLUS_FILE_ALREADY_EXIST_MSG:
            "File with same name already exists, Please change the file name",
        HEADER: {
            FORGOT_PASSWORD: "Forgot Password",
        },
        LOGIN: {
            INVALID_CREDENTIALS:
                "Your username/password combination is not recognized.",
            GENERIC_ERROR: "Your request could not be processed at this time.",
            UNAUTHORIZED_ACCESS: "Unauthorized Access",
            UNAUTHORIZED_ACCESS_MESSAGE:
                "You are not authorized to access this application. Please sign up",
        },
        TABS: {
            LIST_VIEW: "List View",
            SUMMARY_VIEW: "Summary View",
        },
        NAVIGATION_TABS: {
            LOGBOOK: "LOGBOOK",
            STATUS: "STATUS",
        },
        HELPANDFEEDBACK: {
            MANUALS: "Manuals",
            TITLE: "Operating Instructions for Eaton BSMS Gateway",
        },
        MERGE_ASSETS: {
            MERGE_DELETE: "Merge and Delete",
            MERGE_ASSETS_TITLE: "Merge assets to another building",
            SUCCESS: "Merged building assets  Successfully",
            ACTION: "Please type your account password to confirm the action.",
            HEADER:
                "Transfer all {{gatewayCount}} gateways and {{systemCount}} systems under it, to another building and permanently delete the current one.",
            TRANSFER_TO: "Transfer To...",
        },
        OPERATING_SYSTEM_THEME: {
            OPERATING_SYSTEM_THEME: "Operating System Theme",
        },
        EULA: {
            OTHER_LANGUAGE: "Other language EULA",
        },
        LOCATIONS: {
            SITES: "Sites",
        },
        RESPONSE: {
            USER_REGISTERED: "User can be registered",
        },
        PASSWORD_RESET: {
            SUCCESS_MESSAGE: "Your password was successfully reset.",
            FAILURE_MESSAGE:
                "Your password was unable to be reset. Please try again later.",
        },
        DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE:
            "Tap or drag over the fixtures to assign them to this trigger.",
        LICENCE: {
            LICENCE_AGREEMENT: "Licence Agreement",
            EULA_WIRELESS_CONTROLLER: "EULA - Eaton Wireless Controller",
            OSS_WIRELESS_CONTROLLER: "Open source licensing - Eaton Wireless Controller",
            EULA_WIRELESS: "EULA - Wireless Controller",
            OSS: "Open source licensing - Wireless Controller",
            OPEN_SOURCE: "Open Source Licenses",
            REACT_NATIVE_LICENCE: {
                MIT_LICENSE: "MIT License",
                COPYRIGHT_TEXT: "Copyright (c) Facebook, Inc. and its affiliates.",
                MIT_LICENSE_TEXT:
                    "Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the 'Software'), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:",
                MIT_LICENSE_TEXT_ONE:
                    "The above copyright notice and this permission notice shall be included in all copies or substantial porttions of the Software.",
                MIT_LICENSE_TEXT_TWO:
                    "THE SOFTWARE IS PROVIDED AS IS, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.",
            },
        },
        WIRELESS_GATEWAY: {
            WIRELESS_SEARCHLUMINAIRE_HEADLINE:
                "Search for All Luminaires will create a new configuration by doing the following:",
            WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE:
                "Search for all installed and addressed luminaires",
            WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO:
                "Starting the search will delete any activated, defective luminaires from your configuration",
            WIRELESS_SEARCH_ALL_LUMINARIES_WARNING:
                "If you only need to add luminaires, please use the Search for New Luminaires option.",
            WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE:
                "This action cannot be undone.",
            WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT:
                "Starting the search will delete any activated luminaires with a defect from your configuration",
            WIRELESS_RETRY_SEARCH: "Retry search",
            WIRELESS_CONFIGURE_LUMINARIES: "Configure Luminaires",
        },
        CONFIG_IO: {
            REST_ORDER: 'Rest Order',
            SWITCH_MAINTAINED_MODE_OFF_FOR: 'Switch maintained mode OFF for',
            ACTIVATE_IA_MODE_FOR: 'Activate IA mode for',
            START_FUNCTIONAL_TEST: 'Start functional test',
            START_FUNCTIONAL_TEST_OR_DURATION_TEST: 'Stop functional / duration test',
            EXTERNAL_FAILURE: 'External failure',
            INPUT_1_FUNCTION: 'Input 1 Function',
            S1S2_INPUT_NAME_ERROR: 'Please provide valid S1S2 name',
            S1S2_DESCRIPTION_ERROR: 'Please provide valid S1S2 description',
        },
        SELECT_STAGE_GROUP: "Select Stage Group",
        STAGE_GROUP: "Stage Group",
        NOTIFICATION_KEYS: {
            NOTIFICATION_ALARM_BODY:
                "An {{logType}} has occurred with the following system",
            NOTIFICATION_HEALTH_REPORT_TITLE: "New Report Available - {{org}}",
            NOTIFICATION_HEALTH_REPORT_BODY:
                "A new monthly report for {{building}} is available to view",
        },
        SERVICEPARNTERINFO: {
            SERVICE_INFO_HEADER: "Service Info",
            SERVICE_INFO_DETAILS_NOT_AVAILABLE: "Service Information Not Available",
        },
        DRY_CONTACT: {
            TITLE: "Dry Contact I/O Status",
            DRY_CONTACT_DETAILS: "Dry Contact Details",
            DRY_CONTACT_OUTPUT: "Dry Contact Output",
            DRY_CONTACT_INPUT: "Dry Contact Input",
            DRY_CONTACT_SETTINGS_READ_ONLY: "Dry Contact Settings (read only)",
            DRY_CONTACT_SETTINGS_DESCRIPTION:
                "Information is only configurable on the system or via the mobile application with a Bluetooth connection.",
            DEFAULT_SETTINGS: "Default Settings",
            NORMALLY_OPEN: "Normally Open",
            NORMALLY_CLOSED: "Normally Closed",
            INPUT_1: "Input 1",
            OUTPUT_1: "Output 1",
            INPUT_2: "Input 2",
            OUTPUT_2: "Output 2",
            S1_S2: "S1/S2",
            BLOCK_THE_SYSTEM: "Block the System",
            ACTIVATE_IA: "Activate IA",
            IOSTATUS: {
                OPEN: "Open",
                CLOSED: "Closed",
                NOT_CONFIGURED: "Not Configured",
                CONFIGURED: "Configured",
                ENABLED: "Enabled",
                DISABLED: "Disabled",
                REST_ORDER: 'Rest Order',
                MAINTAINED_MODE_OFFLINE1: 'Maintained Mode OFFLine 1',
                MAINTAINED_MODE_OFFLINE2: 'Maintained Mode OFFLine 2',
                MAINTAINED_MODE_OFFLINE3: 'Maintained Mode OFFLine 3',
                MAINTAINED_MODE_OFFLINE4: 'Maintained Mode OFFLine 4',
                STOP_FT_DT: 'Stop FT DT',
                ACTIVATE_IA_MODELINE1: 'Activate IA ModeLine 1',
                ACTIVATE_IA_MODELINE2: 'Activate IA ModeLine 2',
                ACTIVATE_IA_MODELINE3: 'Activate IA ModeLine 3',
                ACTIVATE_IA_MODELINE4: 'Activate IA ModeLine 4',
                ONE_LUMINAIRE_FAILURE: 'One Luminaire Failure',
                THREE_CONSECUTIVE_LUMINAIRE_FAILURE: 'Three Consecutive Luminaire Failure',
                CHARGING_FAILURE: 'Charging Failure',
                FAILURE_FT_DT: 'Failure FT DT',
                STOP_FTDT: 'Stop FT/DT',
                LUMINAIRE_ALERT_THRESHOLD: 'Luminaire Alert Threshold',
                START_FUNCTIONAL_TEST: 'Start Functional Test',
                EXTERNAL_FAILURE: 'External Failure',
                FUNCTIONAL_TEST: 'Functional Test',
            },
        },
        LINEZONE_STATUS: {
            TOTAL_FAILED: "Total Failed",
            BATTERY_FAILURE: "Battery Failure",
            LAMP_FAILURE: "Lamp Failure",
            CHARGE_FAILURE: "Charge Failure",
            FT_FAILURE: "FT Failure",
            DT_FAILURE: "DT Failure",
            READY: "Ready",
            COMMUNICATION_FAILURE: "Communication Failure",
            BLOCKED: "Blocked",
            CIRCUIT_FAILURE: "Hardware Failure",
        },
        LINE_ZONE: {
            LINE: "Line",
            ZONE: "Zone",
        },
    },
};
export default resources;
